/*! For license information please see application.js.LICENSE.txt */
(() => {
    "use strict";
    var t = {};
    function e(t) {
        return (
            (e =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            e(t)
        );
    }
    function n(t, e) {
        Object.keys(e).forEach(function (n) {
            t.style[n] = e[n];
        });
    }
    function r(t, e) {
        var n,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
        return (n = r ? document.createElementNS(r, e) : document.createElement(e || "div")), t.parentNode.insertBefore(n, t), n.appendChild(t), n;
    }
    function o(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500;
        (t.style.transitionProperty = "height, margin, padding"),
            (t.style.transitionDuration = e + "ms"),
            (t.style.boxSizing = "border-box"),
            (t.style.height = t.offsetHeight + "px"),
            t.offsetHeight,
            (t.style.overflow = "hidden"),
            (t.style.height = 0),
            (t.style.paddingTop = 0),
            (t.style.paddingBottom = 0),
            (t.style.marginTop = 0),
            (t.style.marginBottom = 0),
            window.setTimeout(function () {
                (t.style.display = "none"),
                    t.style.removeProperty("height"),
                    t.style.removeProperty("padding-top"),
                    t.style.removeProperty("padding-bottom"),
                    t.style.removeProperty("margin-top"),
                    t.style.removeProperty("margin-bottom"),
                    t.style.removeProperty("overflow"),
                    t.style.removeProperty("transition-duration"),
                    t.style.removeProperty("transition-property");
            }, e);
    }
    function i() {
        return "_".concat(Math.random().toString(36).substr(2, 9));
    }
    function a(t) {
        return null !== t.offsetParent;
    }
    function s(t) {
        var e,
            n = this,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 300;
        return function () {
            for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++) i[a] = arguments[a];
            clearTimeout(e),
                (e = setTimeout(function () {
                    t.apply(n, i);
                }, r));
        };
    }
    function c(t) {
        return (
            (c =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            c(t)
        );
    }
    function u(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
        return r;
    }
    function l(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== c(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== c(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === c(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function f(t, e) {
        if (e && ("object" === c(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function p(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (p = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return d(t, arguments, y(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), v(n, t);
            }),
            p(t)
        );
    }
    function d(t, e, n) {
        return (
            (d = h()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && v(o, n.prototype), o;
                  }),
            d.apply(null, arguments)
        );
    }
    function h() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function v(t, e) {
        return (
            (v = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            v(t, e)
        );
    }
    function y(t) {
        return (
            (y = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            y(t)
        );
    }
    t.g = (function () {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (t) {
            if ("object" == typeof window) return window;
        }
    })();
    var m = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && v(t, e);
        })(p, t);
        var e,
            o,
            a,
            s,
            c =
                ((e = p),
                (o = h()),
                function () {
                    var t,
                        n = y(e);
                    if (o) {
                        var r = y(this).constructor;
                        t = Reflect.construct(n, arguments, r);
                    } else t = n.apply(this, arguments);
                    return f(this, t);
                });
        function p() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, p),
                ((t = c.call(this)).loaded = !1),
                t
            );
        }
        return (
            (a = p),
            (s = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        (this.loaded = !0), this._handleScrollAnimations();
                        var e,
                            o = !0;
                        if (
                            ((o = 2 == this.children.length) &&
                                (o =
                                    !this.children.length ||
                                    2 ==
                                        ((e = this.children),
                                        (function (t) {
                                            if (Array.isArray(t)) return u(t);
                                        })(e) ||
                                            (function (t) {
                                                if (("undefined" != typeof Symbol && null != t[Symbol.iterator]) || null != t["@@iterator"]) return Array.from(t);
                                            })(e) ||
                                            (function (t, e) {
                                                if (t) {
                                                    if ("string" == typeof t) return u(t, e);
                                                    var n = Object.prototype.toString.call(t).slice(8, -1);
                                                    return (
                                                        "Object" === n && t.constructor && (n = t.constructor.name),
                                                        "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? u(t, e) : void 0
                                                    );
                                                }
                                            })(e) ||
                                            (function () {
                                                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                            })()).filter(function (t) {
                                            return "PICTURE" == t.tagName || "IMG" == t.tagName;
                                        }).length),
                            !o)
                        )
                            return console.error("image-compare must have 2 images as children"), this.remove(), !1;
                        var a = this.children[0],
                            s = r(a);
                        s.classList.add("compare-container");
                        var c = this.querySelectorAll("picture");
                        c &&
                            c.forEach(function (t) {
                                return n(t, { display: "inline-flex", height: "100%" });
                            }),
                            n(this, { display: "inline-flex", position: "relative", "user-select": "none" }),
                            n(s, { top: 0, left: 0, width: "50%", height: "100%", position: "absolute", overflow: "hidden", "will-change": "width" }),
                            n("PICTURE" == a.tagName ? a.firstElementChild : a, { height: "100%", width: "auto", "max-width": "none" });
                        var l = document.querySelectorAll("image-compare img");
                        l &&
                            l.forEach(function (t) {
                                t.ondragstart = function () {
                                    return !1;
                                };
                            });
                        var f = document.createElement("div");
                        f.classList.add("image-compare--handle");
                        var p = document.createElement("button");
                        p.addEventListener("keydown", function (t) {
                            "ArrowDown" == t.key || "ArrowLeft" == t.key
                                ? ((v.value = parseInt(v.value) - 1), v.dispatchEvent(new Event("change")))
                                : ("ArrowRight" != t.key && "ArrowUp" != t.key) || ((v.value = parseInt(v.value) + 1), v.dispatchEvent(new Event("change")));
                        }),
                            p.setAttribute("aria-label", "Compare images by moving this button left or right"),
                            f.append(p),
                            this.append(f),
                            n(f, { top: "50%", left: "50%", transform: "translate(-50%, -50%)", position: "absolute", cursor: "grab" });
                        var d = document.createElement("div"),
                            h = document.createElement("label"),
                            v = document.createElement("input");
                        v.setAttribute("type", "range"),
                            v.setAttribute("min", 0),
                            v.setAttribute("max", 100),
                            (v.value = 50),
                            (v.id = "image-compare-" + i()),
                            (h.innerText = "Compare Images"),
                            h.setAttribute("for", v.id),
                            d.append(h),
                            d.append(v),
                            this.append(d),
                            v.addEventListener("change", function (t) {
                                n(f, { left: v.value + "%" }), n(s, { width: v.value + "%" });
                            }),
                            n(d, { position: "absolute", left: "-9999px", width: "1px", height: "1px", overflow: "hidden" });
                        var y = !1;
                        var parentContainer = f.parentElement;
                        parentContainer.addEventListener('mouseenter', function(e) {
                            var compareContainer = parentContainer.querySelector(".compare-container");

                            let addClass = (element) => {
                                element.classList.add("stop-animation");
                            };
                            let pauseOnCursorPlacement = (element, property, measurement, e) => {
                            let boundingContainer = element.closest('.before-after--image-compare-container');
                            let boundingRect = boundingContainer.getBoundingClientRect();
                            let x = (e.clientX - boundingRect.left) / boundingRect.width * 100;

                            // Ensure the percentage does not exceed 100%
                            x = Math.min(x, 100);

                            element.style[property] = x + measurement; 
                        }
                            addClass(f);
                            addClass(compareContainer)
                            pauseOnCursorPlacement(f, 'left', '%', e);
                            pauseOnCursorPlacement(compareContainer, 'width', '%', e);
                        });
                        ["mousedown", "touchstart"].forEach(function (t) {
                            f.addEventListener(
                                t,
                                function (t) {
                                    n(f, { "pointer-events": "none" }), (y = !0);
                                },
                                { passive: !0 }
                            );
                        }),
                            ["mouseup", "touchend"].forEach(function (t) {
                                window.addEventListener(
                                    t,
                                    function (t) {
                                        (y = !1), n(f, { "pointer-events": "" });
                                    },
                                    { passive: !0 }
                                );
                            }),
                            ["mousemove", "touchmove"].forEach(function (e) {
                                t.addEventListener(
                                    e,
                                    function (e) {
                                        if (y) {
                                            var r = t._getRelativeCursorPosition(e);
                                            n(f, { left: r }), n(s, { width: r }), (v.value = r.replace("%", ""));
                                        }
                                    },
                                    { passive: !0 }
                                );
                            }),
                            [this.getAttribute("label-1"), this.getAttribute("label-2")].forEach(function (e, r) {
                                if (e) {
                                    var o = document.createElement("div");
                                    (o.innerText = e), o.classList.add("image-compare--label"), t.append(o), n(o, { position: "absolute", left: 0 == r ? 0 : "", right: 1 == r ? 0 : "" });
                                }
                            });
                    },
                },
                {
                    key: "_getRelativeCursorPosition",
                    value: function (t) {
                        var e = 0;
                        if (t.touches && t.touches.length) e = (t.touches[0].clientX / t.target.parentNode.offsetWidth) * 100;
                        else {
                            var n = t.target.getBoundingClientRect();
                            e = ((t.clientX - n.left) / t.target.offsetWidth) * 100;
                        }
                        return e < 0 ? (e = 0) : e > 100 && (e = 100), e + "%";
                    },
                },
                {
                    key: "_handleScrollAnimations",
                    value: function () {
                        var t = this,
                            e = new IntersectionObserver(
                                function (e) {
                                    !0 !== e[0].isIntersecting ||
                                        t.getAttribute("handled-animatation-once") ||
                                        (t.classList.add("animate-in"),
                                        t.setAttribute("handled-animatation-once", !0),
                                        setTimeout(function () {
                                            return t.classList.remove("animate-in");
                                        }, 1e4));
                                },
                                { threshold: [0.5] }
                            );
                        setTimeout(function () {
                            e.observe(t);
                        });
                    },
                },
            ]),
            s && l(a.prototype, s),
            Object.defineProperty(a, "prototype", { writable: !1 }),
            p
        );
    })(p(HTMLElement));
    const b = m;
    function g(t) {
        return (
            (g =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            g(t)
        );
    }
    function w(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== g(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== g(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === g(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function _(t, e) {
        if (e && ("object" === g(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function S(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (S = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return A(t, arguments, E(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), x(n, t);
            }),
            S(t)
        );
    }
    function A(t, e, n) {
        return (
            (A = O()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && x(o, n.prototype), o;
                  }),
            A.apply(null, arguments)
        );
    }
    function O() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function x(t, e) {
        return (
            (x = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            x(t, e)
        );
    }
    function E(t) {
        return (
            (E = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            E(t)
        );
    }
    const P = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && x(t, e);
        })(s, t);
        var e,
            r,
            o,
            i,
            a =
                ((e = s),
                (r = O()),
                function () {
                    var t,
                        n = E(e);
                    if (r) {
                        var o = E(this).constructor;
                        t = Reflect.construct(n, arguments, o);
                    } else t = n.apply(this, arguments);
                    return _(this, t);
                });
        function s() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, s),
                ((t = a.call(this)).loaded = !1),
                (t.originalAnimation = t.getAttribute("animation") || "none"),
                (t.originalHeight = t.offsetHeight),
                t
            );
        }
        return (
            (o = s),
            (i = [
                {
                    key: "playLeaveAnimation",
                    value: function () {
                        n(this, { opacity: 0 }), this._initAnimationStyles(this);
                    },
                },
                {
                    key: "playEnterAnimation",
                    value: function () {
                        var t = this,
                            e = this.getAttribute("delay") || 100,
                            r = this.getAttribute("speed") || 1e3,
                            o = "true" == this.getAttribute("infinite");
                        0 == e && (e = 10), this.setAttribute("animation", this.originalAnimation), this._initAnimationStyles(this);
                        var i = this.getAttribute("animation");
                        o || this.setAttribute("animation", "none"),
                            setTimeout(function () {
                                var e = "";
                                ("wipe-left" != i && "wipe-right" != i && "wipe-up" != i && "wipe-down" != i) || (e = "polygon(0 0, 100% 0, 100% 100%, 0% 100%)"),
                                    n(t, { transform: "", opacity: 1, clipPath: e, transition: "opacity ".concat(r, "ms, transform ").concat(r, "ms, clip-path ").concat(r, "ms") });
                            }, e);
                    },
                },
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        if (((this.loaded = !0), "none" == this.getAttribute("animation"))) return n(this, { display: "block", opacity: 1 }), !1;
                        n(this, { display: "block", opacity: 0, transition: "none" });
                        var e = this.getAttribute("px-visible") || 100,
                            r = this._calculateThreshold(e),
                            o = new IntersectionObserver(
                                function (e) {
                                    var n = e[0];
                                    (n.intersectionRatio < r && t.originalHeight == t.offsetHeight) ||
                                        (n.intersectionRatio < r && (t.originalHeight, t.offsetHeight), !0 === n.isIntersecting && "none" != t.getAttribute("animation") && t.playEnterAnimation());
                                },
                                { threshold: [0.001, r] }
                            ),
                            i = new IntersectionObserver(
                                function (e) {
                                    var n = e[0],
                                        r = "true" == t.getAttribute("infinite");
                                    !1 === n.isIntersecting && r && t.playLeaveAnimation();
                                },
                                { threshold: [1e-4] }
                            );
                        setTimeout(function () {
                            o.observe(t), i.observe(t);
                        });
                    },
                },
                {
                    key: "_calculateThreshold",
                    value: function (t) {
                        return Math.min(t / this.offsetHeight, 1);
                    },
                },
                {
                    key: "_initAnimationStyles",
                    value: function (t) {
                        switch (t.getAttribute("animation")) {
                            case "up":
                                setTimeout(function () {
                                    return n(t, { transform: "translate3d(0, 100px, 0)" });
                                }, 0);
                                break;
                            case "down":
                                setTimeout(function () {
                                    return n(t, { transform: "translate3d(0, -100px, 0)" });
                                }, 0);
                                break;
                            case "left":
                                setTimeout(function () {
                                    return n(t, { transform: "translate3d(-100px, 0, 0)" });
                                }, 0);
                                break;
                            case "right":
                                setTimeout(function () {
                                    return n(t, { transform: "translate3d(100px, 0, 0)" });
                                }, 0);
                                break;
                            case "scale":
                                setTimeout(function () {
                                    return n(t, { transform: "scale(0.65)" });
                                }, 0);
                                break;
                            case "wipe-left":
                                setTimeout(function () {
                                    return n(t, { clipPath: "polygon(100% 0, 100% 0, 100% 100%, 100% 100%)" });
                                }, 0);
                                break;
                            case "wipe-right":
                                setTimeout(function () {
                                    return n(t, { clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)" });
                                }, 0);
                                break;
                            case "wipe-down":
                                setTimeout(function () {
                                    return n(t, { clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)" });
                                }, 0);
                                break;
                            case "wipe-up":
                                setTimeout(function () {
                                    return n(t, { clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)" });
                                }, 0);
                        }
                    },
                },
            ]) && w(o.prototype, i),
            Object.defineProperty(o, "prototype", { writable: !1 }),
            s
        );
    })(S(HTMLElement));
    function T(t) {
        return (
            (T =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            T(t)
        );
    }
    function k(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== T(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== T(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === T(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function j(t, e) {
        if (e && ("object" === T(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function C(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (C = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return L(t, arguments, I(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), M(n, t);
            }),
            C(t)
        );
    }
    function L(t, e, n) {
        return (
            (L = $()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && M(o, n.prototype), o;
                  }),
            L.apply(null, arguments)
        );
    }
    function $() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function M(t, e) {
        return (
            (M = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            M(t, e)
        );
    }
    function I(t) {
        return (
            (I = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            I(t)
        );
    }
    var R = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && M(t, e);
        })(c, t);
        var e,
            o,
            i,
            a,
            s =
                ((e = c),
                (o = $()),
                function () {
                    var t,
                        n = I(e);
                    if (o) {
                        var r = I(this).constructor;
                        t = Reflect.construct(n, arguments, r);
                    } else t = n.apply(this, arguments);
                    return j(this, t);
                });
        function c() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, c),
                ((t = s.call(this)).loaded = !1),
                t
            );
        }
        return (
            (i = c),
            (a = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        if (((this.loaded = !0), !this.id)) return console.warn("ADA modal needs an ID", this), void this.remove();
                        this.querySelectorAll("h1, h2, h3, h4, h5, h6").length || console.warn("#" + this.id + " should have a heading"),
                            (this.style.display = "none"),
                            this.setAttribute("aria-hidden", !0),
                            this.setAttribute("aria-modal", !0),
                            this.setAttribute("role", "dialog");
                        var e = document.querySelectorAll('[modal-id="'.concat(this.id, '"]'));
                        e &&
                            e.forEach(function (t) {
                                "BUTTON" != t.tagName && console.warn("ADA modal trigger should be a button", t), t.setAttribute("aria-expanded", !1), t.setAttribute("aria-haspopup", "dialog");
                            }),
                            document.addEventListener("click", function (e) {
                                var n, r;
                                e.target.hasAttribute("modal-id")
                                    ? ((n = e.target.getAttribute("modal-id")), (r = e.target))
                                    : ((n = e.target.closest("[modal-id]")) && (n = n.getAttribute("modal-id")), (r = e.target.closest("[modal-id]"))),
                                    n && n == t.id && (r.setAttribute("aria-expanded", !0), t._openModal());
                            }),
                            "false" !== this.getAttribute("esc-to-close") &&
                                document.addEventListener("keydown", function (e) {
                                    "Escape" == e.key && "none" != t.style.display && t._closeModal();
                                }),
                            "true" == this.getAttribute("open-on-load") && this._openModal();
                    },
                },
                {
                    key: "_openModal",
                    value: function () {
                        var t = this;
                        this.dispatchEvent(new Event("open")), this.setAttribute("aria-hidden", !1);
                        var e = r(this);
                        e.classList.add("ada-modal-backdrop"),
                            n(e, {
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100vw",
                                height: "100vh",
                                background: "rgba(0,0,0,0.65)",
                                transition: "450ms",
                                opacity: 0,
                                overflow: "auto",
                                "backdrop-filter": "blur(3px)",
                                "z-index": 999999,
                                margin: 0,
                            }),
                            setTimeout(function () {
                                n(e, { opacity: 1 });
                            }, 0),
                            setTimeout(function () {
                                n(t, { display: "block", "margin-left": "auto", "margin-right": "auto", opacity: 0, transform: "translateY(-100px)", transition: "450ms" });
                            }, 1),
                            setTimeout(function () {
                                n(t, { opacity: 1, transform: "translateY(0)" }), t._trapFocus();
                            }, 100),
                            "false" != this.getAttribute("click-backdrop-to-close") &&
                                e.addEventListener("click", function (n) {
                                    n.target == e && t._closeModal();
                                });
                        var o = this.querySelectorAll("[ada-modal-closer]");
                        o.length
                            ? o.forEach(function (e) {
                                  e.dataset.listenerAdded ||
                                      ("BUTTON" != e.tagName && console.warn("ADA modal closer should be a button", e),
                                      (e.dataset.listenerAdded = !0),
                                      e.addEventListener("click", function (e) {
                                          e.preventDefault(), t._closeModal();
                                      }));
                              })
                            : console.warn("#" + this.id + " should have a close button");
                    },
                },
                {
                    key: "_closeModal",
                    value: function () {
                        var t = this,
                            e = this.parentNode;
                        n(this, { opacity: 0, transform: "translateY(-100px)" }),
                            n(e, { opacity: 0 }),
                            setTimeout(function () {
                                t.setAttribute("aria-hidden", !0), (t.style.display = "none"), e.parentNode.insertBefore(t, e), e.remove(), t.dispatchEvent(new Event("close"));
                            }, 500);
                    },
                },
                {
                    key: "_trapFocus",
                    value: function () {
                        var t = this.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
                            e = t.length ? t[0] : this,
                            n = t.length ? t[t.length - 1] : this;
                        document.addEventListener("keydown", function (t) {
                            ("Tab" === t.key || 9 === t.keyCode) && (t.shiftKey ? document.activeElement === e && (n.focus(), t.preventDefault()) : document.activeElement === n && (e.focus(), t.preventDefault()));
                        }),
                            this.setAttribute("tabindex", -1),
                            this.focus();
                    },
                },
            ]),
            a && k(i.prototype, a),
            Object.defineProperty(i, "prototype", { writable: !1 }),
            c
        );
    })(C(HTMLElement));
    const D = R;
    function N(t) {
        return (
            (N =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            N(t)
        );
    }
    function F(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
        return r;
    }
    function q(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== N(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== N(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === N(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function H(t, e) {
        if (e && ("object" === N(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function B(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (B = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return U(t, arguments, z(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), V(n, t);
            }),
            B(t)
        );
    }
    function U(t, e, n) {
        return (
            (U = W()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && V(o, n.prototype), o;
                  }),
            U.apply(null, arguments)
        );
    }
    function W() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function V(t, e) {
        return (
            (V = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            V(t, e)
        );
    }
    function z(t) {
        return (
            (z = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            z(t)
        );
    }
    var K = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && V(t, e);
        })(u, t);
        var e,
            r,
            o,
            i,
            c =
                ((e = u),
                (r = W()),
                function () {
                    var t,
                        n = z(e);
                    if (r) {
                        var o = z(this).constructor;
                        t = Reflect.construct(n, arguments, o);
                    } else t = n.apply(this, arguments);
                    return H(this, t);
                });
        function u() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, u),
                ((t = c.call(this)).loaded = !1),
                (t.isAnimating = !1),
                (t.animationTimer = null),
                (t.forceUpdate = !1),
                t
            );
        }
        return (
            (o = u),
            (i = [
                {
                    key: "activePage",
                    get: function () {
                        return parseInt(this.getAttribute("active-page"));
                    },
                    set: function (t) {
                        var e = this;
                        if ((this.getAttribute("slides-per-page") > 1 && (t = this._getClosestValidPage(t)), t < 0 && (t = this._getMaxAllowedIndex()), t > this._getMaxAllowedIndex() && (t = 0), t != this.activePage)) {
                            if (this.isAnimating) return !1;
                            (this.isAnimating = !0), this.setAttribute("active-page", t);
                            var n = new CustomEvent("activePageChanged", { detail: t });
                            this.dispatchEvent(n),
                                this.animationTimer ||
                                    (this.animationTimer = setTimeout(function () {
                                        (e.isAnimating = !1), (e.animationTimer = null);
                                    }, parseInt(this.getAttribute("speed")) + 10));
                        }
                    },
                },
                {
                    key: "getValidIndicies",
                    value: function () {
                        var t = [],
                            e = this.getAttribute("pagination-style"),
                            n = parseInt(this.getAttribute("slides-per-page"));
                        if ("multi" == e) for (var r = 0; r < this.children.length; ) t.push(r), (r += n);
                        else for (var o = 0; o <= this._getMaxAllowedIndex(); o++) t.push(o);
                        return t;
                    },
                },
                {
                    key: "_getClosestValidPage",
                    value: function (t) {
                        var e = this.getValidIndicies();
                        if (-1 !== e.indexOf(t)) return t;
                        var n = this.activePage ? parseInt(this.activePage) : 0,
                            r = n > t ? "prev" : "next";
                        if ("prev" == r && 0 == n) return e[e.length - 1];
                        if ("next" == r && n >= e[e.length - 1]) return 0;
                        var o = e.indexOf(n);
                        return "next" == r ? e[o + 1] : e[o - 1];
                    },
                },
                {
                    key: "_getMaxAllowedIndex",
                    value: function () {
                        var t = this.children.length,
                            e = parseInt(this.getAttribute("slides-per-page")),
                            n = this.getAttribute("pagination-style"),
                            r = t - 1;
                        return 1 != e && "single" == n && (r = r - e + 1), r;
                    },
                },
                {
                    key: "connectedCallback",
                    value: function () {
                        var t,
                            e = this;
                        return (
                            !this.loaded &&
                            ((this.loaded = !0),
                            (this.autoplayerInterval = ""),
                            this.id
                                ? (((t = this.children),
                                  (function (t) {
                                      if (Array.isArray(t)) return F(t);
                                  })(t) ||
                                      (function (t) {
                                          if (("undefined" != typeof Symbol && null != t[Symbol.iterator]) || null != t["@@iterator"]) return Array.from(t);
                                      })(t) ||
                                      (function (t, e) {
                                          if (t) {
                                              if ("string" == typeof t) return F(t, e);
                                              var n = Object.prototype.toString.call(t).slice(8, -1);
                                              return (
                                                  "Object" === n && t.constructor && (n = t.constructor.name),
                                                  "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? F(t, e) : void 0
                                              );
                                          }
                                      })(t) ||
                                      (function () {
                                          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                      })()).filter(function (t) {
                                      return "ADA-SLIDE" !== t.tagName;
                                  }).length && console.warn("ADA slider can only have ada-slide as children"),
                                  document.querySelectorAll('ada-slider-page[for="'.concat(this.id, '"]')).length != this.children.length && console.warn(this.id, "ADA slider slides/pagination mismatch"),
                                  document.querySelector('ada-slider-prev[for="'.concat(this.id, '"]')) || console.warn(this.id, "ADA slider must have prev button"),
                                  document.querySelector('ada-slider-next[for="'.concat(this.id, '"]')) || console.warn(this.id, "ADA slider must have next button"),
                                  this.getAttribute("slides-per-page") || this.setAttribute("slides-per-page", 1),
                                  this.getAttribute("slides-per-page-large") || this.setAttribute("slides-per-page-large", this.getAttribute("slides-per-page")),
                                  this.getAttribute("slides-per-page-medium") || this.setAttribute("slides-per-page-medium", this.getAttribute("slides-per-page-large")),
                                  this.getAttribute("slides-per-page-small") || this.setAttribute("slides-per-page-small", this.getAttribute("slides-per-page-medium")),
                                  (this.activePage = 0),
                                  this.getAttribute("speed") || this.setAttribute("speed", 350),
                                  this.getAttribute("pagination-style") || this.setAttribute("pagination-style", "single"),
                                  this.getAttribute("transition-type") || this.setAttribute("transition-type", "all"),
                                  this.getAttribute("autoplay") && this._startAutoplay(),
                                  this._createLiveRegion(),
                                  this._createInitialStyles(),
                                  this._createTouchEvents(),
                                  "false" === this.getAttribute("adaptive-height") &&
                                      (setTimeout(function () {
                                          return e._forceSlidesToSameHeight();
                                      }, 0),
                                      window.addEventListener(
                                          "resize",
                                          s(function () {
                                              return e._forceSlidesToSameHeight();
                                          }, 500)
                                      )),
                                  this._handleResponsivePerPage(),
                                  void window.addEventListener(
                                      "resize",
                                      s(function () {
                                          return e._handleResponsivePerPage();
                                      }, 500)
                                  ))
                                : (console.warn("ADA slider must have an id"), void this.remove()))
                        );
                    },
                },
                {
                    key: "_forceSlidesToSameHeight",
                    value: function () {
                        var t = this.querySelectorAll("ada-slide"),
                            e = 0;
                        t.forEach(function (t) {
                            t.style.height && (t.style.height = ""),
                                0 == t.offsetHeight && ((t.style.display = "block"), (t.style.visibility = "hidden"), (t.style.width = "100%")),
                                t.offsetHeight > e && (e = t.offsetHeight),
                                "hidden" == t.style.visibility && ((t.style.visibility = ""), (t.style.width = 0), (t.style.display = "none"));
                        }),
                            t.forEach(function (t) {
                                return (t.style.height = "".concat(e, "px"));
                            });
                    },
                },
                {
                    key: "_handleResponsivePerPage",
                    value: function () {
                        var t = this,
                            e = this.getAttribute("slides-per-page-large"),
                            n = this.getAttribute("slides-per-page-medium"),
                            r = this.getAttribute("slides-per-page-small");
                        window.innerWidth <= 768 ? this.setAttribute("slides-per-page", r) : window.innerWidth <= 1024 ? this.setAttribute("slides-per-page", n) : this.setAttribute("slides-per-page", e),
                            (this.forceUpdate = !0),
                            setTimeout(function () {
                                t.forceUpdate = !1;
                                var e = parseInt(t.getAttribute("active-page")),
                                    n = document.querySelectorAll('ada-slider-page[for="'.concat(t.id, '"]'));
                                if (((t.forceUpdate = !0), 1 == n.length)) t.activePage = 0;
                                else if (n && n[e] && "none" == n[e].style.display)
                                    for (var r = 0; r < n.length; r++)
                                        if ("none" != n[r].style.display) {
                                            t.activePage = r;
                                            break;
                                        }
                                var o = document.querySelectorAll('ada-slider-prev[for="'.concat(t.id, '"], ada-slider-next[for="').concat(t.id, '"]'));
                                o &&
                                    o.forEach(function (e) {
                                        e.style.display = parseInt(t.getAttribute("slides-per-page")) >= t.children.length ? "none" : "";
                                    });
                                var i = document.querySelectorAll('ada-slider-page[for="'.concat(t.id, '"]'));
                                if (i) {
                                    var a = 0;
                                    i.forEach(function (t) {
                                        t.offsetParent && a++;
                                    }),
                                        i.forEach(function (t) {
                                            a <= 1 ? (t.style.display = "none") : t.offsetParent && (t.style.display = "");
                                        });
                                }
                            }, parseInt(this.getAttribute("speed")) + 100);
                    },
                },
                {
                    key: "_startAutoplay",
                    value: function () {
                        var t = this;
                        this.setAttribute("is-autoplay-active", !0);
                        var e = parseInt(this.getAttribute("autoplay-speed")) || 6e3;
                        clearInterval(this.autoplayerInterval),
                            (this.autoplayerInterval = setInterval(function () {
                                if (
                                    (e = t.getBoundingClientRect()).top >= 0 &&
                                    e.left >= 0 &&
                                    e.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                                    e.right <= (window.innerWidth || document.documentElement.clientWidth)
                                ) {
                                    var e,
                                        n = parseInt(t.getAttribute("active-page")) + 1;
                                    if ("multi" == t.getAttribute("pagination-style")) {
                                        var r = t.getAttribute("slides-per-page");
                                        n += parseInt(r) - 1;
                                    }
                                    n > t.children.length - 1 && (n = 0), (t.activePage = n);
                                }
                            }, e)),
                            ["mousedown", "touchstart"].forEach(
                                function (e) {
                                    t.addEventListener(e, function (e) {
                                        t.setAttribute("is-autoplay-active", !1), clearInterval(t.autoplayerInterval);
                                    });
                                },
                                { passive: !0 }
                            );
                    },
                },
                {
                    key: "_createTouchEvents",
                    value: function () {
                        var t = this,
                            e = !1,
                            r = 0,
                            o = 0,
                            i = 0,
                            a = 0;
                        this.addEventListener("mouseleave", function (e) {
                            (e = new Event("touchend")), t.dispatchEvent(e);
                        }),
                            ["mousedown", "touchstart"].forEach(function (n) {
                                return t.addEventListener(
                                    n,
                                    function (t) {
                                        t.touches ? ((r = t.touches[0].clientY), (o = r), (i = t.touches[0].clientX), (a = i), (e = !0)) : ((r = t.clientY), (o = r), (i = t.clientX), (a = i), (e = !0));
                                    },
                                    { passive: !0 }
                                );
                            }),
                            ["mousemove", "touchmove"].forEach(function (s) {
                                return t.addEventListener(
                                    s,
                                    function (s) {
                                        if (!e) return !1;
                                        s.touches ? ((o = s.touches[0].clientY), (a = s.touches[0].clientX)) : ((o = s.clientY), (a = s.clientX)),
                                            Math.abs(i - a) > 10 &&
                                                "vertical" != t.getAttribute("transition-type") &&
                                                t.querySelectorAll('ada-slide[aria-hidden="false"]').forEach(function (t) {
                                                    n(t, { transition: "", transform: "translate3d(".concat(-1 * (i - a), "px, 0px, 0px)") });
                                                }),
                                            Math.abs(r - o) > 10 &&
                                                "vertical" == t.getAttribute("transition-type") &&
                                                t.querySelectorAll('ada-slide[aria-hidden="false"]').forEach(function (t) {
                                                    n(t, { transition: "", transform: "translate3d(0px, ".concat(-1 * (r - o), "px, 0px)") });
                                                });
                                    },
                                    { passive: !1 }
                                );
                            }),
                            ["mouseup", "touchend"].forEach(function (s) {
                                t.addEventListener(
                                    s,
                                    function (s) {
                                        if (Math.abs(i - a) > 50 && "vertical" != t.getAttribute("transition-type")) {
                                            if (Math.abs(r - o) > 50) return t.querySelectorAll('ada-slide[aria-hidden="false"]'), !1;
                                            s.stopPropagation(), (t.activePage = a > i ? t.activePage - 1 : t.activePage + 1);
                                        } else
                                            t.querySelectorAll('ada-slide[aria-hidden="false"]').forEach(function (t) {
                                                return n(t, { transform: "" });
                                            });
                                        Math.abs(r - o) > 50 && "vertical" == t.getAttribute("transition-type")
                                            ? (s.stopPropagation(), (t.activePage = o > r ? t.activePage - 1 : t.activePage + 1))
                                            : t.querySelectorAll('ada-slide[aria-hidden="false"]').forEach(function (t) {
                                                  return n(t, { transform: "" });
                                              }),
                                            (e = !1),
                                            (r = 0),
                                            (o = 0),
                                            (i = 0),
                                            (a = 0);
                                    },
                                    { passive: !0 }
                                );
                            });
                    },
                },
                {
                    key: "_getVisibleSlideCount",
                    value: function () {
                        var t = 0;
                        return (
                            Array.from(this.children).forEach(function (e) {
                                a(e) && t++;
                            }),
                            t
                        );
                    },
                },
                {
                    key: "_createInitialStyles",
                    value: function () {
                        var t = this.getAttribute("speed");
                        n(this, { display: "flex", overflow: "hidden", position: "relative", transition: "height ".concat(t, "ms linear, opacity ").concat(t, "ms linear") }),
                            "vertical" == this.getAttribute("transition-type") && n(this, { "flex-flow": "column" });
                    },
                },
                {
                    key: "_createLiveRegion",
                    value: function () {
                        if (!document.querySelector('ada-slider-pagination-text[for="'.concat(this.id, '"]'))) {
                            var t = document.createElement("ada-slider-pagination-text");
                            t.setAttribute("for", this.id), n(t, { clip: "rect(0 0 0 0)", "clip-path": "inset(50%)", height: "1px", overflow: "hidden", position: "absolute", "white-space": "nowrap", width: "1px" }), this.after(t);
                        }
                    },
                },
            ]),
            i && q(o.prototype, i),
            Object.defineProperty(o, "prototype", { writable: !1 }),
            u
        );
    })(B(HTMLElement));
    function G(t) {
        return (
            (G =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            G(t)
        );
    }
    function Y(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== G(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== G(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === G(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function X(t, e) {
        if (e && ("object" === G(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function J(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (J = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return Z(t, arguments, et(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), tt(n, t);
            }),
            J(t)
        );
    }
    function Z(t, e, n) {
        return (
            (Z = Q()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && tt(o, n.prototype), o;
                  }),
            Z.apply(null, arguments)
        );
    }
    function Q() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function tt(t, e) {
        return (
            (tt = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            tt(t, e)
        );
    }
    function et(t) {
        return (
            (et = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            et(t)
        );
    }
    var nt = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && tt(t, e);
        })(s, t);
        var e,
            r,
            o,
            i,
            a =
                ((e = s),
                (r = Q()),
                function () {
                    var t,
                        n = et(e);
                    if (r) {
                        var o = et(this).constructor;
                        t = Reflect.construct(n, arguments, o);
                    } else t = n.apply(this, arguments);
                    return X(this, t);
                });
        function s() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, s),
                ((t = a.call(this)).loaded = !1),
                t
            );
        }
        return (
            (o = s),
            (i = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        (this.loaded = !0),
                            new MutationObserver(function (e, n) {
                                "active-page" == e[0].attributeName && t._onParentUpdated(parseInt(e[0].oldValue));
                            }).observe(this.parentNode, { attributeOldValue: !0, attributes: !0 }),
                            (this.lastActivePage = -1),
                            (this.lastPerPage = 1),
                            this._init();
                    },
                },
                {
                    key: "_onParentUpdated",
                    value: function (t) {
                        var e = this,
                            r = this.parentNode.getAttribute("transition-type"),
                            o = parseFloat(this.parentNode.getAttribute("speed")),
                            i =
                                Array.from(document.querySelectorAll('ada-slider-page[for="'.concat(this.parentNode.id, '"]'))).filter(function (t) {
                                    return t.offsetParent;
                                }).length - 1,
                            a = this.parentNode.getAttribute("active-page"),
                            s = this.parentNode.getAttribute("slides-per-page"),
                            c = "left";
                        (c = this._shouldBeActive() ? (a < t ? "left" : "right") : a > t ? "left" : "right"),
                            (0 != a && a != i) ||
                                (this._getIndexInParent() >= i && 0 == t && (c = "left"),
                                this._getIndexInParent() >= i && 0 == a && (c = "left"),
                                this._getIndexInParent() <= s && a == i && (c = "right"),
                                this._getIndexInParent() <= s && t == i && (c = "right"));
                        var u,
                            l,
                            f = "";
                        (f = "left" == c ? "translate3d(-100%,0,0)" : "translate3d(100%,0,0)"),
                            "vertical" == r && (f = "left" == c ? "translate3d(0,-100%,0)" : "translate3d(0,100%,0)"),
                            (l = (u = this).style.display),
                            (u.style.display = "none"),
                            u.offsetHeight,
                            (u.style.display = l),
                            this._shouldBeActive() && n(this, { display: "block", transform: f }),
                            requestAnimationFrame(function () {
                                n(e, {
                                    opacity: e._shouldBeActive() ? 1 : 0,
                                    transform: e._shouldBeActive() ? "none" : f,
                                    position: e._shouldBeActive() ? "static" : "absolute",
                                    left: 0,
                                    width: e._shouldBeActive() ? "" : e.offsetWidth + "px",
                                    transition: "opacity ".concat(o, "ms linear, transform ").concat(o, "ms linear"),
                                }),
                                    e._shouldBeActive() ||
                                        setTimeout(function () {
                                            n(e, { display: "none" });
                                        }, o + 1);
                            }),
                            this._setAria(o);
                    },
                },
                {
                    key: "_init",
                    value: function () {
                        var t = this.parentNode.getAttribute("speed"),
                            e = this.parentNode.getAttribute("transition-type"),
                            r = 100 / (this.parentNode.getAttribute("slides-per-page") || 1);
                        n(this, {
                            display: this._shouldBeActive() ? "block" : "none",
                            flex: "1 0 ".concat(r, "%"),
                            maxWidth: "vertical" == e ? "100%" : "".concat(r, "%"),
                            maxHeight: "vertical" == e ? "".concat(r, "%") : "100%",
                            transition: "opacity ".concat(t, "ms linear, transform ").concat(t, "ms linear"),
                        }),
                            this._setAria(0);
                    },
                },
                {
                    key: "_setAria",
                    value: function (t) {
                        var e = this._shouldBeActive();
                        this.setAttribute("tabindex", -1), this.setAttribute("aria-hidden", !e);
                    },
                },
                {
                    key: "_shouldBeActive",
                    value: function () {
                        var t = this._getIndexInParent(),
                            e = parseInt(this.parentNode.getAttribute("active-page")),
                            n = parseInt(this.parentNode.getAttribute("slides-per-page"));
                        return t >= e && t <= e + (n - 1);
                    },
                },
                {
                    key: "_getIndexInParent",
                    value: function () {
                        return Array.prototype.indexOf.call(this.parentNode.children, this);
                    },
                },
            ]) && Y(o.prototype, i),
            Object.defineProperty(o, "prototype", { writable: !1 }),
            s
        );
    })(J(HTMLElement));
    function rt(t) {
        return (
            (rt =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            rt(t)
        );
    }
    function ot(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== rt(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== rt(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === rt(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function it(t, e) {
        if (e && ("object" === rt(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function at(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (at = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return st(t, arguments, lt(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), ut(n, t);
            }),
            at(t)
        );
    }
    function st(t, e, n) {
        return (
            (st = ct()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && ut(o, n.prototype), o;
                  }),
            st.apply(null, arguments)
        );
    }
    function ct() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function ut(t, e) {
        return (
            (ut = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            ut(t, e)
        );
    }
    function lt(t) {
        return (
            (lt = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            lt(t)
        );
    }
    var ft = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && ut(t, e);
        })(c, t);
        var e,
            n,
            o,
            i,
            s =
                ((e = c),
                (n = ct()),
                function () {
                    var t,
                        r = lt(e);
                    if (n) {
                        var o = lt(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return it(this, t);
                });
        function c() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, c),
                ((t = s.call(this)).loaded = !1),
                t
            );
        }
        return (
            (o = c),
            (i = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        this.loaded = !0;
                        var e = document.createElement("button");
                        this.children.length
                            ? Array.from(this.children).forEach(function (t) {
                                  return e.append(t);
                              })
                            : ((e.innerHTML = this.innerHTML), (this.innerHTML = "")),
                            this.append(e),
                            "UL" == this.parentNode.tagName && r(this, "li"),
                            e.addEventListener("click", function (e) {
                                var n = document.querySelector("#" + t.getAttribute("for"));
                                (n.activePage = parseInt(t.getAttribute("index"))),
                                    setTimeout(function () {
                                        n.querySelector('ada-slide[aria-hidden="false"]').focus();
                                    }, parseInt(n.getAttribute("speed")) + 1);
                            }),
                            a(e) || e.setAttribute("focusable", "false"),
                            window.addEventListener("resize", function (t) {
                                a(e) ? e.removeAttribute("focusable") : e.setAttribute("focusable", "false");
                            }),
                            new MutationObserver(function (e, n) {
                                return t._init();
                            }).observe(document.querySelector("#" + this.getAttribute("for")), { attributes: !0 }),
                            this._init();
                    },
                },
                {
                    key: "_init",
                    value: function () {
                        var t = document.querySelector("#" + this.getAttribute("for")),
                            e = this.querySelector("button"),
                            n = t.getValidIndicies(),
                            r = parseInt(this.getAttribute("index"));
                        if (-1 == n.indexOf(r)) this.style.display = "none";
                        else {
                            this.style.display = "";
                            var o = parseInt(t.getAttribute("slides-per-page")),
                                i = parseInt(this.getAttribute("index")),
                                a = i > 0 ? Math.ceil(i / o + 1) : 1;
                            o > 1 ? e.setAttribute("aria-label", "Go to Slide Group " + a) : e.setAttribute("aria-label", "Go to Slide " + a);
                        }
                        t.getAttribute("active-page") == this.getAttribute("index") ? (e.setAttribute("aria-current", !0), this.classList.add("active")) : (e.setAttribute("aria-current", !1), this.classList.remove("active"));
                    },
                },
            ]) && ot(o.prototype, i),
            Object.defineProperty(o, "prototype", { writable: !1 }),
            c
        );
    })(at(HTMLElement));
    function pt(t) {
        return (
            (pt =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            pt(t)
        );
    }
    function dt(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== pt(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== pt(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === pt(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function ht(t, e) {
        if (e && ("object" === pt(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function vt(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (vt = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return yt(t, arguments, gt(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), bt(n, t);
            }),
            vt(t)
        );
    }
    function yt(t, e, n) {
        return (
            (yt = mt()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && bt(o, n.prototype), o;
                  }),
            yt.apply(null, arguments)
        );
    }
    function mt() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function bt(t, e) {
        return (
            (bt = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            bt(t, e)
        );
    }
    function gt(t) {
        return (
            (gt = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            gt(t)
        );
    }
    var wt = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && bt(t, e);
        })(a, t);
        var e,
            n,
            r,
            o,
            i =
                ((e = a),
                (n = mt()),
                function () {
                    var t,
                        r = gt(e);
                    if (n) {
                        var o = gt(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return ht(this, t);
                });
        function a() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, a),
                ((t = i.call(this)).loaded = !1),
                t
            );
        }
        return (
            (r = a),
            (o = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        this.loaded = !0;
                        var e = document.createElement("button");
                        this.children.length
                            ? Array.from(this.children).forEach(function (t) {
                                  return e.append(t);
                              })
                            : ((e.innerHTML = this.innerHTML), (this.innerHTML = "")),
                            this.append(e);
                        var n = this.getAttribute("aria-label");
                        n && (e.setAttribute("aria-label", n), this.removeAttribute("aria-label")),
                            e.addEventListener("click", function (e) {
                                var n = document.querySelector("#" + t.getAttribute("for"));
                                if (!n.isAnimating) {
                                    var r = parseInt(n.getAttribute("active-page")) - 1;
                                    (n.activePage = r),
                                        n.setAttribute("is-autoplay-active", !1),
                                        clearInterval(n.autoplayerInterval),
                                        setTimeout(function () {
                                            n.querySelector('ada-slide[aria-hidden="false"]').focus();
                                        }, parseInt(n.getAttribute("speed")) + 1);
                                }
                            });
                    },
                },
            ]) && dt(r.prototype, o),
            Object.defineProperty(r, "prototype", { writable: !1 }),
            a
        );
    })(vt(HTMLElement));
    function _t(t) {
        return (
            (_t =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            _t(t)
        );
    }
    function St(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== _t(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== _t(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === _t(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function At(t, e) {
        if (e && ("object" === _t(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function Ot(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (Ot = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return xt(t, arguments, Tt(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Pt(n, t);
            }),
            Ot(t)
        );
    }
    function xt(t, e, n) {
        return (
            (xt = Et()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && Pt(o, n.prototype), o;
                  }),
            xt.apply(null, arguments)
        );
    }
    function Et() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function Pt(t, e) {
        return (
            (Pt = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            Pt(t, e)
        );
    }
    function Tt(t) {
        return (
            (Tt = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            Tt(t)
        );
    }
    var kt = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Pt(t, e);
        })(s, t);
        var e,
            n,
            r,
            o,
            i =
                ((e = s),
                (n = Et()),
                function () {
                    var t,
                        r = Tt(e);
                    if (n) {
                        var o = Tt(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return At(this, t);
                });
        function s() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, s),
                ((t = i.call(this)).loaded = !1),
                t
            );
        }
        return (
            (r = s),
            (o = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        this.loaded = !0;
                        var e = document.createElement("button");
                        this.children.length
                            ? Array.from(this.children).forEach(function (t) {
                                  return e.append(t);
                              })
                            : ((e.innerHTML = this.innerHTML), (this.innerHTML = "")),
                            this.append(e);
                        var n = this.getAttribute("aria-label");
                        n && (e.setAttribute("aria-label", n), this.removeAttribute("aria-label")),
                            e.addEventListener("click", function (e) {
                                var n = document.querySelector("#" + t.getAttribute("for"));
                                if (!n.isAnimating) {
                                    var r = parseInt(n.getAttribute("active-page")) + 1;
                                    (n.activePage = r),
                                        n.setAttribute("is-autoplay-active", !1),
                                        clearInterval(n.autoplayerInterval),
                                        setTimeout(function () {
                                            n.querySelector('ada-slide[aria-hidden="false"]').focus();
                                        }, parseInt(n.getAttribute("speed")) + 1);
                                }
                            }),
                            a(e) || e.setAttribute("focusable", "false"),
                            window.addEventListener("resize", function (t) {
                                a(e) ? e.removeAttribute("focusable") : e.setAttribute("focusable", "false");
                            });
                    },
                },
            ]) && St(r.prototype, o),
            Object.defineProperty(r, "prototype", { writable: !1 }),
            s
        );
    })(Ot(HTMLElement));
    function jt(t) {
        return (
            (jt =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            jt(t)
        );
    }
    function Ct(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== jt(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== jt(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === jt(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function Lt(t, e) {
        if (e && ("object" === jt(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function $t(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            ($t = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return Mt(t, arguments, Dt(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Rt(n, t);
            }),
            $t(t)
        );
    }
    function Mt(t, e, n) {
        return (
            (Mt = It()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && Rt(o, n.prototype), o;
                  }),
            Mt.apply(null, arguments)
        );
    }
    function It() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function Rt(t, e) {
        return (
            (Rt = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            Rt(t, e)
        );
    }
    function Dt(t) {
        return (
            (Dt = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            Dt(t)
        );
    }
    var Nt = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Rt(t, e);
        })(a, t);
        var e,
            n,
            r,
            o,
            i =
                ((e = a),
                (n = It()),
                function () {
                    var t,
                        r = Dt(e);
                    if (n) {
                        var o = Dt(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return Lt(this, t);
                });
        function a() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, a),
                ((t = i.call(this)).loaded = !1),
                t
            );
        }
        return (
            (r = a),
            (o = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        (this.loaded = !0),
                            (this.parent = document.querySelector("#" + this.getAttribute("for"))),
                            (this.button = document.createElement("button")),
                            this.classList.add("true" == this.parent.getAttribute("is-autoplay-active") ? "playing" : "paused"),
                            this.append(this.button),
                            this.button.addEventListener("click", function (e) {
                                "true" == t.parent.getAttribute("is-autoplay-active")
                                    ? (t.parent.setAttribute("is-autoplay-active", !1), clearInterval(t.parent.autoplayerInterval))
                                    : (document.querySelector('ada-slider-next[for="'.concat(t.parent.id, '"]')).querySelector("button").click(), t.parent._startAutoplay());
                            }),
                            new MutationObserver(function (e, n) {
                                return t._parentUpdated();
                            }).observe(this.parent, { attributes: !0 }),
                            this._parentUpdated();
                    },
                },
                {
                    key: "_parentUpdated",
                    value: function () {
                        "true" == this.parent.getAttribute("is-autoplay-active")
                            ? (this.classList.add("playing"), this.classList.remove("paused"), (this.button.innerHTML = '<span aria-hidden="true">&#x2759;&#x2759;</span><span class="sr-only">Pause</span>'))
                            : (this.classList.add("paused"), this.classList.remove("playing"), (this.button.innerHTML = '<span aria-hidden="true">&#9658;</span><span class="sr-only">Play</span>'));
                    },
                },
            ]) && Ct(r.prototype, o),
            Object.defineProperty(r, "prototype", { writable: !1 }),
            a
        );
    })($t(HTMLElement));
    function Ft(t) {
        return (
            (Ft =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            Ft(t)
        );
    }
    function qt(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== Ft(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== Ft(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === Ft(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function Ht(t, e) {
        if (e && ("object" === Ft(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function Bt(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (Bt = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return Ut(t, arguments, zt(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Vt(n, t);
            }),
            Bt(t)
        );
    }
    function Ut(t, e, n) {
        return (
            (Ut = Wt()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && Vt(o, n.prototype), o;
                  }),
            Ut.apply(null, arguments)
        );
    }
    function Wt() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function Vt(t, e) {
        return (
            (Vt = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            Vt(t, e)
        );
    }
    function zt(t) {
        return (
            (zt = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            zt(t)
        );
    }
    var Kt = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Vt(t, e);
        })(a, t);
        var e,
            n,
            r,
            o,
            i =
                ((e = a),
                (n = Wt()),
                function () {
                    var t,
                        r = zt(e);
                    if (n) {
                        var o = zt(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return Ht(this, t);
                });
        function a() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, a),
                ((t = i.call(this)).loaded = !1),
                t
            );
        }
        return (
            (r = a),
            (o = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        (this.loaded = !0),
                            this.setAttribute("aria-live", "polite"),
                            this.setAttribute("aria-atomic", "true"),
                            new MutationObserver(function (e, n) {
                                return t._init();
                            }).observe(document.querySelector("#" + this.getAttribute("for")), { attributes: !0 }),
                            this._init();
                    },
                },
                {
                    key: "_init",
                    value: function () {
                        var t = document.querySelector("#" + this.getAttribute("for")),
                            e = parseInt(t.getAttribute("active-page")) + 1,
                            n = t.children.length;
                        this.textContent = n > 1 ? "Page ".concat(e, " of ").concat(n) : "";
                    },
                },
            ]) && qt(r.prototype, o),
            Object.defineProperty(r, "prototype", { writable: !1 }),
            a
        );
    })(Bt(HTMLElement));
    function Gt(t) {
        return (
            (Gt =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            Gt(t)
        );
    }
    function Yt(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== Gt(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== Gt(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === Gt(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function Xt(t, e) {
        if (e && ("object" === Gt(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function Jt(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (Jt = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return Zt(t, arguments, ee(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), te(n, t);
            }),
            Jt(t)
        );
    }
    function Zt(t, e, n) {
        return (
            (Zt = Qt()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && te(o, n.prototype), o;
                  }),
            Zt.apply(null, arguments)
        );
    }
    function Qt() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function te(t, e) {
        return (
            (te = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            te(t, e)
        );
    }
    function ee(t) {
        return (
            (ee = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            ee(t)
        );
    }
    var ne = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && te(t, e);
        })(c, t);
        var e,
            n,
            r,
            a,
            s =
                ((e = c),
                (n = Qt()),
                function () {
                    var t,
                        r = ee(e);
                    if (n) {
                        var o = ee(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return Xt(this, t);
                });
        function c() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, c),
                ((t = s.call(this)).loaded = !1),
                t
            );
        }
        return (
            (r = c),
            (a = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        (this.loaded = !0),
                            this.getAttribute("type") || this.setAttribute("type", "accordion"),
                            "accordion" == this.getAttribute("type") ? (this.setAttribute("can-close-all", !0), this.setAttribute("slide", !0)) : (this.setAttribute("can-close-all", !1), this.setAttribute("slide", !1)),
                            (this.innerHTML = "<button>" + this.innerHTML + "</button>"),
                            "tab" == this.getAttribute("type") && this.firstChild.setAttribute("role", "tab"),
                            this.id || console.warn("ADA toggler should have an ID"),
                            (this.firstChild.id = this.id),
                            this.removeAttribute("id"),
                            this.getAttribute("group") || this.setAttribute("group", i()),
                            this.querySelectorAll("h2,h3,h4,h5,h6").length || console.warn("ADA Toggler should have a header as a child", this),
                            this.firstChild.setAttribute("aria-controls", this.getAttribute("for")),
                            "accordion" == this.getAttribute("type") ? this.firstChild.setAttribute("aria-expanded", "false") : (this.firstChild.setAttribute("aria-selected", "false"), this.firstChild.setAttribute("tabindex", "-1"));
                        var e = document.querySelector("#" + this.getAttribute("for"));
                        e
                            ? (e.setAttribute("aria-labelledby", this.firstChild.id),
                              "accordion" == this.getAttribute("type") ? e.setAttribute("role", "region") : e.setAttribute("role", "tabpanel"),
                              (e.style.display = "none"),
                              "tab" != this.getAttribute("type") || e.closest('[role="tablist"]') || console.warn("ADA Toggler tab content must be contained within an element containing `role=tablist`"))
                            : console.warn("No target for ada toggler ", this),
                            this.firstChild.addEventListener("keydown", function (e) {
                                if ("ArrowRight" == e.key || "ArrowDown" == e.key) {
                                    e.preventDefault();
                                    var n,
                                        r = document.querySelectorAll('ada-toggler[group="'.concat(t.getAttribute("group"), '"]'));
                                    r.forEach(function (e, r) {
                                        e == t && (n = r + 1);
                                    }),
                                        n > r.length - 1 && (n = 0),
                                        r[n].firstChild.focus();
                                }
                                if ("ArrowLeft" == e.key || "ArrowUp" == e.key) {
                                    e.preventDefault();
                                    var o,
                                        i = document.querySelectorAll('ada-toggler[group="'.concat(t.getAttribute("group"), '"]'));
                                    i.forEach(function (e, n) {
                                        e == t && (o = n - 1);
                                    }),
                                        o < 0 && (o = i.length - 1),
                                        i[o].firstChild.focus();
                                }
                                if (("Home" == e.key && (e.preventDefault(), document.querySelectorAll('ada-toggler[group="'.concat(t.getAttribute("group"), '"]'))[0].firstChild.focus()), "End" == e.key)) {
                                    e.preventDefault();
                                    var a = document.querySelectorAll('ada-toggler[group="'.concat(t.getAttribute("group"), '"]'));
                                    a[a.length - 1].firstChild.focus();
                                }
                            }),
                            this.firstChild.addEventListener("click", function (e) {
                                e.preventDefault(), t._onTogglerClick(!0);
                            });
                        var n = !!this.hasAttribute("initially-active") && this.getAttribute("initially-active");
                        ("true" != n && 1 != n) ||
                            setTimeout(function () {
                                return t._onTogglerClick(!1);
                            }, 1),
                            window.location.hash &&
                                window.location.hash.replace("#", "") == this.firstChild.id &&
                                setTimeout(function () {
                                    return t._onTogglerClick(!1);
                                }, 10);
                    },
                },
                {
                    key: "_onTogglerClick",
                    value: function (t) {
                        var e = this;
                        document.querySelectorAll('ada-toggler[group="'.concat(this.getAttribute("group"), '"]')).forEach(function (n) {
                            var r = document.querySelector("#" + n.getAttribute("for"));
                            if (r) {
                                var i = window.getComputedStyle(r);
                                if (n == e)
                                    if ("none" === i.display)
                                        "accordion" == e.getAttribute("type") ? e.firstChild.setAttribute("aria-expanded", "true") : (e.firstChild.setAttribute("aria-selected", "true"), e.firstChild.setAttribute("tabindex", "")),
                                            "false" == e.getAttribute("slide")
                                                ? (r.style.display = "")
                                                : (function (t) {
                                                      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500;
                                                      t.style.removeProperty("display");
                                                      var n = window.getComputedStyle(t).display;
                                                      "none" === n && (n = "block"), (t.style.display = n);
                                                      var r = t.offsetHeight;
                                                      (t.style.overflow = "hidden"),
                                                          (t.style.height = 0),
                                                          (t.style.paddingTop = 0),
                                                          (t.style.paddingBottom = 0),
                                                          (t.style.marginTop = 0),
                                                          (t.style.marginBottom = 0),
                                                          t.offsetHeight,
                                                          (t.style.boxSizing = "border-box"),
                                                          (t.style.transitionProperty = "height, margin, padding"),
                                                          (t.style.transitionDuration = e + "ms"),
                                                          (t.style.height = r + "px"),
                                                          t.style.removeProperty("padding-top"),
                                                          t.style.removeProperty("padding-bottom"),
                                                          t.style.removeProperty("margin-top"),
                                                          t.style.removeProperty("margin-bottom"),
                                                          window.setTimeout(function () {
                                                              t.style.removeProperty("height"), t.style.removeProperty("overflow"), t.style.removeProperty("transition-duration"), t.style.removeProperty("transition-property");
                                                          }, e);
                                                  })(r),
                                            t &&
                                                setTimeout(function () {
                                                    r.setAttribute("tabindex", -1), r.focus();
                                                });
                                    else {
                                        var a = e.getAttribute("can-close-all");
                                        if ("false" == a || 0 == a) return;
                                        "accordion" == e.getAttribute("type") ? e.firstChild.setAttribute("aria-expanded", "false") : (e.firstChild.setAttribute("aria-selected", "false"), e.firstChild.setAttribute("tabindex", "-1")),
                                            "false" == e.getAttribute("slide") ? (r.style.display = "none") : o(r);
                                    }
                                else
                                    "accordion" == e.getAttribute("type") ? n.firstChild.setAttribute("aria-expanded", "false") : (n.firstChild.setAttribute("aria-selected", "false"), n.firstChild.setAttribute("tabindex", "-1")),
                                        "false" == e.getAttribute("slide") ? (r.style.display = "none") : o(r);
                            }
                        });
                    },
                },
            ]),
            a && Yt(r.prototype, a),
            Object.defineProperty(r, "prototype", { writable: !1 }),
            c
        );
    })(Jt(HTMLElement));
    const re = ne;
    function oe(t) {
        return (
            (oe =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            oe(t)
        );
    }
    function ie(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function ae(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== oe(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== oe(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === oe(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function se(t, e, n) {
        return e && ae(t.prototype, e), n && ae(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
    }
    function ce(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && he(t, e);
    }
    function ue(t) {
        var e = de();
        return function () {
            var n,
                r = ve(t);
            if (e) {
                var o = ve(this).constructor;
                n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);
            return le(this, n);
        };
    }
    function le(t, e) {
        if (e && ("object" === oe(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function fe(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (fe = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return pe(t, arguments, ve(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), he(n, t);
            }),
            fe(t)
        );
    }
    function pe(t, e, n) {
        return (
            (pe = de()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && he(o, n.prototype), o;
                  }),
            pe.apply(null, arguments)
        );
    }
    function de() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function he(t, e) {
        return (
            (he = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            he(t, e)
        );
    }
    function ve(t) {
        return (
            (ve = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            ve(t)
        );
    }
    var ye = (function (t) {
            ce(n, t);
            var e = ue(n);
            function n() {
                var t;
                return ie(this, n), ((t = e.call(this)).loaded = !1), t;
            }
            return (
                se(n, [
                    {
                        key: "connectedCallback",
                        value: function () {
                            var t = this;
                            if (this.loaded) return !1;
                            this.loaded = !0;
                            var e = this.getAttribute("target"),
                                n = this.getAttribute("now");
                            e
                                ? (parseInt(e) != e && console.warn(this, " timestamp should be a unix timestamp"),
                                  n
                                      ? (parseInt(n) != n && console.warn(this, " now should be a unix timestamp"),
                                        (e = 1e3 * parseInt(e)),
                                        (n = 1e3 * parseInt(n)),
                                        setInterval(function () {
                                            var r = new Date(e),
                                                o = new Date(n),
                                                i = Math.floor((r - o) / 1e3),
                                                a = Math.floor(i / 60),
                                                s = Math.floor(a / 60),
                                                c = Math.floor(s / 24);
                                            (i = i - 24 * c * 60 * 60 - 60 * (s -= 24 * c) * 60 - 60 * (a = a - 24 * c * 60 - 60 * s)), (n += 1e3), r < o && ((c = 0), (s = 0), (a = 0), (i = 0));
                                            var u = t.querySelectorAll("countdown-timer-days"),
                                                l = t.querySelectorAll("countdown-timer-hours"),
                                                f = t.querySelectorAll("countdown-timer-minutes"),
                                                p = t.querySelectorAll("countdown-timer-seconds");
                                            u.length &&
                                                u.forEach(function (t) {
                                                    return (t.innerHTML = c);
                                                }),
                                                l.length &&
                                                    l.forEach(function (t) {
                                                        return (t.innerHTML = s);
                                                    }),
                                                f.length &&
                                                    f.forEach(function (t) {
                                                        return (t.innerHTML = a);
                                                    }),
                                                p.length &&
                                                    p.forEach(function (t) {
                                                        return (t.innerHTML = i);
                                                    });
                                        }, 1e3))
                                      : console.warn(this, " has no now timestamp."))
                                : console.warn(this, " has no target timestamp.");
                        },
                    },
                ]),
                n
            );
        })(fe(HTMLElement)),
        me = (function (t) {
            ce(n, t);
            var e = ue(n);
            function n() {
                return ie(this, n), e.call(this);
            }
            return se(n);
        })(fe(HTMLElement)),
        be = (function (t) {
            ce(n, t);
            var e = ue(n);
            function n() {
                return ie(this, n), e.call(this);
            }
            return se(n);
        })(fe(HTMLElement)),
        ge = (function (t) {
            ce(n, t);
            var e = ue(n);
            function n() {
                return ie(this, n), e.call(this);
            }
            return se(n);
        })(fe(HTMLElement)),
        we = (function (t) {
            ce(n, t);
            var e = ue(n);
            function n() {
                return ie(this, n), e.call(this);
            }
            return se(n);
        })(fe(HTMLElement));
    function _e(t) {
        return (
            (_e =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            _e(t)
        );
    }
    function Se(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== _e(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== _e(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === _e(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function Ae(t, e) {
        if (e && ("object" === _e(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function Oe(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (Oe = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return xe(t, arguments, Te(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Pe(n, t);
            }),
            Oe(t)
        );
    }
    function xe(t, e, n) {
        return (
            (xe = Ee()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && Pe(o, n.prototype), o;
                  }),
            xe.apply(null, arguments)
        );
    }
    function Ee() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function Pe(t, e) {
        return (
            (Pe = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            Pe(t, e)
        );
    }
    function Te(t) {
        return (
            (Te = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            Te(t)
        );
    }
    const ke = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Pe(t, e);
        })(s, t);
        var e,
            r,
            o,
            i,
            a =
                ((e = s),
                (r = Ee()),
                function () {
                    var t,
                        n = Te(e);
                    if (r) {
                        var o = Te(this).constructor;
                        t = Reflect.construct(n, arguments, o);
                    } else t = n.apply(this, arguments);
                    return Ae(this, t);
                });
        function s() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, s),
                ((t = a.call(this)).loaded = !1),
                t
            );
        }
        return (
            (o = s),
            (i = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        (this.loaded = !0),
                            setTimeout(function () {
                                var e = t.getAttribute("aspect-ratio");
                                1 != t.children.length && console.warn(t, "Force aspect ratio should only have 1 child as an element"), (e && e.match(/^[0-9]+:[0-9]+$/)) || console.warn(t, "Missing or incorrect aspect-ratio attribute");
                            }, 1e3);
                        var e = this.getAttribute("aspect-ratio");
                        n(this, { position: "relative", width: "100%", "padding-top": (e.split(":")[1] / e.split(":")[0]) * 100 + "%", display: "block" }),
                            n(this.firstElementChild, { position: "absolute", top: 0, left: 0, width: "100%", height: "100%" });
                    },
                },
            ]) && Se(o.prototype, i),
            Object.defineProperty(o, "prototype", { writable: !1 }),
            s
        );
    })(Oe(HTMLElement));
    function je(t) {
        return (
            (je =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            je(t)
        );
    }
    function Ce(t, e) {
        if (e && ("object" === je(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return Le(t);
    }
    function Le(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
    }
    function $e(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            ($e = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return Me(t, arguments, De(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Re(n, t);
            }),
            $e(t)
        );
    }
    function Me(t, e, n) {
        return (
            (Me = Ie()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && Re(o, n.prototype), o;
                  }),
            Me.apply(null, arguments)
        );
    }
    function Ie() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function Re(t, e) {
        return (
            (Re = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            Re(t, e)
        );
    }
    function De(t) {
        return (
            (De = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            De(t)
        );
    }
    function Ne(t) {
        return t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    const Fe = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Re(t, e);
        })(i, t);
        var e,
            n,
            r,
            o =
                ((e = i),
                (n = Ie()),
                function () {
                    var t,
                        r = De(e);
                    if (n) {
                        var o = De(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return Ce(this, t);
                });
        function i() {
            var t;
            !(function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            })(this, i),
                ((t = o.call(this)).innerHTML = 0);
            var e = new IntersectionObserver(
                function (e) {
                    var n,
                        r = e[0],
                        o = r.target;
                    if (!0 === r.isIntersecting && !o.getAttribute("animated")) {
                        t.setAttribute("animated", !0);
                        var i = parseFloat(t.getAttribute("to")),
                            a = parseFloat(t.getAttribute("speed")) || 1e3,
                            s = parseFloat(t.getAttribute("step")) || "auto";
                        !(function (t, e, n, r) {
                            var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
                                i = arguments.length > 5 ? arguments[5] : void 0,
                                a = null,
                                s = function s(c) {
                                    a || (a = c);
                                    var u = Math.min((c - a) / r, 1),
                                        l = u * (n - e + e);
                                    "auto" != i && (l = Math.floor(l / i) * i) + i > n && (l = n);
                                    var f = Ne(l.toFixed(o));
                                    (t.innerHTML = f), u < 1 && window.requestAnimationFrame(s);
                                };
                            window.requestAnimationFrame(s);
                        })(Le(t), 0, i, a, ((n = i), Math.floor(n) === n || -1 == (n + "").indexOf(".") ? 0 : n.toString().split(".")[1].length || 0), s);
                    }
                },
                { threshold: [0.5] }
            );
            return (
                setTimeout(function () {
                    e.observe(Le(t));
                }, 1e3),
                t
            );
        }
        return (r = i), Object.defineProperty(r, "prototype", { writable: !1 }), r;
    })($e(HTMLElement));
    function qe(t) {
        return (
            (qe =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            qe(t)
        );
    }
    function He(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== qe(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== qe(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === qe(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function Be(t, e) {
        if (e && ("object" === qe(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function Ue(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (Ue = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return We(t, arguments, Ke(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), ze(n, t);
            }),
            Ue(t)
        );
    }
    function We(t, e, n) {
        return (
            (We = Ve()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && ze(o, n.prototype), o;
                  }),
            We.apply(null, arguments)
        );
    }
    function Ve() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function ze(t, e) {
        return (
            (ze = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            ze(t, e)
        );
    }
    function Ke(t) {
        return (
            (Ke = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            Ke(t)
        );
    }
    const Ge = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && ze(t, e);
        })(s, t);
        var e,
            r,
            o,
            i,
            a =
                ((e = s),
                (r = Ve()),
                function () {
                    var t,
                        n = Ke(e);
                    if (r) {
                        var o = Ke(this).constructor;
                        t = Reflect.construct(n, arguments, o);
                    } else t = n.apply(this, arguments);
                    return Be(this, t);
                });
        function s() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, s),
                ((t = a.call(this)).loaded = !1),
                t
            );
        }
        return (
            (o = s),
            (i = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        this.loaded = !0;
                        var e = this.getAttribute("source"),
                            r = this.getAttribute("poster"),
                            o = this.getAttribute("alt"),
                            i = this.getAttribute("title"),
                            a = this.getAttribute("button_aria"),
                            s = this.getAttribute("tabindex");
                        if (e)
                            if (i) {
                                var c = document.createElement("iframe");
                                if ((c.setAttribute("src", e), c.setAttribute("title", i), s && c.setAttribute("tabindex", s), n(c, { width: "100%", height: "100%" }), r)) {
                                    var u = document.createElement("div"),
                                        l = document.createElement("button"),
                                        f = document.createElement("img");
                                    f.setAttribute("loading", "lazy"),
                                        f.setAttribute("alt", o),
                                        f.setAttribute("src", r),
                                        l.setAttribute("aria-label", a),
                                        (l.innerText = "Play"),
                                        n(u, { position: "relative", width: "100%", height: "100%" }),
                                        n(f, { width: "100%", height: "100%" }),
                                        n(l, { position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 1 }),
                                        this.append(u),
                                        u.append(f),
                                        u.append(l),
                                        l.addEventListener("click", function (e) {
                                            var n,
                                                r,
                                                o,
                                                i = ((r = -1 !== (n = c.getAttribute("src")).indexOf("?") ? "&" : "?"), (o = "autoplay=1"), -1 !== n.indexOf(o) || (n += r + o), n);
                                            c.setAttribute("src", i), c.setAttribute("allow", "autoplay"), c.setAttribute("allowFullScreen", "true"), t.append(c), u.remove();
                                        });
                                } else 0 != c.src.indexOf("autoplay=1") && (c.setAttribute("allow", "autoplay"), c.setAttribute("allowFullScreen", "true")), this.append(c);
                                n(this, { display: "block" });
                            } else console.warn("ada video must have a title");
                        else console.warn("ada video must have a source");
                    },
                },
            ]) && He(o.prototype, i),
            Object.defineProperty(o, "prototype", { writable: !1 }),
            s
        );
    })(Ue(HTMLElement));
    function Ye(t) {
        return (
            (Ye =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            Ye(t)
        );
    }
    function Xe(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== Ye(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== Ye(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === Ye(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function Je(t, e) {
        if (e && ("object" === Ye(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function Ze(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (Ze = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return Qe(t, arguments, nn(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), en(n, t);
            }),
            Ze(t)
        );
    }
    function Qe(t, e, n) {
        return (
            (Qe = tn()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && en(o, n.prototype), o;
                  }),
            Qe.apply(null, arguments)
        );
    }
    function tn() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function en(t, e) {
        return (
            (en = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            en(t, e)
        );
    }
    function nn(t) {
        return (
            (nn = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            nn(t)
        );
    }
    const rn = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && en(t, e);
        })(a, t);
        var e,
            n,
            r,
            o,
            i =
                ((e = a),
                (n = tn()),
                function () {
                    var t,
                        r = nn(e);
                    if (n) {
                        var o = nn(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return Je(this, t);
                });
        function a() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, a),
                ((t = i.call(this)).loaded = !1),
                t
            );
        }
        return (
            (r = a),
            (o = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        (this.loaded = !0),
                            (this.style.display = "block"),
                            (this._maxDistance = parseFloat(this.getAttribute("max-distance")) || 99999),
                            (this._speed = parseFloat(this.getAttribute("speed")) || 0.25),
                            setTimeout(function () {
                                var e;
                                (t._initialTopDistance = t.getBoundingClientRect().top + document.documentElement.scrollTop),
                                    window.addEventListener(
                                        "scroll",
                                        ((e = Date.now()),
                                        function () {
                                            e + 14 - Date.now() < 0 && (t._move_and_slide(!1), (e = Date.now()));
                                        })
                                    ),
                                    t._move_and_slide(!0);
                            }, 50);
                    },
                },
                {
                    key: "_move_and_slide",
                    value: function (t) {
                        var e = window.pageYOffset,
                            n = (this._initialTopDistance - window.innerHeight / 2 + this.offsetHeight / 2 - e) * this._speed;
                        if (Math.abs(n) < Math.abs(this._maxDistance)) this.style.transform = "translateY(" + n + "px)";
                        else {
                            var r = n < 0 ? -this._maxDistance : this._maxDistance;
                            this.style.transform = "translateY(" + r + "px)";
                        }
                    },
                },
            ]) && Xe(r.prototype, o),
            Object.defineProperty(r, "prototype", { writable: !1 }),
            a
        );
    })(Ze(HTMLElement));
    function on(t) {
        return (
            (on =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            on(t)
        );
    }
    function an(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== on(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== on(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === on(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function sn(t, e) {
        if (e && ("object" === on(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function cn(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (cn = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return un(t, arguments, pn(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), fn(n, t);
            }),
            cn(t)
        );
    }
    function un(t, e, n) {
        return (
            (un = ln()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && fn(o, n.prototype), o;
                  }),
            un.apply(null, arguments)
        );
    }
    function ln() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function fn(t, e) {
        return (
            (fn = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            fn(t, e)
        );
    }
    function pn(t) {
        return (
            (pn = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            pn(t)
        );
    }
    const dn = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && fn(t, e);
        })(s, t);
        var e,
            r,
            o,
            i,
            a =
                ((e = s),
                (r = ln()),
                function () {
                    var t,
                        n = pn(e);
                    if (r) {
                        var o = pn(this).constructor;
                        t = Reflect.construct(n, arguments, o);
                    } else t = n.apply(this, arguments);
                    return sn(this, t);
                });
        function s() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, s),
                ((t = a.call(this)).loaded = !1),
                t
            );
        }
        return (
            (o = s),
            (i = [
                {
                    key: "connectedCallback",
                    value: function () {
                        if (this.loaded) return !1;
                        (this.loaded = !0),
                            n(this, { display: "block", position: "static" == getComputedStyle(this).position ? "relative" : "", backgroundColor: this.getAttribute("background-color") ? this.getAttribute("background-color") : "" });
                        var t = this.getAttribute("type"),
                            e = document.createElement("div"),
                            r = document.querySelector(this.getAttribute("target"));
                        n(e, {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "vertical" == t ? "100%" : 0,
                            height: "vertical" == t ? 0 : "100%",
                            backgroundColor: this.getAttribute("foreground-color") ? this.getAttribute("foreground-color") : "",
                            transition: "250ms",
                        }),
                            this.append(e),
                            window.addEventListener("scroll", function (n) {
                                var o = r.getBoundingClientRect().top + document.documentElement.scrollTop - window.innerHeight / 2,
                                    i = o + r.offsetHeight,
                                    a = window.scrollY,
                                    s = ((a - o) / r.offsetHeight) * 100;
                                a > o && a < i && ("vertical" == t ? (e.style.height = s + "%") : (e.style.width = s + "%")),
                                    a < o && ("vertical" == t ? (e.style.height = "0%") : (e.style.width = "0%")),
                                    a > i && ("vertical" == t ? (e.style.height = "100%") : (e.style.width = "100%"));
                            });
                    },
                },
            ]) && an(o.prototype, i),
            Object.defineProperty(o, "prototype", { writable: !1 }),
            s
        );
    })(cn(HTMLElement));
    function hn(t) {
        return (
            (hn =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            hn(t)
        );
    }
    function vn(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== hn(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== hn(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === hn(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function yn(t, e) {
        if (e && ("object" === hn(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function mn(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (mn = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return bn(t, arguments, _n(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), wn(n, t);
            }),
            mn(t)
        );
    }
    function bn(t, e, n) {
        return (
            (bn = gn()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && wn(o, n.prototype), o;
                  }),
            bn.apply(null, arguments)
        );
    }
    function gn() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function wn(t, e) {
        return (
            (wn = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            wn(t, e)
        );
    }
    function _n(t) {
        return (
            (_n = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            _n(t)
        );
    }
    const Sn = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && wn(t, e);
        })(s, t);
        var e,
            r,
            o,
            i,
            a =
                ((e = s),
                (r = gn()),
                function () {
                    var t,
                        n = _n(e);
                    if (r) {
                        var o = _n(this).constructor;
                        t = Reflect.construct(n, arguments, o);
                    } else t = n.apply(this, arguments);
                    return yn(this, t);
                });
        function s() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, s),
                ((t = a.call(this)).loaded = !1),
                t
            );
        }
        return (
            (o = s),
            (i = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        (this.loaded = !0),
                            n(this, { display: "block", position: "absolute", top: 0 }),
                            window.addEventListener("scroll", function (e) {
                                var n = t.parentNode.getBoundingClientRect().top + document.documentElement.scrollTop,
                                    r = n + t.parentNode.offsetHeight,
                                    o = window.scrollY;
                                return t.offsetHeight + o >= r
                                    ? ((t.style.position = "absolute"), (t.style.top = ""), (t.style.bottom = 0), !1)
                                    : o > n && o < r
                                    ? ((t.style.position = "fixed"), (t.style.top = 0), (t.style.bottom = ""), !1)
                                    : o < n
                                    ? ((t.style.position = "absolute"), (t.style.top = 0), (t.style.bottom = ""), !1)
                                    : void 0;
                            });
                    },
                },
            ]) && vn(o.prototype, i),
            Object.defineProperty(o, "prototype", { writable: !1 }),
            s
        );
    })(mn(HTMLElement));
    function An(t) {
        return (
            (An =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            An(t)
        );
    }
    function On(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== An(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== An(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === An(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function xn(t, e) {
        if (e && ("object" === An(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function En(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (En = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return Pn(t, arguments, jn(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), kn(n, t);
            }),
            En(t)
        );
    }
    function Pn(t, e, n) {
        return (
            (Pn = Tn()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && kn(o, n.prototype), o;
                  }),
            Pn.apply(null, arguments)
        );
    }
    function Tn() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function kn(t, e) {
        return (
            (kn = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            kn(t, e)
        );
    }
    function jn(t) {
        return (
            (jn = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            jn(t)
        );
    }
    function Cn(t, e) {
        if ("BODY" == t.tagName) return !1;
        Array.from(t.parentNode.children).forEach(function (n) {
            n != t &&
                (e
                    ? (n.hasAttribute("aria-hidden") && !n.hasAttribute("data-original-aria-hidden") && n.setAttribute("data-original-aria-hidden", n.getAttribute("aria-hidden")), n.setAttribute("aria-hidden", !0))
                    : n.hasAttribute("data-original-aria-hidden")
                    ? (n.setAttribute("aria-hidden", n.getAttribute("data-original-aria-hidden")), n.removeAttribute("data-original-aria-hidden"))
                    : n.removeAttribute("aria-hidden"));
        }),
            Cn(t.parentNode, e);
    }
    var Ln = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && kn(t, e);
        })(s, t);
        var e,
            n,
            r,
            o,
            i,
            a =
                ((e = s),
                (n = Tn()),
                function () {
                    var t,
                        r = jn(e);
                    if (n) {
                        var o = jn(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return xn(this, t);
                });
        function s() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, s),
                ((t = a.call(this)).loaded = !1),
                t
            );
        }
        return (
            (r = s),
            (o = [
                {
                    key: "attributeChangedCallback",
                    value: function (t, e, n) {
                        if (!this.loaded) return !1;
                        if ("true" == n) {
                            var r = this.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                            r.length ? r[0].focus() : this.focus(), Cn(this, !0);
                        } else Cn(this, !1);
                    },
                },
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        (this.loaded = !0),
                            this.getAttribute("tabindex") || this.setAttribute("tabindex", -1),
                            document.addEventListener("keydown", function (e) {
                                return t.checkForOutsideFocus(e);
                            }),
                            document.addEventListener("click", function (e) {
                                return t.checkForOutsideFocus(e);
                            }),
                            this.addEventListener("keydown", function (e) {
                                var n = "Tab" === e.key || 9 === e.keyCode;
                                if ("false" != t.getAttribute("active") && n) {
                                    var r = t.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
                                        o = r.length ? r[0] : t,
                                        i = r.length ? r[r.length - 1] : t;
                                    e.shiftKey ? document.activeElement === o && (i.focus(), e.preventDefault()) : document.activeElement === i && (o.focus(), e.preventDefault());
                                }
                            });
                    },
                },
                {
                    key: "checkForOutsideFocus",
                    value: function (t) {
                        var e = document.activeElement.closest("focus-trap");
                        "true" != this.getAttribute("active") || (e && e == this) || this.setAttribute("active", !1);
                    },
                },
            ]),
            (i = [
                {
                    key: "observedAttributes",
                    get: function () {
                        return ["active"];
                    },
                },
            ]),
            o && On(r.prototype, o),
            i && On(r, i),
            Object.defineProperty(r, "prototype", { writable: !1 }),
            s
        );
    })(En(HTMLElement));
    const $n = Ln;
    function Mn(t) {
        return (
            (Mn =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            Mn(t)
        );
    }
    function In(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== Mn(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== Mn(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === Mn(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function Rn(t, e) {
        if (e && ("object" === Mn(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        })(t);
    }
    function Dn(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (Dn = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return Nn(t, arguments, Hn(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), qn(n, t);
            }),
            Dn(t)
        );
    }
    function Nn(t, e, n) {
        return (
            (Nn = Fn()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && qn(o, n.prototype), o;
                  }),
            Nn.apply(null, arguments)
        );
    }
    function Fn() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function qn(t, e) {
        return (
            (qn = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            qn(t, e)
        );
    }
    function Hn(t) {
        return (
            (Hn = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            Hn(t)
        );
    }
    var Bn = s(function (t) {
        return Un(t);
    });
    function Un(t) {
        var e = document.querySelector(t.getAttribute("target"));
        if (e) {
            var r = t.offsetTop,
                o = document.querySelector("#wpadminbar");
            o && (r += o.offsetHeight), n(e, { position: "absolute", top: "".concat(r, "px"), left: "".concat(t.offsetLeft, "px"), width: "".concat(t.offsetWidth, "px") }), n(t, { height: "".concat(e.offsetHeight, "px") });
        }
    }
    const Wn = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && qn(t, e);
        })(a, t);
        var e,
            n,
            r,
            o,
            i =
                ((e = a),
                (n = Fn()),
                function () {
                    var t,
                        r = Hn(e);
                    if (n) {
                        var o = Hn(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return Rn(this, t);
                });
        function a() {
            var t;
            return (
                (function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, a),
                ((t = i.call(this)).loaded = !1),
                t
            );
        }
        return (
            (r = a),
            (o = [
                {
                    key: "connectedCallback",
                    value: function () {
                        var t = this;
                        if (this.loaded) return !1;
                        (this.loaded = !0),
                            (this.style.display = "block"),
                            document.addEventListener("DOMContentLoaded", function () {
                                return Un(t);
                            }),
                            window.addEventListener("resize", function () {
                                return Bn(t);
                            }),
                            window.addEventListener("scroll", function () {
                                return Bn(t);
                            }),
                            setTimeout(function () {
                                return Un(t);
                            }, 500);
                    },
                },
            ]) && In(r.prototype, o),
            Object.defineProperty(r, "prototype", { writable: !1 }),
            a
        );
    })(Dn(HTMLElement));
    function Vn(t) {
        return (
            (Vn =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            Vn(t)
        );
    }
    function zn(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function Kn(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== Vn(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== Vn(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === Vn(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function Gn(t, e, n) {
        return e && Kn(t.prototype, e), n && Kn(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
    }
    function Yn(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && nr(t, e);
    }
    function Xn(t) {
        var e = er();
        return function () {
            var n,
                r = rr(t);
            if (e) {
                var o = rr(this).constructor;
                n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);
            return Jn(this, n);
        };
    }
    function Jn(t, e) {
        if (e && ("object" === Vn(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return Zn(t);
    }
    function Zn(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
    }
    function Qn(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (Qn = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return tr(t, arguments, rr(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), nr(n, t);
            }),
            Qn(t)
        );
    }
    function tr(t, e, n) {
        return (
            (tr = er()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && nr(o, n.prototype), o;
                  }),
            tr.apply(null, arguments)
        );
    }
    function er() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function nr(t, e) {
        return (
            (nr = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            nr(t, e)
        );
    }
    function rr(t) {
        return (
            (rr = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            rr(t)
        );
    }
    var or = (function (t) {
            Yn(n, t);
            var e = Xn(n);
            function n() {
                return zn(this, n), e.call(this);
            }
            return (
                Gn(n, [
                    {
                        key: "connectedCallback",
                        value: function () {
                            (this.perPage = this.hasAttribute("items-per-page") ? parseInt(this.getAttribute("items-per-page")) : 4),
                                (this.page = 1),
                                (this.maxPages = 1),
                                (this.itemsSelector = this.hasAttribute("items-selector") ? this.getAttribute("items-selector") : null),
                                (this.items = []),
                                this.itemsSelector && ((this.items = document.querySelectorAll(this.itemsSelector)), this.items.length && ((this.maxPages = Math.ceil(this.items.length / this.perPage)), this._updateVisibleItems()));
                        },
                    },
                    { key: "disconnectedCallback", value: function () {} },
                    { key: "attributeChangedCallback", value: function (t, e, n) {} },
                    {
                        key: "_updateVisibleItems",
                        value: function () {
                            for (
                                var t = this,
                                    e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                                    n = (this.page - 1) * this.perPage,
                                    r = this.page * this.perPage - 1,
                                    o = this.querySelector("inline-pagination-prev"),
                                    i = this.querySelector("inline-pagination-next"),
                                    a = Array.from(this.querySelectorAll(".inline-pagination-page")),
                                    s = this.hasAttribute("load-more") && "true" == this.getAttribute("load-more"),
                                    c = 0;
                                c < this.items.length;
                                c++
                            )
                                s ? (c <= r ? this._showItem(c) : this._hideItem(c)) : c >= n && c <= r ? this._showItem(c) : this._hideItem(c);
                            o && (1 == this.page ? (o.parentNode.style.display = "none") : (o.parentNode.style.display = "")),
                                i && (this.page == this.maxPages ? (i.parentNode.style.display = "none") : (i.parentNode.style.display = "")),
                                a.length &&
                                    (a.forEach(function (t) {
                                        t.classList.remove("active"), t.setAttribute("aria-current", !1);
                                    }),
                                    a[this.page - 1].classList.add("active"),
                                    a[this.page - 1].setAttribute("aria-current", !0)),
                                e &&
                                    setTimeout(function () {
                                        t.items[n].setAttribute("tabindex", -1), t.items[n].focus();
                                    });
                        },
                    },
                    {
                        key: "_showItem",
                        value: function (t) {
                            this.items[t].style.display = "";
                        },
                    },
                    {
                        key: "_hideItem",
                        value: function (t) {
                            this.items[t].style.display = "none";
                        },
                    },
                    {
                        key: "goToPrevPage",
                        value: function () {
                            this.page > 1 && ((this.page -= 1), this._updateVisibleItems(!0));
                        },
                    },
                    {
                        key: "goToNextPage",
                        value: function () {
                            this.page != this.maxPages && ((this.page += 1), this._updateVisibleItems(!0));
                        },
                    },
                    {
                        key: "goToPage",
                        value: function (t) {
                            this.page != t && ((this.page = t), this._updateVisibleItems(!0));
                        },
                    },
                ]),
                n
            );
        })(Qn(HTMLElement)),
        ir = (function (t) {
            Yn(n, t);
            var e = Xn(n);
            function n() {
                var t;
                zn(this, n);
                var o = r(Zn((t = e.call(this))), "button");
                return (
                    t.hasAttribute("aria-label") ? (o.setAttribute("aria-label", t.getAttribute("aria-label")), t.removeAttribute("aria-label")) : o.setAttribute("aria-label", "Previous page"),
                    o.addEventListener("click", function () {
                        return o.parentNode.goToPrevPage();
                    }),
                    t
                );
            }
            return Gn(n);
        })(Qn(HTMLElement)),
        ar = (function (t) {
            Yn(n, t);
            var e = Xn(n);
            function n() {
                var t;
                zn(this, n);
                var o = r(Zn((t = e.call(this))), "button");
                return (
                    t.hasAttribute("aria-label") ? (o.setAttribute("aria-label", t.getAttribute("aria-label")), t.removeAttribute("aria-label")) : o.setAttribute("aria-label", "Next page"),
                    o.addEventListener("click", function () {
                        return o.parentNode.goToNextPage();
                    }),
                    t
                );
            }
            return Gn(n);
        })(Qn(HTMLElement)),
        sr = (function (t) {
            Yn(n, t);
            var e = Xn(n);
            function n() {
                var t;
                zn(this, n);
                var r = Zn((t = e.call(this)));
                t.style.display = "none";
                for (
                    var o = function (e) {
                            var n,
                                o,
                                i = document.createElement("button");
                            i.classList.add("inline-pagination-page"),
                                i.setAttribute("aria-label", "Go to page ".concat(e)),
                                (i.innerText = t.innerText.replace("${i}", e)),
                                (n = i),
                                (o = r).parentNode.insertBefore(n, o.nextSibling),
                                i.addEventListener("click", function () {
                                    return t.parentNode.goToPage(e);
                                }),
                                (r = i);
                        },
                        i = 1;
                    i <= t.parentNode.maxPages;
                    i++
                )
                    o(i);
                return t.parentNode._updateVisibleItems(), t;
            }
            return Gn(n);
        })(Qn(HTMLElement));
    function cr(t) {
        return (
            (cr =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            cr(t)
        );
    }
    function ur(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== cr(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== cr(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === cr(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function lr(t, e) {
        if (e && ("object" === cr(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return fr(t);
    }
    function fr(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
    }
    function pr(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (pr = function (t) {
                if (
                    null === t ||
                    !(function (t) {
                        return -1 !== Function.toString.call(t).indexOf("[native code]");
                    })(t)
                )
                    return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return dr(t, arguments, yr(this).constructor);
                }
                return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), vr(n, t);
            }),
            pr(t)
        );
    }
    function dr(t, e, n) {
        return (
            (dr = hr()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && vr(o, n.prototype), o;
                  }),
            dr.apply(null, arguments)
        );
    }
    function hr() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function vr(t, e) {
        return (
            (vr = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            vr(t, e)
        );
    }
    function yr(t) {
        return (
            (yr = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            yr(t)
        );
    }
    var mr = (function (t) {
        !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && vr(t, e);
        })(u, t);
        var e,
            o,
            a,
            s,
            c =
                ((e = u),
                (o = hr()),
                function () {
                    var t,
                        n = yr(e);
                    if (o) {
                        var r = yr(this).constructor;
                        t = Reflect.construct(n, arguments, r);
                    } else t = n.apply(this, arguments);
                    return lr(this, t);
                });
        function u() {
            var t;
            !(function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            })(this, u);
            var e = (t = c.call(this)).getAttribute("target");
            return (t.targetSvg = document.querySelector("".concat(e))), t.targetSvg ? t._init() : console.error(fr(t), "Could not find ".concat(e)), t;
        }
        return (
            (a = u),
            (s = [
                {
                    key: "_init",
                    value: function () {
                        if (this.targetSvg.getAttribute("viewBox"))
                            if (1 == this.targetSvg.children.length)
                                if (this.targetSvg.hasAttribute("converted")) {
                                    var t = this.targetSvg.children[0];
                                    n(this, { display: "block", clipPath: "url(#".concat(t.id, ")") });
                                } else {
                                    this.targetSvg.setAttribute("converted", !0), r(this.targetSvg, "defs").setAttribute("height", 0), this.targetSvg.setAttribute("height", 0);
                                    var e = this.targetSvg
                                        .getAttribute("viewBox")
                                        .split(" ")
                                        .map(function (t) {
                                            return parseInt(t);
                                        });
                                    this.targetSvg.removeAttribute("viewbox");
                                    var o = r(this.targetSvg.children[0], "clipPath", "http://www.w3.org/2000/svg");
                                    o.setAttributeNS(null, "clipPathUnits", "objectBoundingBox"), (o.id = i());
                                    var a = 1 / e[2],
                                        s = 1 / e[3];
                                    o.children[0].setAttribute("transform", "scale(".concat(a, " ").concat(s, ")")), n(this, { display: "block", clipPath: "url(#".concat(o.id, ")") });
                                }
                            else console.error(this.targetSvg, "SVG may only contain one child");
                        else console.error(this.targetSvg, "Missing viewBox");
                    },
                },
            ]),
            s && ur(a.prototype, s),
            Object.defineProperty(a, "prototype", { writable: !1 }),
            u
        );
    })(pr(HTMLElement));
    function br(t, e) {
        const n = [];
        for (let r = 0; r < t.length; r += e) {
            const o = t.slice(r, r + e);
            n.push(o);
        }
        return n;
    }
    function gr(t) {
        const e = window.getComputedStyle(t).getPropertyValue("transform");
        return new DOMMatrixReadOnly(e).m41;
    }
    function wr(t, e) {
        const n = [...t.querySelectorAll('a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])')].filter((t) => !t.hasAttribute("disabled") && !t.getAttribute("aria-hidden"));
        n &&
            n.forEach((t) => {
                e ? t.removeAttribute("tabindex") : t.setAttribute("tabindex", -1);
            });
    }
    class _r extends HTMLElement {
        constructor() {
            super(),
                (this.allowEmptySpaces = !1),
                (this.shouldFocus = !1),
                (this.swipeThreshold = this.hasAttribute("swipe-threshold") ? parseInt(this.getAttribute("swipe-threshold")) : 100),
                (this.slideSpeed = this.hasAttribute("slide-speed") ? parseInt(this.getAttribute("slide-speed")) : 1e3),
                (this.autoplay = !!this.hasAttribute("autoplay") && "true" == this.getAttribute("autoplay")),
                (this.autoplaySpeed = this.hasAttribute("autoplay-speed") ? parseInt(this.getAttribute("autoplay-speed")) : 12e3),
                (this.slideAlignment = this.hasAttribute("slide-alignment") ? this.getAttribute("slide-alignment") : "stretch"),
                (this.adaptiveHeight = !!this.hasAttribute("adaptive-height") && "true" === this.getAttribute("adaptive-height"));
            const t = this.attachShadow({ mode: "open" }),
                e = document.createElement("template");
            (e.innerHTML = `\n      <style>\n        :host {\n          overflow: hidden;\n          display: block;\n        }\n\n        .viewport {\n          display: flex;\n          align-items: ${this.slideAlignmentValue};\n          transition-duration: ${this.slideSpeed}ms;\n          transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1.0);\n          position: relative;\n          will-change: transform height;\n        }\n        .viewport.animations-disabled {\n          transition: none;\n        }\n\n        ::slotted(*) {\n          flex-shrink: 0;\n        }\n      </style>\n      <div class='viewport animations-disabled'>\n        <slot></slot>\n      </div>\n    `),
                t.appendChild(e.content.cloneNode(!0)),
                (this._viewport = t.querySelector(".viewport")),
                (this._isAnimating = !1),
                (this._originalChildren = Array.from(this.children)),
                (this._pages = br(Array.from(this.children), this.slidesPerPage)),
                (this.currentPage = 0),
                (this._isAutoplaying = this.autoplay),
                (this.isAutoplaying = this._isAutoplaying),
                this._autoplayInterval,
                this._originalmouseDown,
                (this._mouseDownTransformX = 0),
                (this._mouseDownReal = 0),
                (function (t, e, n, r, o, i) {
                    let a = 0,
                        s = 0,
                        c = 0,
                        u = 0,
                        l = !1;
                    t.addEventListener(
                        "touchstart",
                        function (t) {
                            (a = t.touches[0].clientX), (s = t.touches[0].clientX), o(a);
                        },
                        { passive: !1 }
                    ),
                        t.addEventListener(
                            "touchmove",
                            function (t) {
                                Math.abs(s - a) >= 30 && (t.preventDefault(), t.stopPropagation(), r(s - a)), (s = t.touches[0].clientX);
                            },
                            { passive: !1 }
                        ),
                        t.addEventListener(
                            "touchend",
                            function (t) {
                                i(s);
                            },
                            { passive: !1 }
                        ),
                        t.addEventListener("mousedown", function (t) {
                            (c = t.clientX), (l = !0), o(c);
                        }),
                        t.addEventListener("mousemove", function (t) {
                            l && r(u - c), (u = t.clientX);
                        }),
                        t.addEventListener("mouseup", function (t) {
                            l && (i(u), (l = !1));
                        }),
                        t.addEventListener("mouseleave", function (t) {
                            l && (i(u), (l = !1));
                        });
                })(
                    this._viewport,
                    0,
                    0,
                    (t) => {
                        if (this.slidesPerPage >= this._originalChildren.length) return;
                        if (this._isAnimating) return !1;
                        let e = gr(this._viewport);
                        (e = this._mouseDownTransformX + t), this._viewport.classList.add("animations-disabled"), (this._viewport.style.transform = `translate3D(${e}px, 0, 0)`), (this.isAutoplaying = !1);
                    },
                    (t) => {
                        if (this._isAnimating) return !1;
                        let e = gr(this._viewport);
                        (this._mouseDownTransformX = e), (this._mouseDownReal = t);
                    },
                    (t) => {
                        if (this._isAnimating) return !1;
                        this.slidesPerPage >= this._originalChildren.length ||
                            (t - this._mouseDownReal >= this.swipeThreshold
                                ? ((this.shouldFocus = !0), (this.currentPage -= 1))
                                : this._mouseDownReal - t >= this.swipeThreshold
                                ? ((this.shouldFocus = !0), (this.currentPage += 1))
                                : (this._viewport.style.transform = `translate3D(${this._mouseDownTransformX}px, 0, 0)`));
                    }
                );
            let n = window.innerWidth;
            window.addEventListener("resize", (t) => {
                const e = window.innerWidth;
                e !== n && ((n = e), this._handleScreenResize());
            }),
                this._handleScreenResize(),
                this._warnIfMissingElements(),
                (this.currentPage = this._currentPage);
        }
        get slidesPerPage() {
            let t = this.hasAttribute("slides-per-page") ? parseInt(this.getAttribute("slides-per-page")) : 1;
            return (
                this._collectResponsiveBreakpoints().forEach((e) => {
                    e.width >= window.innerWidth && (t = e.count);
                }),
                t
            );
        }
        get slideAlignmentValue() {
            return "bottom" == this.slideAlignment ? "flex-end" : "top" == this.slideAlignment ? "flex-start" : this.slideAlignment;
        }
        set currentPage(t) {
            if (this._isAnimating || parseInt(t) == this._currentPage) return;
            (this._currentPage = parseInt(t)), this.dispatchEvent(new Event("pageUpdated"));
            let e = this._currentPage * this.offsetWidth * -1;
            !this.allowEmptySpaces && this._currentPageWouldShowEmptySpace() && (e = (this._originalChildren.length - this.slidesPerPage) * this.slideWidth * -1),
                !this.allowEmptySpaces &&
                    this.slidesPerPage > 1 &&
                    (-1 == this._currentPage || this._currentPage == this.totalPages) &&
                    (this._currentPage == this.totalPages && (e = -1 * this._originalChildren.length * this.slideWidth), -1 == this._currentPage && (e = this.slidesPerPage * this.slideWidth)),
                (this._viewport.style.transform = `translate3D(${e}px, 0, 0)`),
                (this._isAnimating = !0),
                this._viewport.classList.remove("animations-disabled"),
                setTimeout(() => this._animationFinished(), this.slideSpeed + 1);
        }
        get slideWidth() {
            return this.offsetWidth / this.slidesPerPage;
        }
        get currentPage() {
            let t = this._currentPage;
            return -1 == this._currentPage ? (t = this.totalPages - 1) : this._currentPage == this.totalPages && (t = 0), t;
        }
        get totalPages() {
            return this._pages.length;
        }
        set isAutoplaying(t) {
            (this._isAutoplaying = t),
                t
                    ? (this._autoplayInterval = setInterval(() => {
                          //if (window.innerWidth <= 768) return console.warn("Skipping autoplay on mobile."), void (this.isAutoplaying = !1);
                          this.currentPage += 1;
                      }, this.autoplaySpeed))
                    : clearInterval(this._autoplayInterval),
                this.dispatchEvent(new Event("autoplayStateChanged"));
        }
        get isAutoplaying() {
            return this._isAutoplaying;
        }
        _animationFinished() {
            if (((this._isAnimating = !1), -1 == this._currentPage)) {
                this._viewport.classList.add("animations-disabled");
                let t = (this._pages.length - 1) * this.offsetWidth * -1;
                if (!this.allowEmptySpaces && this._currentPageWouldShowEmptySpace()) {
                    const e = this._originalChildren.length - this.slidesPerPage;
                    t = e * this.slideWidth * -1;
                }
                setTimeout(() => (this._viewport.style.transform = `translate3D(${t}px, 0, 0)`)), (this._currentPage = this._pages.length - 1);
            } else this._currentPage == this.totalPages && (this._viewport.classList.add("animations-disabled"), setTimeout(() => (this._viewport.style.transform = "translate3D(0, 0, 0)"), 10), (this._currentPage = 0));
            this._updateSlideAriaAndFocus(),
                !this.isAutoplaying && this.shouldFocus && ((this.shouldFocus = !1), this._pages[this._currentPage][0].focus({ preventScroll: !0 })),
                this.adaptiveHeight &&
                    setTimeout(() => {
                        this._viewport.classList.remove("animations-disabled");
                        const t = this._getTallestVisibleSlide();
                        t && (this._viewport.style.height = t.offsetHeight + "px");
                    }, 20);
        }
        _getTallestVisibleSlide() {
            const t = gr(this._viewport),
                e = this._originalChildren;
            let n = null,
                r = 0;
            for (let o = 0; o < e.length; o++) {
                const i = e[o],
                    a = i.offsetLeft - this._viewport.offsetLeft;
                if (a >= t && a < Math.abs(t) + this._viewport.offsetWidth) {
                    const t = i.offsetHeight;
                    t > r && ((r = t), (n = i));
                }
            }
            return n;
        }
        _getCustomElementByClassName(t) {
            let e = [];
            const n = document.getElementsByTagName("*");
            for (let r = 0; r < n.length; r++) {
                const o = n[r];
                "originalConstructorName" in o && o.originalConstructorName == t && o.getAttribute("slider") == this.id && e.push(o);
            }
            return e;
        }
        _warnIfMissingElements() {
            setTimeout(() => {
                !this.autoplay || this._getCustomElementByClassName("OSliderAutoplayControls").length || console.warn("Autoplay slider is missing OSliderAutoplayControls:", this),
                    this._getCustomElementByClassName("OSliderPaginationText").length || console.warn("Slider is missing OSliderPaginationText:", this),
                    this._getCustomElementByClassName("OSliderPrev").length || console.warn("Slider is missing OSliderPrev:", this),
                    this._getCustomElementByClassName("OSliderNext").length || console.warn("Slider is missing OSliderNext:", this),
                    this._getCustomElementByClassName("OSliderPage").length < this._originalChildren.length && console.warn("Slider must have at least on OSliderPage per slide:", this);
            });
        }
        _updateSlideAriaAndFocus() {
            this._pages.forEach((t, e) => {
                t.forEach((t) => {
                    const n = e == this.currentPage;
                    t.setAttribute("aria-hidden", !n), t.setAttribute("tabindex", -1), wr(t, n), (t.style.width = `${this.slideWidth}px`);
                });
            });
        }
        _cloneSlides() {
            const t = this.querySelectorAll(".multi-pagination-placeholder, .prepend-clone, .append-clone");
            if ((t.length && t.forEach((t) => t.remove()), (this._pages = br(Array.from(this.children), this.slidesPerPage)), this.allowEmptySpaces))
                for (; this.children.length % this.slidesPerPage != 0; ) {
                    const t = document.createElement("div");
                    t.classList.add("multi-pagination-placeholder"), (t.style.width = `${this.slideWidth}px`), this.append(t);
                }
            const e = document.createElement("div");
            e.classList.add("prepend-clone"),
                e.setAttribute("aria-hidden", !0),
                (e.style.cssText = `\n      display: flex;\n      align-items: ${this.slideAlignmentValue};\n      position: absolute;\n      top: 0;\n      left: 0;\n      transform: translateX(-100%);\n      height: 100%;\n    `),
                Array.from(this.children).forEach((t) => {
                    var n = t.cloneNode(!0);
                    wr(n, !1), e.append(n);
                });
            const n = document.createElement("div");
            n.classList.add("append-clone"),
                n.setAttribute("aria-hidden", !0),
                (n.style.cssText = `\n      display: flex;\n      align-items: ${this.slideAlignmentValue};\n    `),
                Array.from(this.children).forEach((t) => {
                    var e = t.cloneNode(!0);
                    wr(e, !1), n.append(e);
                }),
                this.prepend(e),
                this.append(n);
        }
        _handleScreenResize() {
            this._updateSlideAriaAndFocus(), this._cloneSlides(), this._viewport.classList.add("animations-disabled"), (this.currentPage = 0), this.dispatchEvent(new Event("pageUpdated"));
        }
        _collectResponsiveBreakpoints() {
            return Array.from(this.attributes)
                .filter((t) => -1 !== t.name.indexOf("slides-per-page-"))
                .map((t) => ({ width: parseInt(t.name.replace("slides-per-page-", "")), count: parseInt(t.value) }));
        }
        _currentPageWouldShowEmptySpace() {
            return this._pages[this.currentPage] && this._pages[this.currentPage].length != this.slidesPerPage;
        }
    }
    class Sr extends HTMLButtonElement {
        get originalConstructorName() {
            return "OSliderNext";
        }
        constructor() {
            super(),
                (this._slider = document.getElementById(this.getAttribute("slider"))),
                this.addEventListener("click", (t) => {
                    (this._slider.shouldFocus = !0), (this._slider.isAutoplaying = !1), (this._slider.currentPage = this._slider.currentPage + 1);
                }),
                this._maybeHide(),
                window.addEventListener("resize", (t) => this._maybeHide());
        }
        _maybeHide() {
            const t = this._slider.totalPages;
            this.style.display = this.index > t - 1 || 1 == t ? "none" : "";
        }
    }
    class Ar extends HTMLButtonElement {
        get originalConstructorName() {
            return "OSliderPrev";
        }
        constructor() {
            super(),
                (this._slider = document.getElementById(this.getAttribute("slider"))),
                this.addEventListener("click", (t) => {
                    (this._slider.shouldFocus = !0), (this._slider.isAutoplaying = !1), (this._slider.currentPage = this._slider.currentPage - 1);
                }),
                this._maybeHide(),
                window.addEventListener("resize", (t) => this._maybeHide());
        }
        _maybeHide() {
            const t = this._slider.totalPages;
            this.style.display = this.index > t - 1 || 1 == t ? "none" : "";
        }
    }
    class Or extends HTMLButtonElement {
        get originalConstructorName() {
            return "OSliderPage";
        }
        constructor() {
            super(),
                (this._slider = document.getElementById(this.getAttribute("slider"))),
                this.addEventListener("click", (t) => {
                    (this._slider.shouldFocus = !0), (this._slider.isAutoplaying = !1), (this._slider.currentPage = this.index);
                }),
                this._onParentUpdate(),
                this._slider.addEventListener("pageUpdated", (t) => this._onParentUpdate());
        }
        get index() {
            return parseInt(this.getAttribute("index"));
        }
        _onParentUpdate() {
            const t = this._slider.totalPages,
                e = this._slider.slidesPerPage > 1 ? "group" : "slide";
            this.setAttribute("aria-current", this._slider.currentPage == this.index), this.setAttribute("aria-label", `Go to ${e} ${this.index + 1}`), (this.style.display = this.index > t - 1 || 1 == t ? "none" : "");
        }
    }
    class xr extends HTMLElement {
        get originalConstructorName() {
            return "OSliderAutoplayControls";
        }
        constructor() {
            super();
            const t = this.attachShadow({ mode: "open" }),
                e = document.createElement("template");
            (e.innerHTML = '\n      <slot name="play" style="display:none"></slot>\n      <slot name="pause"></slot>\n    '), t.appendChild(e.content.cloneNode(!0));
            const n = t.querySelector('slot[name="play"]'),
                r = n.assignedElements()[0],
                o = t.querySelector('slot[name="pause"]'),
                i = o.assignedElements()[0],
                a = document.getElementById(this.getAttribute("slider"));
            r.addEventListener("click", (t) => {
                (a.currentPage += 1), (a.isAutoplaying = !0), (n.style.display = "none"), (o.style.display = "");
            }),
                i.addEventListener("click", (t) => {
                    (a.isAutoplaying = !1), (n.style.display = ""), (o.style.display = "none");
                }),
                a.addEventListener("autoplayStateChanged", (t) => {
                    a.isAutoplaying ? ((n.style.display = "none"), (o.style.display = "")) : ((n.style.display = ""), (o.style.display = "none"));
                }),
                a.autoplay && ((n.style.display = "none"), (o.style.display = ""));
        }
    }
    class Er extends HTMLElement {
        get originalConstructorName() {
            return "OSliderPaginationText";
        }
        constructor() {
            super(), (this.loaded = !1);
        }
        connectedCallback() {
            if (this.loaded) return !1;
            (this.loaded = !0),
                this.setAttribute("aria-live", "polite"),
                this.setAttribute("aria-atomic", "true"),
                (this._slider = document.getElementById(this.getAttribute("slider"))),
                this._slider.addEventListener("pageUpdated", (t) => this._init()),
                this._init();
        }
        _init() {
            const t = parseInt(this._slider.currentPage) + 1,
                e = this._slider.totalPages;
            this.textContent = e > 1 ? `Page ${t} of ${e}` : "";
        }
    }
    var Pr = [];
    function Tr(t) {
        var e = 0;
        if (0 == t.length) return e;
        for (var n = 0; n < t.length; n++) (e = (e << 5) - e + t.charCodeAt(n)), (e &= e);
        return e;
    }
    function kr(t) {
        return t.replace(/[^A-Za-z0-9]/g, "").toLowerCase();
    }
    function jr(t) {
        document.querySelector(".site-notification").offsetHeight;
        var e = t.target.closest(".site-notification");
        !(function (t, e, n) {
            var r = new Date();
            r.setTime(r.getTime() + 31536e6);
            var o = "expires=" + r.toUTCString();
            document.cookie = t + "=1;" + o + ";path=/";
        })("notification-" + Tr(kr(e.querySelector(".editor-content").innerText))),
            (e.style.display = "none");
    }
    const Cr = function () {
        (Pr = document.querySelectorAll(".site-notification")).length &&
            (Pr.forEach(function (t) {
                var e = (function (t) {
                    for (var e = t + "=", n = decodeURIComponent(document.cookie).split(";"), r = 0; r < n.length; r++) {
                        for (var o = n[r]; " " == o.charAt(0); ) o = o.substring(1);
                        if (0 == o.indexOf(e)) return o.substring(e.length, o.length);
                    }
                    return "";
                })("notification-" + Tr(kr(t.querySelector(".editor-content").innerText)));
                e || (t.style.display = "block");
            }),
            document.querySelectorAll(".site-notification--close").forEach(function (t) {
                return t.addEventListener("click", jr);
            }));
    };
    function Lr(t) {
        return (
            (Lr =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            Lr(t)
        );
    }
    function $r(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== Lr(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== Lr(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === Lr(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    var Mr = (function () {
        function t(e, n) {
            var r = this;
            !(function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            })(this, t),
                (this.el = document.querySelector(e)),
                (this.options = Object.assign(
                    {
                        menuTogglerContainer: "",
                        menuDisplayWhenOpen: "block",
                        slideDuration: 450,
                        subMenuDisplayWhenOpen: "block",
                        menuToggler: "",
                        menuFillsScreenHeightOnToggle: !0,
                        menuFillAccountsForHeaderHeight: !0,
                        mobileSwitch: 768,
                        setHiddenWhenMobileMenuIsToggled: [],
                        mobileSubMenusAutomaticallyClose: !1,
                        megamenuClass: "mega-menu-link",
                    },
                    n
                )),
                (this.timeoutAnimationInstances = []),
                this._createFirstSubMenuFromParent(),
                this._addAria(),
                this._enableKeyboardNavigation(),
                this._enableDesktopHoverSubmenus(),
                this._enableDesktopHoverSubSubmenus(),
                this._enableMobileMenuButtonToggle(),
                this._enableMobileMenuSubmenuClicks(),
                new MutationObserver(function (t) {
                    return r._handleMutation(t);
                }).observe(this.el, { childList: !0, attributes: !0, subtree: !0 });
        }
        var e, n;
        return (
            (e = t),
            (n = [
                {
                    key: "_addAria",
                    value: function () {
                        var t = this.el.parentNode;
                        "NAV" !== t.tagName && console.warn("An ADA Menu should be wrapped in a <nav>"),
                            t.hasAttribute("aria-label") || console.warn("An ADA Menu's parent should have an aria-label"),
                            this.el.setAttribute("aria-label", t.getAttribute("aria-label")),
                            this.el.setAttribute("role", "menubar"),
                            this._addChildAria(this.el);
                    },
                },
                {
                    key: "_addChildAria",
                    value: function (t) {
                        var e = this;
                        t.children &&
                            Array.from(t.children).forEach(function (t) {
                                t.setAttribute("role", "none");
                                var n = t.querySelector("a");
                                if ((n && n.setAttribute("role", "menuitem"), t.classList.contains("menu-item-has-children"))) {
                                    n.setAttribute("aria-haspopup", !0), n.setAttribute("aria-expanded", !1);
                                    var r = t.querySelector(".sub-menu");
                                    if (r) {
                                        var o = i();
                                        r.setAttribute("role", "menu"), r.setAttribute("aria-label", t.querySelector("a").innerText), n.setAttribute("aria-controls", o), (r.id = o), e._addChildAria(r);
                                    }
                                }
                            });
                    },
                },
                {
                    key: "_enableDesktopHoverSubSubmenus",
                    value: function () {
                        var t = this;
                        this.el.querySelectorAll(".sub-menu .menu-item-has-children").forEach(function (e) {
                            (t.options.megamenuClass && e.closest("." + t.options.megamenuClass)) ||
                                (e.addEventListener("mouseenter", function (n) {
                                    window.innerWidth > t.options.mobileSwitch && e.parentNode.querySelector(".sub-menu").classList.toggle("open");
                                }),
                                e.addEventListener("mouseleave", function (n) {
                                    window.innerWidth > t.options.mobileSwitch && e.parentNode.querySelector(".sub-menu").classList.toggle("open");
                                }));
                        });
                    },
                },
                {
                    key: "_enableMobileMenuButtonToggle",
                    value: function () {
                        var t = this;
                        if (this.options.menuToggler) {
                            var e = document.querySelector(this.options.menuToggler);
                            "BUTTON" !== e.tagName && console.warn("An ADA Menu's toggler should be a button"),
                                e.setAttribute("aria-expanded", !1),
                                e.setAttribute("aria-label", "Open Menu"),
                                e.addEventListener("keydown", function (e) {
                                    if (window.innerWidth <= t.options.mobileSwitch && e.shiftKey && "Tab" == e.key) {
                                        var n = t._getTabbables("last");
                                        n && (n.focus(), e.preventDefault());
                                    }
                                }),
                                e.addEventListener("click", function (n) {
                                    var r = t.options.menuTogglerContainer ? document.querySelector(t.options.menuTogglerContainer) : t.el;
                                    setTimeout(function () {
                                        document.querySelector("html").classList.toggle("ada-wp-menu-open"), r.classList.toggle("open"), e.classList.toggle("open");
                                    }, 0),
                                        t._elIsVisible(r)
                                            ? (t._enableScroll(), t._slideUp(r), t._setHiddenWhenMobileMenuIsToggled(!1), e.setAttribute("aria-expanded", !1), e.setAttribute("aria-label", "Open Menu"))
                                            : (t._disableScroll(), t._slideDown(r), t._setHiddenWhenMobileMenuIsToggled(!0), e.setAttribute("aria-expanded", !0), e.setAttribute("aria-label", "Close Menu"), t._getTabbables("first").focus());
                                });
                        }
                    },
                },
                {
                    key: "_setHiddenWhenMobileMenuIsToggled",
                    value: function (t) {
                        this.options.setHiddenWhenMobileMenuIsToggled.length &&
                            this.options.setHiddenWhenMobileMenuIsToggled.forEach(function (e) {
                                var n = document.querySelector(e);
                                n && n.setAttribute("aria-hidden", t);
                            });
                    },
                },
                {
                    key: "_enableScroll",
                    value: function () {
                        var t = document.body.style.top;
                        (document.body.style.top = ""), (document.body.style.position = ""), (document.body.style.width = ""), window.scrollTo(0, -1 * parseInt(t || "0"));
                    },
                },
                {
                    key: "_disableScroll",
                    value: function () {
                        (document.body.style.top = "-".concat(window.scrollY, "px")), (document.body.style.position = "fixed"), (document.body.style.width = "100%");
                    },
                },
                {
                    key: "_enableDesktopHoverSubmenus",
                    value: function () {
                        var t = this;
                        if (window.innerWidth <= this.options.mobileSwitch) return !1;
                        var e = this.el.querySelectorAll(":scope > .menu-item-has-children");
                        e.forEach(function (e) {
                            e.addEventListener("mouseenter", function (n) {
                                var r = e.querySelector(".sub-menu").classList.contains("open");
                                t._closeAllTopLevelSubMenus(), r || e.querySelector(".sub-menu").classList.toggle("open");
                            });
                        }),
                            e.forEach(function (e) {
                                e.addEventListener("mouseleave", function (e) {
                                    t._closeAllTopLevelSubMenus();
                                });
                            });
                        var n = this.el.querySelectorAll(":scope > .menu-item > a");
                        document.addEventListener("click", function (e) {
                            var n = t.el.querySelector(".sub-menu.open");
                            n && !n.contains(document.activeElement) && n.classList.remove("open");
                        }),
                            n.forEach(function (e) {
                                e.addEventListener("focus", function (n) {
                                    t._closeAllTopLevelSubMenus(),
                                        setTimeout(function () {
                                            var t = e.closest(".menu-item-has-children");
                                            document.querySelector("body.touched") && t && t.querySelector(".sub-menu").classList.toggle("open");
                                        });
                                }),
                                    e.addEventListener("click", function (e) {
                                        document.activeElement == e.target && t._closeAllTopLevelSubMenus();
                                    });
                            });
                    },
                },
                {
                    key: "_enableKeyboardNavigation",
                    value: function () {
                        var t = this,
                            e = window.innerWidth <= this.options.mobileSwitch && this.options.menuTogglerContainer ? document.querySelector(this.options.menuTogglerContainer) : this.el;
                        this.options.menuToggler &&
                            document.querySelector(this.options.menuToggler).addEventListener("keydown", function (e) {
                                if (window.innerWidth <= t.options.mobileSwitch && "Tab" == e.key) {
                                    var n = t._getTabbables();
                                    n.length && (e.preventDefault(), n[1].focus());
                                }
                            }),
                            e.addEventListener("keydown", function (e) {
                                ("Space" !== e.code && 32 !== e.which) || (e.preventDefault(), t._handleArrowDown());
                                var n = document.activeElement.closest(".sub-menu");
                                switch (e.key) {
                                    case "Enter":
                                        if (e.target.closest(".menu-item").classList.contains("menu-item-has-children")) {
                                            e.preventDefault();
                                            var r = e.target.closest(".menu-item").querySelector(".sub-menu");
                                            r.classList.contains("open") && window.innerWidth <= t.options.mobileSwitch ? r.classList.remove("open") : t._handleArrowDown();
                                        }
                                        break;
                                    case "Home":
                                        e.preventDefault(), t._focusTabbable("first");
                                        break;
                                    case "End":
                                        e.preventDefault(), t._focusTabbable("last");
                                        break;
                                    case "Escape":
                                        n && (e.preventDefault(), (a = document.activeElement.closest(".sub-menu").parentNode.querySelector("a")).focus(), a.setAttribute("aria-expanded", !1));
                                        break;
                                    case "ArrowUp":
                                        e.preventDefault();
                                        var o = !1;
                                        if (n && ((o = n.querySelector(":scope > .menu-item:first-child a") == document.activeElement), n.parentNode.closest(".sub-menu") && o))
                                            return t._slideUp(document.activeElement.closest(".sub-menu")), (a = document.activeElement.closest(".sub-menu").parentNode.querySelector("a")).focus(), a.setAttribute("aria-expanded", !1), !1;
                                        o ? n.closest(".menu-item").querySelector("a").focus() : t._focusTabbable("prev");
                                        break;
                                    case "ArrowRight":
                                        e.preventDefault(),
                                            n
                                                ? document.activeElement.parentNode.classList.contains("menu-item-has-children")
                                                    ? (document.activeElement.parentNode.querySelector(".sub-menu").classList.add("open"),
                                                      setTimeout(function () {
                                                          return t._focusTabbable("next");
                                                      }, 0))
                                                    : t.getNextTopLevelMenuItem(document.activeElement).querySelector("a").focus()
                                                : t._focusTabbable("next");
                                        break;
                                    case "ArrowDown":
                                        e.preventDefault();
                                        var i = !1;
                                        n && (i = n.querySelector(":scope > .menu-item:last-child a") == document.activeElement), i || t._handleArrowDown();
                                        break;
                                    case "ArrowLeft":
                                        var a;
                                        e.preventDefault(),
                                            n
                                                ? n.parentNode.closest(".sub-menu")
                                                    ? (t._slideUp(document.activeElement.closest(".sub-menu")), (a = document.activeElement.closest(".sub-menu").parentNode.querySelector("a")).focus(), a.setAttribute("aria-expanded", !1))
                                                    : t.getPrevTopLevelMenuItem(document.activeElement).querySelector("a").focus()
                                                : t._focusTabbable("prev");
                                        break;
                                    case "Tab":
                                        if (window.innerWidth > t.options.mobileSwitch) break;
                                        var s = 0,
                                            c = t._getTabbables();
                                        c.forEach(function (t, e) {
                                            document.activeElement == t && (s = e);
                                        }),
                                            e.shiftKey && 1 == s && (c[0].focus(), e.preventDefault()),
                                            e.shiftKey || s != c.length - 1 || (c[0].focus(), e.preventDefault());
                                }
                            });
                    },
                },
                {
                    key: "_closeAllTopLevelSubMenus",
                    value: function () {
                        this.el.querySelectorAll(".open").forEach(function (t) {
                            return t.classList.remove("open");
                        });
                    },
                },
                {
                    key: "_getTabbables",
                    value: function (t) {
                        var e = this,
                            n = window.innerWidth <= this.options.mobileSwitch && this.options.menuTogglerContainer ? document.querySelector(this.options.menuTogglerContainer) : this.el,
                            r = Array.from(n.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"]'));
                        if (n.classList.contains("open")) {
                            var o = document.querySelector(this.options.menuToggler);
                            r.unshift(o);
                        }
                        return (
                            (r = r.filter(function (t) {
                                return e._elIsVisible(t) && !t.hasAttribute("disabled");
                            })),
                            "first" == t ? r[0] : "last" == t ? r[r.length - 1] : r
                        );
                    },
                },
                {
                    key: "_focusTabbable",
                    value: function (t) {
                        for (
                            var e = this,
                                n = Array.from(this.el.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"]')).filter(function (t) {
                                    return e._elIsVisible(t) && !t.hasAttribute("disabled");
                                }),
                                r = n.length - 1;
                            r >= 0;
                            r--
                        )
                            if (n[r] == document.activeElement) {
                                if ("next" == t) void 0 !== n[r + 1] ? n[r + 1].focus() : n[0].focus();
                                else if ("sub-menu-first" == t) {
                                    var o = n[r].closest(".menu-item-has-children").querySelectorAll("ul.sub-menu li.menu-item");
                                    o && o[0].querySelector("a").focus();
                                } else if ("sub-menu-last" == t) {
                                    var i = n[r].closest(".menu-item-has-children").querySelectorAll("ul.sub-menu li.menu-item");
                                    i && i[i.length - 1].querySelector("a").focus();
                                } else "last" == t ? n[n.length - 1].focus() : "first" == t ? n[0].focus() : void 0 !== n[r - 1] ? n[r - 1].focus() : n[n.length - 1].focus();
                                break;
                            }
                    },
                },
                {
                    key: "_handleArrowDown",
                    value: function () {
                        var t = this,
                            e = document.activeElement.parentNode,
                            n = Array.from(this.el.querySelectorAll(":scope > .menu-item")).filter(function (t) {
                                return t == e;
                            }).length,
                            r = !n || (n && e.querySelector(".sub-menu").classList.contains("open"));
                        n && e.classList.contains("menu-item-has-children") && !e.querySelector(".sub-menu").classList.contains("open") && e.querySelector(".sub-menu").classList.add("open"),
                            r &&
                                setTimeout(function () {
                                    return t._focusTabbable("next");
                                }, 0);
                    },
                },
                {
                    key: "_enableMobileMenuSubmenuClicks",
                    value: function () {
                        var t = this;
                        if (!(window.innerWidth > this.options.mobileSwitch)) {
                            var e = this.el.querySelectorAll(".menu-item-has-children > a");
                            e &&
                                e.forEach(function (e) {
                                    e.addEventListener("click", function (n) {
                                        var r = n.target.closest(".menu-item-has-children").querySelector(".sub-menu");
                                        r.classList.contains("open")
                                            ? r.classList.remove("open")
                                            : (t.options.mobileSubMenusAutomaticallyClose && t.isTopLevelMenuItem(e.parentNode) && t._closeAllTopLevelSubMenus(),
                                              setTimeout(function () {
                                                  return r.classList.add("open");
                                              }));
                                    });
                                });
                        }
                    },
                },
                {
                    key: "_createFirstSubMenuFromParent",
                    value: function () {
                        var t = this.el.querySelectorAll(".menu-item-has-children");
                        t &&
                            t.forEach(function (t) {
                                var e = t.querySelector("a").getAttribute("href"),
                                    n = t.querySelector("ul.sub-menu");
                                if (e && "#" !== e[0] && n) {
                                    var r = document.createElement("li");
                                    r.setAttribute("class", "menu-item"), r.setAttribute("role", "none");
                                    var o = document.createElement("a");
                                    o.setAttribute("role", "menuitem"), o.setAttribute("href", e), (o.innerHTML = t.querySelector("a").innerHTML), r.appendChild(o), n.insertBefore(r, n.firstChild);
                                    var i = t.querySelector("a");
                                    i && i.setAttribute("href", "#");
                                }
                            });
                    },
                },
                {
                    key: "_elIsVisible",
                    value: function (t) {
                        return t.offsetWidth > 0 || t.offsetHeight > 0 || t.getClientRects().length > 0;
                    },
                },
                {
                    key: "_handleMutation",
                    value: function (t) {
                        var e = t[0];
                        if ("class" == e.attributeName && e.target.classList.contains("sub-menu"))
                            if (e.target.classList.contains("open")) e.target.parentNode.querySelector("a").setAttribute("aria-expanded", !0), this._slideDown(e.target);
                            else {
                                e.target.parentNode.querySelector("a").setAttribute("aria-expanded", !1), this._slideUp(e.target);
                                var n = e.target.querySelectorAll(".sub-menu .sub-menu");
                                n &&
                                    (e.target.querySelectorAll('.sub-menu a[aria-expanded="true"]').forEach(function (t) {
                                        return t.setAttribute("aria-expanded", !1);
                                    }),
                                    n.forEach(function (t) {
                                        t.classList.remove("open"), (t.style.display = "none");
                                    }));
                            }
                    },
                },
                {
                    key: "_slideUp",
                    value: function (t) {
                        var e = this;
                        t.dataset.timeoutInstance &&
                            (clearTimeout(
                                this.timeoutAnimationInstances.filter(function (e) {
                                    return e == t.dataset.timeoutInstance;
                                })[0]
                            ),
                            (this.timeoutAnimationInstances = this.timeoutAnimationInstances.filter(function (e) {
                                return e != t.dataset.timeoutInstance;
                            }))),
                            (t.style.transitionProperty = "height, margin, padding"),
                            (t.style.transitionDuration = this.options.slideDuration + "ms"),
                            (t.style.boxSizing = "border-box"),
                            (t.style.height = t.offsetHeight + "px"),
                            t.offsetHeight,
                            (t.style.overflow = "hidden"),
                            (t.style.height = 0),
                            (t.style.paddingTop = 0),
                            (t.style.paddingBottom = 0),
                            (t.style.marginTop = 0),
                            (t.style.marginBottom = 0);
                        var n = window.setTimeout(function () {
                            (t.style.display = "none"),
                                t.style.removeProperty("height"),
                                t.style.removeProperty("padding-top"),
                                t.style.removeProperty("padding-bottom"),
                                t.style.removeProperty("margin-top"),
                                t.style.removeProperty("margin-bottom"),
                                t.style.removeProperty("overflow"),
                                t.style.removeProperty("transition-duration"),
                                t.style.removeProperty("transition-property"),
                                (e.timeoutAnimationInstances = e.timeoutAnimationInstances.filter(function (e) {
                                    return e != t.dataset.timeoutInstance;
                                })),
                                (t.dataset.timeoutInstance = 0);
                        }, this.options.slideDuration);
                        this.timeoutAnimationInstances.push(n), (t.dataset.timeoutInstance = n);
                    },
                },
                {
                    key: "_slideDown",
                    value: function (t) {
                        var e = this;
                        t.dataset.timeoutInstance &&
                            (clearTimeout(
                                this.timeoutAnimationInstances.filter(function (e) {
                                    return e == t.dataset.timeoutInstance;
                                })[0]
                            ),
                            (this.timeoutAnimationInstances = this.timeoutAnimationInstances.filter(function (e) {
                                return e != t.dataset.timeoutInstance;
                            }))),
                            t.style.removeProperty("display");
                        var n = window.getComputedStyle(t).display;
                        "none" === n && (n = t == this.el ? this.options.menuDisplayWhenOpen : this.options.subMenuDisplayWhenOpen), (t.style.display = n);
                        var r = t.offsetHeight,
                            o = this.options.menuTogglerContainer ? document.querySelector(this.options.menuTogglerContainer) : this.el;
                        if (t == o && this.options.menuFillsScreenHeightOnToggle)
                            if (this.options.menuFillAccountsForHeaderHeight) {
                                var i = this.el.closest("header");
                                r = window.innerHeight - i.offsetHeight;
                            } else r = window.innerHeight;
                        (t.style.overflow = "hidden"),
                            (t.style.height = 0),
                            (t.style.paddingTop = 0),
                            (t.style.paddingBottom = 0),
                            (t.style.marginTop = 0),
                            (t.style.marginBottom = 0),
                            t.offsetHeight,
                            (t.style.boxSizing = "border-box"),
                            (t.style.transitionProperty = "height, margin, padding"),
                            (t.style.transitionDuration = this.options.slideDuration + "ms"),
                            (t.style.height = r + "px"),
                            t.style.removeProperty("padding-top"),
                            t.style.removeProperty("padding-bottom"),
                            t.style.removeProperty("margin-top"),
                            t.style.removeProperty("margin-bottom");
                        var a = t.getBoundingClientRect();
                        t.offsetWidth + a.left > window.innerWidth && t.classList.add("push-left");
                        var s = window.setTimeout(function () {
                            (t == o && e.options.menuFillsScreenHeightOnToggle) || t.style.removeProperty("height"),
                                t.style.removeProperty("overflow"),
                                t.style.removeProperty("transition-duration"),
                                t.style.removeProperty("transition-property"),
                                (e.timeoutAnimationInstances = e.timeoutAnimationInstances.filter(function (e) {
                                    return e != t.dataset.timeoutInstance;
                                })),
                                (t.dataset.timeoutInstance = 0);
                        }, this.options.slideDuration);
                        this.timeoutAnimationInstances.push(s), (t.dataset.timeoutInstance = s);
                    },
                },
                {
                    key: "getNextTopLevelMenuItem",
                    value: function (t) {
                        var e = null,
                            n = this.el.querySelectorAll(":scope > .menu-item");
                        if (n) for (var r = 0; r < n.length; r++) n[r].contains(t) && (e = r == n.length - 1 ? n[0] : n[r + 1]);
                        return e;
                    },
                },
                {
                    key: "isTopLevelMenuItem",
                    value: function (t) {
                        var e = this.el.querySelectorAll(":scope > .menu-item");
                        if (e) for (var n = 0; n < e.length; n++) if (e[n] == t) return !0;
                        return !1;
                    },
                },
                {
                    key: "getPrevTopLevelMenuItem",
                    value: function (t) {
                        var e = null,
                            n = this.el.querySelectorAll(":scope > .menu-item");
                        if (n) for (var r = 0; r < n.length; r++) n[r].contains(t) && (e = 0 == r ? n[n.length - 1] : n[r - 1]);
                        return e;
                    },
                },
            ]),
            n && $r(e.prototype, n),
            Object.defineProperty(e, "prototype", { writable: !1 }),
            t
        );
    })();
    const Ir = Mr;
    function Rr(t) {
        return (
            (Rr =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            Rr(t)
        );
    }
    function Dr() {
        Dr = function () {
            return t;
        };
        var t = {},
            e = Object.prototype,
            n = e.hasOwnProperty,
            r =
                Object.defineProperty ||
                function (t, e, n) {
                    t[e] = n.value;
                },
            o = "function" == typeof Symbol ? Symbol : {},
            i = o.iterator || "@@iterator",
            a = o.asyncIterator || "@@asyncIterator",
            s = o.toStringTag || "@@toStringTag";
        function c(t, e, n) {
            return Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }), t[e];
        }
        try {
            c({}, "");
        } catch (t) {
            c = function (t, e, n) {
                return (t[e] = n);
            };
        }
        function u(t, e, n, o) {
            var i = e && e.prototype instanceof p ? e : p,
                a = Object.create(i.prototype),
                s = new x(o || []);
            return r(a, "_invoke", { value: _(t, n, s) }), a;
        }
        function l(t, e, n) {
            try {
                return { type: "normal", arg: t.call(e, n) };
            } catch (t) {
                return { type: "throw", arg: t };
            }
        }
        t.wrap = u;
        var f = {};
        function p() {}
        function d() {}
        function h() {}
        var v = {};
        c(v, i, function () {
            return this;
        });
        var y = Object.getPrototypeOf,
            m = y && y(y(E([])));
        m && m !== e && n.call(m, i) && (v = m);
        var b = (h.prototype = p.prototype = Object.create(v));
        function g(t) {
            ["next", "throw", "return"].forEach(function (e) {
                c(t, e, function (t) {
                    return this._invoke(e, t);
                });
            });
        }
        function w(t, e) {
            function o(r, i, a, s) {
                var c = l(t[r], t, i);
                if ("throw" !== c.type) {
                    var u = c.arg,
                        f = u.value;
                    return f && "object" == Rr(f) && n.call(f, "__await")
                        ? e.resolve(f.__await).then(
                              function (t) {
                                  o("next", t, a, s);
                              },
                              function (t) {
                                  o("throw", t, a, s);
                              }
                          )
                        : e.resolve(f).then(
                              function (t) {
                                  (u.value = t), a(u);
                              },
                              function (t) {
                                  return o("throw", t, a, s);
                              }
                          );
                }
                s(c.arg);
            }
            var i;
            r(this, "_invoke", {
                value: function (t, n) {
                    function r() {
                        return new e(function (e, r) {
                            o(t, n, e, r);
                        });
                    }
                    return (i = i ? i.then(r, r) : r());
                },
            });
        }
        function _(t, e, n) {
            var r = "suspendedStart";
            return function (o, i) {
                if ("executing" === r) throw new Error("Generator is already running");
                if ("completed" === r) {
                    if ("throw" === o) throw i;
                    return { value: void 0, done: !0 };
                }
                for (n.method = o, n.arg = i; ; ) {
                    var a = n.delegate;
                    if (a) {
                        var s = S(a, n);
                        if (s) {
                            if (s === f) continue;
                            return s;
                        }
                    }
                    if ("next" === n.method) n.sent = n._sent = n.arg;
                    else if ("throw" === n.method) {
                        if ("suspendedStart" === r) throw ((r = "completed"), n.arg);
                        n.dispatchException(n.arg);
                    } else "return" === n.method && n.abrupt("return", n.arg);
                    r = "executing";
                    var c = l(t, e, n);
                    if ("normal" === c.type) {
                        if (((r = n.done ? "completed" : "suspendedYield"), c.arg === f)) continue;
                        return { value: c.arg, done: n.done };
                    }
                    "throw" === c.type && ((r = "completed"), (n.method = "throw"), (n.arg = c.arg));
                }
            };
        }
        function S(t, e) {
            var n = e.method,
                r = t.iterator[n];
            if (void 0 === r)
                return (
                    (e.delegate = null),
                    ("throw" === n && t.iterator.return && ((e.method = "return"), (e.arg = void 0), S(t, e), "throw" === e.method)) ||
                        ("return" !== n && ((e.method = "throw"), (e.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
                    f
                );
            var o = l(r, t.iterator, e.arg);
            if ("throw" === o.type) return (e.method = "throw"), (e.arg = o.arg), (e.delegate = null), f;
            var i = o.arg;
            return i
                ? i.done
                    ? ((e[t.resultName] = i.value), (e.next = t.nextLoc), "return" !== e.method && ((e.method = "next"), (e.arg = void 0)), (e.delegate = null), f)
                    : i
                : ((e.method = "throw"), (e.arg = new TypeError("iterator result is not an object")), (e.delegate = null), f);
        }
        function A(t) {
            var e = { tryLoc: t[0] };
            1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
        }
        function O(t) {
            var e = t.completion || {};
            (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function x(t) {
            (this.tryEntries = [{ tryLoc: "root" }]), t.forEach(A, this), this.reset(!0);
        }
        function E(t) {
            if (t) {
                var e = t[i];
                if (e) return e.call(t);
                if ("function" == typeof t.next) return t;
                if (!isNaN(t.length)) {
                    var r = -1,
                        o = function e() {
                            for (; ++r < t.length; ) if (n.call(t, r)) return (e.value = t[r]), (e.done = !1), e;
                            return (e.value = void 0), (e.done = !0), e;
                        };
                    return (o.next = o);
                }
            }
            return { next: P };
        }
        function P() {
            return { value: void 0, done: !0 };
        }
        return (
            (d.prototype = h),
            r(b, "constructor", { value: h, configurable: !0 }),
            r(h, "constructor", { value: d, configurable: !0 }),
            (d.displayName = c(h, s, "GeneratorFunction")),
            (t.isGeneratorFunction = function (t) {
                var e = "function" == typeof t && t.constructor;
                return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
            }),
            (t.mark = function (t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : ((t.__proto__ = h), c(t, s, "GeneratorFunction")), (t.prototype = Object.create(b)), t;
            }),
            (t.awrap = function (t) {
                return { __await: t };
            }),
            g(w.prototype),
            c(w.prototype, a, function () {
                return this;
            }),
            (t.AsyncIterator = w),
            (t.async = function (e, n, r, o, i) {
                void 0 === i && (i = Promise);
                var a = new w(u(e, n, r, o), i);
                return t.isGeneratorFunction(n)
                    ? a
                    : a.next().then(function (t) {
                          return t.done ? t.value : a.next();
                      });
            }),
            g(b),
            c(b, s, "Generator"),
            c(b, i, function () {
                return this;
            }),
            c(b, "toString", function () {
                return "[object Generator]";
            }),
            (t.keys = function (t) {
                var e = Object(t),
                    n = [];
                for (var r in e) n.push(r);
                return (
                    n.reverse(),
                    function t() {
                        for (; n.length; ) {
                            var r = n.pop();
                            if (r in e) return (t.value = r), (t.done = !1), t;
                        }
                        return (t.done = !0), t;
                    }
                );
            }),
            (t.values = E),
            (x.prototype = {
                constructor: x,
                reset: function (t) {
                    if (((this.prev = 0), (this.next = 0), (this.sent = this._sent = void 0), (this.done = !1), (this.delegate = null), (this.method = "next"), (this.arg = void 0), this.tryEntries.forEach(O), !t))
                        for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
                },
                stop: function () {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function (t) {
                    if (this.done) throw t;
                    var e = this;
                    function r(n, r) {
                        return (a.type = "throw"), (a.arg = t), (e.next = n), r && ((e.method = "next"), (e.arg = void 0)), !!r;
                    }
                    for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                        var i = this.tryEntries[o],
                            a = i.completion;
                        if ("root" === i.tryLoc) return r("end");
                        if (i.tryLoc <= this.prev) {
                            var s = n.call(i, "catchLoc"),
                                c = n.call(i, "finallyLoc");
                            if (s && c) {
                                if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                                if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                            } else if (s) {
                                if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                            } else {
                                if (!c) throw new Error("try statement without catch or finally");
                                if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function (t, e) {
                    for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                        var o = this.tryEntries[r];
                        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                            var i = o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return (a.type = t), (a.arg = e), i ? ((this.method = "next"), (this.next = i.finallyLoc), f) : this.complete(a);
                },
                complete: function (t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return (
                        "break" === t.type || "continue" === t.type ? (this.next = t.arg) : "return" === t.type ? ((this.rval = this.arg = t.arg), (this.method = "return"), (this.next = "end")) : "normal" === t.type && e && (this.next = e),
                        f
                    );
                },
                finish: function (t) {
                    for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                        var n = this.tryEntries[e];
                        if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), O(n), f;
                    }
                },
                catch: function (t) {
                    for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                        var n = this.tryEntries[e];
                        if (n.tryLoc === t) {
                            var r = n.completion;
                            if ("throw" === r.type) {
                                var o = r.arg;
                                O(n);
                            }
                            return o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function (t, e, n) {
                    return (this.delegate = { iterator: E(t), resultName: e, nextLoc: n }), "next" === this.method && (this.arg = void 0), f;
                },
            }),
            t
        );
    }
    function Nr(t, e, n, r, o, i, a) {
        try {
            var s = t[i](a),
                c = s.value;
        } catch (t) {
            return void n(t);
        }
        s.done ? e(c) : Promise.resolve(c).then(r, o);
    }
    function Fr(t, e) {
        var n = e.options[e.selectedIndex],
            r = n.getAttribute("sale-price"),
            o = n.getAttribute("regular-price"),
            i = parseFloat(o.replace("$", "")) - parseFloat(r.replace("$", "")),
            a = 100 * Math.abs(parseFloat(r.replace("$", "")) / parseFloat(o.replace("$", "")) - 1),
            s = t.querySelector(".add-to-cart--regular-price"),
            c = t.querySelector(".add-to-cart--sale-price"),
            u = t.querySelector(".add-to-cart--save-dollars"),
            l = t.querySelector(".add-to-cart--save-percent");
        s && (s.innerText = o),
            c && r <= o && (c.innerText = r),
            u && i >= 0 && (u.innerText = "$".concat(i.toFixed(2))),
            l &&
                (l.innerText =
                    a % 1 == 0
                        ? a
                        : (function (t, e) {
                              var n = new RegExp("^-?\\d+(?:.\\d{0,-1})?");
                              return t.toString().match(n)[0];
                          })(a));
    }
    function qr(t) {
        !(function (t) {
            var e = t.querySelector('select[name="id"]');
            e
                ? (Fr(t, e),
                  e.addEventListener("change", function (n) {
                      return Fr(t, e);
                  }))
                : console.warn("Product ID selector missing");
        })(t),
            (function (t) {
                var n = t.querySelector('select[name="id"]');
                if (n) {
                    var r = (function (t) {
                        var n = {},
                            r = document.createElement("a");
                        r.href = window.location.href;
                        for (var o = r.search.substring(1).split("&"), i = 0; i < o.length; i++) {
                            var a = o[i].split("=");
                            n[a[0]] = decodeURIComponent(a[1]);
                        }
                        return void 0 !== e(n[t]) ? n[t] : null;
                    })("variant");
                    r && (n.value = r);
                    var o = !0;
                    Array.from(n.options).forEach(function (t) {
                        t.disabled || (o = !1);
                    }),
                        o && (t.querySelector('button[type="  "]').disabled = !0);
                } else console.warn("Product ID selector missing");
            })(t),
            (function (t) {
                t.addEventListener(
                    "submit",
                    (function () {
                        var t = (function (t) {
                            return function () {
                                var e = this,
                                    n = arguments;
                                return new Promise(function (r, o) {
                                    var i = t.apply(e, n);
                                    function a(t) {
                                        Nr(i, r, o, a, s, "next", t);
                                    }
                                    function s(t) {
                                        Nr(i, r, o, a, s, "throw", t);
                                    }
                                    a(void 0);
                                });
                            };
                        })(
                            Dr().mark(function t(e) {
                                var n;
                                return Dr().wrap(function (t) {
                                    for (;;)
                                        switch ((t.prev = t.next)) {
                                            case 0:
                                                (n = document.querySelector(".rbr-page-container")) && (e.preventDefault(), n.querySelector(".rbr-addBundleBtn-container").click());
                                            case 2:
                                            case "end":
                                                return t.stop();
                                        }
                                }, t);
                            })
                        );
                        return function (e) {
                            return t.apply(this, arguments);
                        };
                    })()
                );
            })(t),
            (function (t) {
                var e = t.querySelectorAll(".lt-add-to-cart--button"),
                    n = new URLSearchParams(window.location.search),
                    r = n.get("variant");
                e.forEach(function (o) {
                    o.addEventListener("click", function (r) {
                        r.preventDefault(),
                            e.forEach(function (t) {
                                t.classList.remove("active");
                            }),
                            this.classList.add("active"),
                            (t.querySelector(".add-to-cart--select").value = this.value),
                            t.querySelector(".add-to-cart--select").dispatchEvent(new Event("change"));
                        var o = this.value;
                        n.set("variant", o);
                        var i = "".concat(window.location.origin).concat(window.location.pathname, "?").concat(n.toString());
                        window.history.replaceState({}, "", i);
                    }),
                        r && o.value === r && o.click();
                });
            })(t),
            (function (t) {
                var e = t.querySelector(".add-to-cart--quantity-and-submit button.button");
                (e.textContent = "ADD TO BAG"),
                    new MutationObserver(function (t) {
                        t.forEach(function (t) {
                            ("class" !== t.attributeName && "data-product-price" !== t.attributeName) || (e.textContent = "ADD TO BAG");
                        });
                    }).observe(e, { attributes: !0 });
            })(t);
    }
    var Hr = {
        install: function (t, e) {
            (t.prototype.$setFromUrl = function (t) {
                var e,
                    n =
                        null != (e = window.location.search.substr(1)) && "" != e
                            ? (function (t) {
                                  for (var e = {}, n = t.split("&"), r = 0; r < n.length; r++) {
                                      var o = n[r].split("=");
                                      e[o[0]] = o[1];
                                  }
                                  return e;
                              })(e)
                            : {};
                for (var r in n)
                    parseInt(n[r]) == n[r] ? (n[r] = parseInt(n[r])) : parseFloat(n[r]) == n[r] && (n[r] = parseFloat(n[r])), "string" == typeof n[r] && ((n[r] = n[r].replaceAll("+", " ")), (n[r] = n[r].replaceAll("%7C", "|")));
                t(n);
            }),
                (t.prototype.$pushToUrl = function (t) {
                    var e = t({}),
                        n = new URL("".concat(window.location.origin).concat(window.location.pathname));
                    for (var r in e) e[r] && n.searchParams.append(r, e[r]);
                    window.history.pushState({}, document.title, n.href);
                });
        },
    };
    const Br = Hr;
    function Ur(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function Wr(t, e) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(
                    t,
                    (void 0,
                    (o = (function (t, e) {
                        if ("object" !== zr(t) || null === t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(t, "string");
                            if ("object" !== zr(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t);
                    })(r.key)),
                    "symbol" === zr(o) ? o : String(o)),
                    r
                );
        }
        var o;
    }
    function Vr(t, e, n) {
        return e && Wr(t.prototype, e), n && Wr(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
    }
    function zr(t) {
        return (
            (zr =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            zr(t)
        );
    }
    var Kr = Object.freeze({}),
        Gr = Array.isArray;
    function Yr(t) {
        return null == t;
    }
    function Xr(t) {
        return null != t;
    }
    function Jr(t) {
        return !0 === t;
    }
    function Zr(t) {
        return "string" == typeof t || "number" == typeof t || "symbol" == zr(t) || "boolean" == typeof t;
    }
    function Qr(t) {
        return "function" == typeof t;
    }
    function to(t) {
        return null !== t && "object" == zr(t);
    }
    var eo = Object.prototype.toString;
    function no(t) {
        return "[object Object]" === eo.call(t);
    }
    function ro(t) {
        var e = parseFloat(String(t));
        return e >= 0 && Math.floor(e) === e && isFinite(t);
    }
    function oo(t) {
        return Xr(t) && "function" == typeof t.then && "function" == typeof t.catch;
    }
    function io(t) {
        return null == t ? "" : Array.isArray(t) || (no(t) && t.toString === eo) ? JSON.stringify(t, null, 2) : String(t);
    }
    function ao(t) {
        var e = parseFloat(t);
        return isNaN(e) ? t : e;
    }
    function so(t, e) {
        for (var n = Object.create(null), r = t.split(","), o = 0; o < r.length; o++) n[r[o]] = !0;
        return e
            ? function (t) {
                  return n[t.toLowerCase()];
              }
            : function (t) {
                  return n[t];
              };
    }
    var co = so("slot,component", !0),
        uo = so("key,ref,slot,slot-scope,is");
    function lo(t, e) {
        var n = t.length;
        if (n) {
            if (e === t[n - 1]) return void (t.length = n - 1);
            var r = t.indexOf(e);
            if (r > -1) return t.splice(r, 1);
        }
    }
    var fo = Object.prototype.hasOwnProperty;
    function po(t, e) {
        return fo.call(t, e);
    }
    function ho(t) {
        var e = Object.create(null);
        return function (n) {
            return e[n] || (e[n] = t(n));
        };
    }
    var vo = /-(\w)/g,
        yo = ho(function (t) {
            return t.replace(vo, function (t, e) {
                return e ? e.toUpperCase() : "";
            });
        }),
        mo = ho(function (t) {
            return t.charAt(0).toUpperCase() + t.slice(1);
        }),
        bo = /\B([A-Z])/g,
        go = ho(function (t) {
            return t.replace(bo, "-$1").toLowerCase();
        }),
        wo = Function.prototype.bind
            ? function (t, e) {
                  return t.bind(e);
              }
            : function (t, e) {
                  function n(n) {
                      var r = arguments.length;
                      return r ? (r > 1 ? t.apply(e, arguments) : t.call(e, n)) : t.call(e);
                  }
                  return (n._length = t.length), n;
              };
    function _o(t, e) {
        e = e || 0;
        for (var n = t.length - e, r = new Array(n); n--; ) r[n] = t[n + e];
        return r;
    }
    function So(t, e) {
        for (var n in e) t[n] = e[n];
        return t;
    }
    function Ao(t) {
        for (var e = {}, n = 0; n < t.length; n++) t[n] && So(e, t[n]);
        return e;
    }
    function Oo(t, e, n) {}
    var xo = function (t, e, n) {
            return !1;
        },
        Eo = function (t) {
            return t;
        };
    function Po(t, e) {
        if (t === e) return !0;
        var n = to(t),
            r = to(e);
        if (!n || !r) return !n && !r && String(t) === String(e);
        try {
            var o = Array.isArray(t),
                i = Array.isArray(e);
            if (o && i)
                return (
                    t.length === e.length &&
                    t.every(function (t, n) {
                        return Po(t, e[n]);
                    })
                );
            if (t instanceof Date && e instanceof Date) return t.getTime() === e.getTime();
            if (o || i) return !1;
            var a = Object.keys(t),
                s = Object.keys(e);
            return (
                a.length === s.length &&
                a.every(function (n) {
                    return Po(t[n], e[n]);
                })
            );
        } catch (t) {
            return !1;
        }
    }
    function To(t, e) {
        for (var n = 0; n < t.length; n++) if (Po(t[n], e)) return n;
        return -1;
    }
    function ko(t) {
        var e = !1;
        return function () {
            e || ((e = !0), t.apply(this, arguments));
        };
    }
    function jo(t, e) {
        return t === e ? 0 === t && 1 / t != 1 / e : t == t || e == e;
    }
    var Co = ["component", "directive", "filter"],
        Lo = ["beforeCreate", "created", "beforeMount", "mounted", "beforeUpdate", "updated", "beforeDestroy", "destroyed", "activated", "deactivated", "errorCaptured", "serverPrefetch", "renderTracked", "renderTriggered"],
        $o = {
            optionMergeStrategies: Object.create(null),
            silent: !1,
            productionTip: !1,
            devtools: !1,
            performance: !1,
            errorHandler: null,
            warnHandler: null,
            ignoredElements: [],
            keyCodes: Object.create(null),
            isReservedTag: xo,
            isReservedAttr: xo,
            isUnknownElement: xo,
            getTagNamespace: Oo,
            parsePlatformTagName: Eo,
            mustUseProp: xo,
            async: !0,
            _lifecycleHooks: Lo,
        },
        Mo = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
    function Io(t) {
        var e = (t + "").charCodeAt(0);
        return 36 === e || 95 === e;
    }
    function Ro(t, e, n, r) {
        Object.defineProperty(t, e, { value: n, enumerable: !!r, writable: !0, configurable: !0 });
    }
    var Do = new RegExp("[^".concat(Mo.source, ".$_\\d]")),
        No = "__proto__" in {},
        Fo = "undefined" != typeof window,
        qo = Fo && window.navigator.userAgent.toLowerCase(),
        Ho = qo && /msie|trident/.test(qo),
        Bo = qo && qo.indexOf("msie 9.0") > 0,
        Uo = qo && qo.indexOf("edge/") > 0;
    qo && qo.indexOf("android");
    var Wo = qo && /iphone|ipad|ipod|ios/.test(qo);
    qo && /chrome\/\d+/.test(qo), qo && /phantomjs/.test(qo);
    var Vo,
        zo = qo && qo.match(/firefox\/(\d+)/),
        Ko = {}.watch,
        Go = !1;
    if (Fo)
        try {
            var Yo = {};
            Object.defineProperty(Yo, "passive", {
                get: function () {
                    Go = !0;
                },
            }),
                window.addEventListener("test-passive", null, Yo);
        } catch (Kr) {}
    var Xo = function () {
            return void 0 === Vo && (Vo = !Fo && void 0 !== t.g && t.g.process && "server" === t.g.process.env.VUE_ENV), Vo;
        },
        Jo = Fo && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
    function Zo(t) {
        return "function" == typeof t && /native code/.test(t.toString());
    }
    var Qo,
        ti = "undefined" != typeof Symbol && Zo(Symbol) && "undefined" != typeof Reflect && Zo(Reflect.ownKeys);
    Qo =
        "undefined" != typeof Set && Zo(Set)
            ? Set
            : (function () {
                  function t() {
                      Ur(this, t), (this.set = Object.create(null));
                  }
                  return (
                      Vr(t, [
                          {
                              key: "has",
                              value: function (t) {
                                  return !0 === this.set[t];
                              },
                          },
                          {
                              key: "add",
                              value: function (t) {
                                  this.set[t] = !0;
                              },
                          },
                          {
                              key: "clear",
                              value: function () {
                                  this.set = Object.create(null);
                              },
                          },
                      ]),
                      t
                  );
              })();
    var ei = null;
    function ni() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
        t || (ei && ei._scope.off()), (ei = t), t && t._scope.on();
    }
    var ri = (function () {
            function t(e, n, r, o, i, a, s, c) {
                Ur(this, t),
                    (this.tag = e),
                    (this.data = n),
                    (this.children = r),
                    (this.text = o),
                    (this.elm = i),
                    (this.ns = void 0),
                    (this.context = a),
                    (this.fnContext = void 0),
                    (this.fnOptions = void 0),
                    (this.fnScopeId = void 0),
                    (this.key = n && n.key),
                    (this.componentOptions = s),
                    (this.componentInstance = void 0),
                    (this.parent = void 0),
                    (this.raw = !1),
                    (this.isStatic = !1),
                    (this.isRootInsert = !0),
                    (this.isComment = !1),
                    (this.isCloned = !1),
                    (this.isOnce = !1),
                    (this.asyncFactory = c),
                    (this.asyncMeta = void 0),
                    (this.isAsyncPlaceholder = !1);
            }
            return (
                Vr(t, [
                    {
                        key: "child",
                        get: function () {
                            return this.componentInstance;
                        },
                    },
                ]),
                t
            );
        })(),
        oi = function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                e = new ri();
            return (e.text = t), (e.isComment = !0), e;
        };
    function ii(t) {
        return new ri(void 0, void 0, void 0, String(t));
    }
    function ai(t) {
        var e = new ri(t.tag, t.data, t.children && t.children.slice(), t.text, t.elm, t.context, t.componentOptions, t.asyncFactory);
        return (e.ns = t.ns), (e.isStatic = t.isStatic), (e.key = t.key), (e.isComment = t.isComment), (e.fnContext = t.fnContext), (e.fnOptions = t.fnOptions), (e.fnScopeId = t.fnScopeId), (e.asyncMeta = t.asyncMeta), (e.isCloned = !0), e;
    }
    var si = 0,
        ci = [],
        ui = (function () {
            function t() {
                Ur(this, t), (this._pending = !1), (this.id = si++), (this.subs = []);
            }
            return (
                Vr(t, [
                    {
                        key: "addSub",
                        value: function (t) {
                            this.subs.push(t);
                        },
                    },
                    {
                        key: "removeSub",
                        value: function (t) {
                            (this.subs[this.subs.indexOf(t)] = null), this._pending || ((this._pending = !0), ci.push(this));
                        },
                    },
                    {
                        key: "depend",
                        value: function (e) {
                            t.target && t.target.addDep(this);
                        },
                    },
                    {
                        key: "notify",
                        value: function (t) {
                            for (
                                var e = this.subs.filter(function (t) {
                                        return t;
                                    }),
                                    n = 0,
                                    r = e.length;
                                n < r;
                                n++
                            )
                                e[n].update();
                        },
                    },
                ]),
                t
            );
        })();
    ui.target = null;
    var li = [];
    function fi(t) {
        li.push(t), (ui.target = t);
    }
    function pi() {
        li.pop(), (ui.target = li[li.length - 1]);
    }
    var di = Array.prototype,
        hi = Object.create(di);
    ["push", "pop", "shift", "unshift", "splice", "sort", "reverse"].forEach(function (t) {
        var e = di[t];
        Ro(hi, t, function () {
            for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
            var i,
                a = e.apply(this, r),
                s = this.__ob__;
            switch (t) {
                case "push":
                case "unshift":
                    i = r;
                    break;
                case "splice":
                    i = r.slice(2);
            }
            return i && s.observeArray(i), s.dep.notify(), a;
        });
    });
    var vi = Object.getOwnPropertyNames(hi),
        yi = {},
        mi = !0;
    function bi(t) {
        mi = t;
    }
    var gi = { notify: Oo, depend: Oo, addSub: Oo, removeSub: Oo },
        wi = (function () {
            function t(e) {
                var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                    r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                if ((Ur(this, t), (this.value = e), (this.shallow = n), (this.mock = r), (this.dep = r ? gi : new ui()), (this.vmCount = 0), Ro(e, "__ob__", this), Gr(e))) {
                    if (!r)
                        if (No) e.__proto__ = hi;
                        else
                            for (var o = 0, i = vi.length; o < i; o++) {
                                var a = vi[o];
                                Ro(e, a, hi[a]);
                            }
                    n || this.observeArray(e);
                } else for (var s = Object.keys(e), c = 0; c < s.length; c++) Si(e, s[c], yi, void 0, n, r);
            }
            return (
                Vr(t, [
                    {
                        key: "observeArray",
                        value: function (t) {
                            for (var e = 0, n = t.length; e < n; e++) _i(t[e], !1, this.mock);
                        },
                    },
                ]),
                t
            );
        })();
    function _i(t, e, n) {
        return t && po(t, "__ob__") && t.__ob__ instanceof wi ? t.__ob__ : !mi || (!n && Xo()) || (!Gr(t) && !no(t)) || !Object.isExtensible(t) || t.__v_skip || Ti(t) || t instanceof ri ? void 0 : new wi(t, e, n);
    }
    function Si(t, e, n, r, o, i) {
        var a = new ui(),
            s = Object.getOwnPropertyDescriptor(t, e);
        if (!s || !1 !== s.configurable) {
            var c = s && s.get,
                u = s && s.set;
            (c && !u) || (n !== yi && 2 !== arguments.length) || (n = t[e]);
            var l = !o && _i(n, !1, i);
            return (
                Object.defineProperty(t, e, {
                    enumerable: !0,
                    configurable: !0,
                    get: function () {
                        var e = c ? c.call(t) : n;
                        return ui.target && (a.depend(), l && (l.dep.depend(), Gr(e) && xi(e))), Ti(e) && !o ? e.value : e;
                    },
                    set: function (e) {
                        var r = c ? c.call(t) : n;
                        if (jo(r, e)) {
                            if (u) u.call(t, e);
                            else {
                                if (c) return;
                                if (!o && Ti(r) && !Ti(e)) return void (r.value = e);
                                n = e;
                            }
                            (l = !o && _i(e, !1, i)), a.notify();
                        }
                    },
                }),
                a
            );
        }
    }
    function Ai(t, e, n) {
        if (!Pi(t)) {
            var r = t.__ob__;
            return Gr(t) && ro(e)
                ? ((t.length = Math.max(t.length, e)), t.splice(e, 1, n), r && !r.shallow && r.mock && _i(n, !1, !0), n)
                : e in t && !(e in Object.prototype)
                ? ((t[e] = n), n)
                : t._isVue || (r && r.vmCount)
                ? n
                : r
                ? (Si(r.value, e, n, void 0, r.shallow, r.mock), r.dep.notify(), n)
                : ((t[e] = n), n);
        }
    }
    function Oi(t, e) {
        if (Gr(t) && ro(e)) t.splice(e, 1);
        else {
            var n = t.__ob__;
            t._isVue || (n && n.vmCount) || Pi(t) || (po(t, e) && (delete t[e], n && n.dep.notify()));
        }
    }
    function xi(t) {
        for (var e, n = 0, r = t.length; n < r; n++) (e = t[n]) && e.__ob__ && e.__ob__.dep.depend(), Gr(e) && xi(e);
    }
    function Ei(t) {
        return (
            (function (t, e) {
                Pi(t) || _i(t, e, Xo());
            })(t, !0),
            Ro(t, "__v_isShallow", !0),
            t
        );
    }
    function Pi(t) {
        return !(!t || !t.__v_isReadonly);
    }
    function Ti(t) {
        return !(!t || !0 !== t.__v_isRef);
    }
    function ki(t, e, n) {
        Object.defineProperty(t, n, {
            enumerable: !0,
            configurable: !0,
            get: function () {
                var t = e[n];
                if (Ti(t)) return t.value;
                var r = t && t.__ob__;
                return r && r.dep.depend(), t;
            },
            set: function (t) {
                var r = e[n];
                Ti(r) && !Ti(t) ? (r.value = t) : (e[n] = t);
            },
        });
    }
    var ji = ho(function (t) {
        var e = "&" === t.charAt(0),
            n = "~" === (t = e ? t.slice(1) : t).charAt(0),
            r = "!" === (t = n ? t.slice(1) : t).charAt(0);
        return { name: (t = r ? t.slice(1) : t), once: n, capture: r, passive: e };
    });
    function Ci(t, e) {
        function n() {
            var t = n.fns;
            if (!Gr(t)) return Fa(t, null, arguments, e, "v-on handler");
            for (var r = t.slice(), o = 0; o < r.length; o++) Fa(r[o], null, arguments, e, "v-on handler");
        }
        return (n.fns = t), n;
    }
    function Li(t, e, n, r, o, i) {
        var a, s, c, u;
        for (a in t)
            (s = t[a]),
                (c = e[a]),
                (u = ji(a)),
                Yr(s) || (Yr(c) ? (Yr(s.fns) && (s = t[a] = Ci(s, i)), Jr(u.once) && (s = t[a] = o(u.name, s, u.capture)), n(u.name, s, u.capture, u.passive, u.params)) : s !== c && ((c.fns = s), (t[a] = c)));
        for (a in e) Yr(t[a]) && r((u = ji(a)).name, e[a], u.capture);
    }
    function $i(t, e, n) {
        var r;
        t instanceof ri && (t = t.data.hook || (t.data.hook = {}));
        var o = t[e];
        function i() {
            n.apply(this, arguments), lo(r.fns, i);
        }
        Yr(o) ? (r = Ci([i])) : Xr(o.fns) && Jr(o.merged) ? (r = o).fns.push(i) : (r = Ci([o, i])), (r.merged = !0), (t[e] = r);
    }
    function Mi(t, e, n, r, o) {
        if (Xr(e)) {
            if (po(e, n)) return (t[n] = e[n]), o || delete e[n], !0;
            if (po(e, r)) return (t[n] = e[r]), o || delete e[r], !0;
        }
        return !1;
    }
    function Ii(t) {
        return Zr(t) ? [ii(t)] : Gr(t) ? Di(t) : void 0;
    }
    function Ri(t) {
        return Xr(t) && Xr(t.text) && !1 === t.isComment;
    }
    function Di(t, e) {
        var n,
            r,
            o,
            i,
            a = [];
        for (n = 0; n < t.length; n++)
            Yr((r = t[n])) ||
                "boolean" == typeof r ||
                ((i = a[(o = a.length - 1)]),
                Gr(r)
                    ? r.length > 0 && (Ri((r = Di(r, "".concat(e || "", "_").concat(n)))[0]) && Ri(i) && ((a[o] = ii(i.text + r[0].text)), r.shift()), a.push.apply(a, r))
                    : Zr(r)
                    ? Ri(i)
                        ? (a[o] = ii(i.text + r))
                        : "" !== r && a.push(ii(r))
                    : Ri(r) && Ri(i)
                    ? (a[o] = ii(i.text + r.text))
                    : (Jr(t._isVList) && Xr(r.tag) && Yr(r.key) && Xr(e) && (r.key = "__vlist".concat(e, "_").concat(n, "__")), a.push(r)));
        return a;
    }
    function Ni(t, e, n, r, o, i) {
        return (
            (Gr(n) || Zr(n)) && ((o = r), (r = n), (n = void 0)),
            Jr(i) && (o = 2),
            (function (t, e, n, r, o) {
                return Xr(n) && Xr(n.__ob__)
                    ? oi()
                    : (Xr(n) && Xr(n.is) && (e = n.is),
                      e
                          ? (Gr(r) && Qr(r[0]) && (((n = n || {}).scopedSlots = { default: r[0] }), (r.length = 0)),
                            2 === o
                                ? (r = Ii(r))
                                : 1 === o &&
                                  (r = (function (t) {
                                      for (var e = 0; e < t.length; e++) if (Gr(t[e])) return Array.prototype.concat.apply([], t);
                                      return t;
                                  })(r)),
                            "string" == typeof e
                                ? ((a = (t.$vnode && t.$vnode.ns) || $o.getTagNamespace(e)),
                                  (i = $o.isReservedTag(e) ? new ri($o.parsePlatformTagName(e), n, r, void 0, void 0, t) : (n && n.pre) || !Xr((s = Cs(t.$options, "components", e))) ? new ri(e, n, r, void 0, void 0, t) : _s(s, n, t, r, e)))
                                : (i = _s(e, n, t, r)),
                            Gr(i)
                                ? i
                                : Xr(i)
                                ? (Xr(a) && Fi(i, a),
                                  Xr(n) &&
                                      (function (t) {
                                          to(t.style) && ts(t.style), to(t.class) && ts(t.class);
                                      })(n),
                                  i)
                                : oi())
                          : oi());
                var i, a, s;
            })(t, e, n, r, o)
        );
    }
    function Fi(t, e, n) {
        if (((t.ns = e), "foreignObject" === t.tag && ((e = void 0), (n = !0)), Xr(t.children)))
            for (var r = 0, o = t.children.length; r < o; r++) {
                var i = t.children[r];
                Xr(i.tag) && (Yr(i.ns) || (Jr(n) && "svg" !== i.tag)) && Fi(i, e, n);
            }
    }
    function qi(t, e) {
        var n,
            r,
            o,
            i,
            a = null;
        if (Gr(t) || "string" == typeof t) for (a = new Array(t.length), n = 0, r = t.length; n < r; n++) a[n] = e(t[n], n);
        else if ("number" == typeof t) for (a = new Array(t), n = 0; n < t; n++) a[n] = e(n + 1, n);
        else if (to(t))
            if (ti && t[Symbol.iterator]) {
                a = [];
                for (var s = t[Symbol.iterator](), c = s.next(); !c.done; ) a.push(e(c.value, a.length)), (c = s.next());
            } else for (o = Object.keys(t), a = new Array(o.length), n = 0, r = o.length; n < r; n++) (i = o[n]), (a[n] = e(t[i], i, n));
        return Xr(a) || (a = []), (a._isVList = !0), a;
    }
    function Hi(t, e, n, r) {
        var o,
            i = this.$scopedSlots[t];
        i ? ((n = n || {}), r && (n = So(So({}, r), n)), (o = i(n) || (Qr(e) ? e() : e))) : (o = this.$slots[t] || (Qr(e) ? e() : e));
        var a = n && n.slot;
        return a ? this.$createElement("template", { slot: a }, o) : o;
    }
    function Bi(t) {
        return Cs(this.$options, "filters", t) || Eo;
    }
    function Ui(t, e) {
        return Gr(t) ? -1 === t.indexOf(e) : t !== e;
    }
    function Wi(t, e, n, r, o) {
        var i = $o.keyCodes[e] || n;
        return o && r && !$o.keyCodes[e] ? Ui(o, r) : i ? Ui(i, t) : r ? go(r) !== e : void 0 === t;
    }
    function Vi(t, e, n, r, o) {
        if (n && to(n)) {
            var i;
            Gr(n) && (n = Ao(n));
            var a = function (a) {
                if ("class" === a || "style" === a || uo(a)) i = t;
                else {
                    var s = t.attrs && t.attrs.type;
                    i = r || $o.mustUseProp(e, s, a) ? t.domProps || (t.domProps = {}) : t.attrs || (t.attrs = {});
                }
                var c = yo(a),
                    u = go(a);
                c in i ||
                    u in i ||
                    ((i[a] = n[a]), !o) ||
                    ((t.on || (t.on = {}))["update:".concat(a)] = function (t) {
                        n[a] = t;
                    });
            };
            for (var s in n) a(s);
        }
        return t;
    }
    function zi(t, e) {
        var n = this._staticTrees || (this._staticTrees = []),
            r = n[t];
        return (r && !e) || Gi((r = n[t] = this.$options.staticRenderFns[t].call(this._renderProxy, this._c, this)), "__static__".concat(t), !1), r;
    }
    function Ki(t, e, n) {
        return Gi(t, "__once__".concat(e).concat(n ? "_".concat(n) : ""), !0), t;
    }
    function Gi(t, e, n) {
        if (Gr(t)) for (var r = 0; r < t.length; r++) t[r] && "string" != typeof t[r] && Yi(t[r], "".concat(e, "_").concat(r), n);
        else Yi(t, e, n);
    }
    function Yi(t, e, n) {
        (t.isStatic = !0), (t.key = e), (t.isOnce = n);
    }
    function Xi(t, e) {
        if (e && no(e)) {
            var n = (t.on = t.on ? So({}, t.on) : {});
            for (var r in e) {
                var o = n[r],
                    i = e[r];
                n[r] = o ? [].concat(o, i) : i;
            }
        }
        return t;
    }
    function Ji(t, e, n, r) {
        e = e || { $stable: !n };
        for (var o = 0; o < t.length; o++) {
            var i = t[o];
            Gr(i) ? Ji(i, e, n) : i && (i.proxy && (i.fn.proxy = !0), (e[i.key] = i.fn));
        }
        return r && (e.$key = r), e;
    }
    function Zi(t, e) {
        for (var n = 0; n < e.length; n += 2) {
            var r = e[n];
            "string" == typeof r && r && (t[e[n]] = e[n + 1]);
        }
        return t;
    }
    function Qi(t, e) {
        return "string" == typeof t ? e + t : t;
    }
    function ta(t) {
        (t._o = Ki), (t._n = ao), (t._s = io), (t._l = qi), (t._t = Hi), (t._q = Po), (t._i = To), (t._m = zi), (t._f = Bi), (t._k = Wi), (t._b = Vi), (t._v = ii), (t._e = oi), (t._u = Ji), (t._g = Xi), (t._d = Zi), (t._p = Qi);
    }
    function ea(t, e) {
        if (!t || !t.length) return {};
        for (var n = {}, r = 0, o = t.length; r < o; r++) {
            var i = t[r],
                a = i.data;
            if ((a && a.attrs && a.attrs.slot && delete a.attrs.slot, (i.context !== e && i.fnContext !== e) || !a || null == a.slot)) (n.default || (n.default = [])).push(i);
            else {
                var s = a.slot,
                    c = n[s] || (n[s] = []);
                "template" === i.tag ? c.push.apply(c, i.children || []) : c.push(i);
            }
        }
        for (var u in n) n[u].every(na) && delete n[u];
        return n;
    }
    function na(t) {
        return (t.isComment && !t.asyncFactory) || " " === t.text;
    }
    function ra(t) {
        return t.isComment && t.asyncFactory;
    }
    function oa(t, e, n, r) {
        var o,
            i = Object.keys(n).length > 0,
            a = e ? !!e.$stable : !i,
            s = e && e.$key;
        if (e) {
            if (e._normalized) return e._normalized;
            if (a && r && r !== Kr && s === r.$key && !i && !r.$hasNormal) return r;
            for (var c in ((o = {}), e)) e[c] && "$" !== c[0] && (o[c] = ia(t, n, c, e[c]));
        } else o = {};
        for (var u in n) u in o || (o[u] = aa(n, u));
        return e && Object.isExtensible(e) && (e._normalized = o), Ro(o, "$stable", a), Ro(o, "$key", s), Ro(o, "$hasNormal", i), o;
    }
    function ia(t, e, n, r) {
        var o = function () {
            var e = ei;
            ni(t);
            var n = arguments.length ? r.apply(null, arguments) : r({}),
                o = (n = n && "object" == zr(n) && !Gr(n) ? [n] : Ii(n)) && n[0];
            return ni(e), n && (!o || (1 === n.length && o.isComment && !ra(o))) ? void 0 : n;
        };
        return r.proxy && Object.defineProperty(e, n, { get: o, enumerable: !0, configurable: !0 }), o;
    }
    function aa(t, e) {
        return function () {
            return t[e];
        };
    }
    function sa(t) {
        return {
            get attrs() {
                if (!t._attrsProxy) {
                    var e = (t._attrsProxy = {});
                    Ro(e, "_v_attr_proxy", !0), ca(e, t.$attrs, Kr, t, "$attrs");
                }
                return t._attrsProxy;
            },
            get listeners() {
                return t._listenersProxy || ca((t._listenersProxy = {}), t.$listeners, Kr, t, "$listeners"), t._listenersProxy;
            },
            get slots() {
                return (function (t) {
                    return t._slotsProxy || la((t._slotsProxy = {}), t.$scopedSlots), t._slotsProxy;
                })(t);
            },
            emit: wo(t.$emit, t),
            expose: function (e) {
                e &&
                    Object.keys(e).forEach(function (n) {
                        return ki(t, e, n);
                    });
            },
        };
    }
    function ca(t, e, n, r, o) {
        var i = !1;
        for (var a in e) a in t ? e[a] !== n[a] && (i = !0) : ((i = !0), ua(t, a, r, o));
        for (var s in t) s in e || ((i = !0), delete t[s]);
        return i;
    }
    function ua(t, e, n, r) {
        Object.defineProperty(t, e, {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return n[r][e];
            },
        });
    }
    function la(t, e) {
        for (var n in e) t[n] = e[n];
        for (var r in t) r in e || delete t[r];
    }
    var fa,
        pa = null;
    function da(t, e) {
        return (t.__esModule || (ti && "Module" === t[Symbol.toStringTag])) && (t = t.default), to(t) ? e.extend(t) : t;
    }
    function ha(t) {
        if (Gr(t))
            for (var e = 0; e < t.length; e++) {
                var n = t[e];
                if (Xr(n) && (Xr(n.componentOptions) || ra(n))) return n;
            }
    }
    function va(t, e) {
        fa.$on(t, e);
    }
    function ya(t, e) {
        fa.$off(t, e);
    }
    function ma(t, e) {
        var n = fa;
        return function r() {
            var o = e.apply(null, arguments);
            null !== o && n.$off(t, r);
        };
    }
    function ba(t, e, n) {
        (fa = t), Li(e, n || {}, va, ya, ma, t), (fa = void 0);
    }
    var ga = null;
    function wa(t) {
        var e = ga;
        return (
            (ga = t),
            function () {
                ga = e;
            }
        );
    }
    function _a(t) {
        for (; t && (t = t.$parent); ) if (t._inactive) return !0;
        return !1;
    }
    function Sa(t, e) {
        if (e) {
            if (((t._directInactive = !1), _a(t))) return;
        } else if (t._directInactive) return;
        if (t._inactive || null === t._inactive) {
            t._inactive = !1;
            for (var n = 0; n < t.$children.length; n++) Sa(t.$children[n]);
            Oa(t, "activated");
        }
    }
    function Aa(t, e) {
        if (!((e && ((t._directInactive = !0), _a(t))) || t._inactive)) {
            t._inactive = !0;
            for (var n = 0; n < t.$children.length; n++) Aa(t.$children[n]);
            Oa(t, "deactivated");
        }
    }
    function Oa(t, e, n) {
        var r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
        fi();
        var o = ei;
        r && ni(t);
        var i = t.$options[e],
            a = "".concat(e, " hook");
        if (i) for (var s = 0, c = i.length; s < c; s++) Fa(i[s], t, n || null, t, a);
        t._hasHookEvent && t.$emit("hook:" + e), r && ni(o), pi();
    }
    var xa = [],
        Ea = [],
        Pa = {},
        Ta = !1,
        ka = !1,
        ja = 0,
        Ca = 0,
        La = Date.now;
    if (Fo && !Ho) {
        var $a = window.performance;
        $a &&
            "function" == typeof $a.now &&
            La() > document.createEvent("Event").timeStamp &&
            (La = function () {
                return $a.now();
            });
    }
    var Ma,
        Ia = function (t, e) {
            if (t.post) {
                if (!e.post) return 1;
            } else if (e.post) return -1;
            return t.id - e.id;
        };
    function Ra() {
        var t, e;
        for (Ca = La(), ka = !0, xa.sort(Ia), ja = 0; ja < xa.length; ja++) (t = xa[ja]).before && t.before(), (e = t.id), (Pa[e] = null), t.run();
        var n = Ea.slice(),
            r = xa.slice();
        (ja = xa.length = Ea.length = 0),
            (Pa = {}),
            (Ta = ka = !1),
            (function (t) {
                for (var e = 0; e < t.length; e++) (t[e]._inactive = !0), Sa(t[e], !0);
            })(n),
            (function (t) {
                for (var e = t.length; e--; ) {
                    var n = t[e],
                        r = n.vm;
                    r && r._watcher === n && r._isMounted && !r._isDestroyed && Oa(r, "updated");
                }
            })(r),
            (function () {
                for (var t = 0; t < ci.length; t++) {
                    var e = ci[t];
                    (e.subs = e.subs.filter(function (t) {
                        return t;
                    })),
                        (e._pending = !1);
                }
                ci.length = 0;
            })(),
            Jo && $o.devtools && Jo.emit("flush");
    }
    var Da = (function () {
        function t() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            Ur(this, t), (this.detached = e), (this.active = !0), (this.effects = []), (this.cleanups = []), (this.parent = Ma), !e && Ma && (this.index = (Ma.scopes || (Ma.scopes = [])).push(this) - 1);
        }
        return (
            Vr(t, [
                {
                    key: "run",
                    value: function (t) {
                        if (this.active) {
                            var e = Ma;
                            try {
                                return (Ma = this), t();
                            } finally {
                                Ma = e;
                            }
                        }
                    },
                },
                {
                    key: "on",
                    value: function () {
                        Ma = this;
                    },
                },
                {
                    key: "off",
                    value: function () {
                        Ma = this.parent;
                    },
                },
                {
                    key: "stop",
                    value: function (t) {
                        if (this.active) {
                            var e, n;
                            for (e = 0, n = this.effects.length; e < n; e++) this.effects[e].teardown();
                            for (e = 0, n = this.cleanups.length; e < n; e++) this.cleanups[e]();
                            if (this.scopes) for (e = 0, n = this.scopes.length; e < n; e++) this.scopes[e].stop(!0);
                            if (!this.detached && this.parent && !t) {
                                var r = this.parent.scopes.pop();
                                r && r !== this && ((this.parent.scopes[this.index] = r), (r.index = this.index));
                            }
                            (this.parent = void 0), (this.active = !1);
                        }
                    },
                },
            ]),
            t
        );
    })();
    function Na(t, e, n) {
        fi();
        try {
            if (e)
                for (var r = e; (r = r.$parent); ) {
                    var o = r.$options.errorCaptured;
                    if (o)
                        for (var i = 0; i < o.length; i++)
                            try {
                                if (!1 === o[i].call(r, t, e, n)) return;
                            } catch (t) {
                                qa(t, r, "errorCaptured hook");
                            }
                }
            qa(t, e, n);
        } finally {
            pi();
        }
    }
    function Fa(t, e, n, r, o) {
        var i;
        try {
            (i = n ? t.apply(e, n) : t.call(e)) &&
                !i._isVue &&
                oo(i) &&
                !i._handled &&
                (i.catch(function (t) {
                    return Na(t, r, o + " (Promise/async)");
                }),
                (i._handled = !0));
        } catch (t) {
            Na(t, r, o);
        }
        return i;
    }
    function qa(t, e, n) {
        if ($o.errorHandler)
            try {
                return $o.errorHandler.call(null, t, e, n);
            } catch (e) {
                e !== t && Ha(e);
            }
        Ha(t);
    }
    function Ha(t, e, n) {
        if (!Fo || "undefined" == typeof console) throw t;
        console.error(t);
    }
    var Ba,
        Ua = !1,
        Wa = [],
        Va = !1;
    function za() {
        Va = !1;
        var t = Wa.slice(0);
        Wa.length = 0;
        for (var e = 0; e < t.length; e++) t[e]();
    }
    if ("undefined" != typeof Promise && Zo(Promise)) {
        var Ka = Promise.resolve();
        (Ba = function () {
            Ka.then(za), Wo && setTimeout(Oo);
        }),
            (Ua = !0);
    } else if (Ho || "undefined" == typeof MutationObserver || (!Zo(MutationObserver) && "[object MutationObserverConstructor]" !== MutationObserver.toString()))
        Ba =
            "undefined" != typeof setImmediate && Zo(setImmediate)
                ? function () {
                      setImmediate(za);
                  }
                : function () {
                      setTimeout(za, 0);
                  };
    else {
        var Ga = 1,
            Ya = new MutationObserver(za),
            Xa = document.createTextNode(String(Ga));
        Ya.observe(Xa, { characterData: !0 }),
            (Ba = function () {
                (Ga = (Ga + 1) % 2), (Xa.data = String(Ga));
            }),
            (Ua = !0);
    }
    function Ja(t, e) {
        var n;
        if (
            (Wa.push(function () {
                if (t)
                    try {
                        t.call(e);
                    } catch (t) {
                        Na(t, e, "nextTick");
                    }
                else n && n(e);
            }),
            Va || ((Va = !0), Ba()),
            !t && "undefined" != typeof Promise)
        )
            return new Promise(function (t) {
                n = t;
            });
    }
    function Za(t) {
        return function (e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ei;
            if (n)
                return (function (t, e, n) {
                    var r = t.$options;
                    r[e] = Ps(r[e], n);
                })(n, t, e);
        };
    }
    Za("beforeMount"), Za("mounted"), Za("beforeUpdate"), Za("updated"), Za("beforeDestroy"), Za("destroyed"), Za("activated"), Za("deactivated"), Za("serverPrefetch"), Za("renderTracked"), Za("renderTriggered"), Za("errorCaptured");
    var Qa = new Qo();
    function ts(t) {
        return es(t, Qa), Qa.clear(), t;
    }
    function es(t, e) {
        var n,
            r,
            o = Gr(t);
        if (!((!o && !to(t)) || t.__v_skip || Object.isFrozen(t) || t instanceof ri)) {
            if (t.__ob__) {
                var i = t.__ob__.dep.id;
                if (e.has(i)) return;
                e.add(i);
            }
            if (o) for (n = t.length; n--; ) es(t[n], e);
            else if (Ti(t)) es(t.value, e);
            else for (n = (r = Object.keys(t)).length; n--; ) es(t[r[n]], e);
        }
    }
    var ns = 0,
        rs = (function () {
            function t(e, n, r, o, i) {
                Ur(this, t),
                    (function (t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Ma;
                        e && e.active && e.effects.push(t);
                    })(this, Ma && !Ma._vm ? Ma : e ? e._scope : void 0),
                    (this.vm = e) && i && (e._watcher = this),
                    o ? ((this.deep = !!o.deep), (this.user = !!o.user), (this.lazy = !!o.lazy), (this.sync = !!o.sync), (this.before = o.before)) : (this.deep = this.user = this.lazy = this.sync = !1),
                    (this.cb = r),
                    (this.id = ++ns),
                    (this.active = !0),
                    (this.post = !1),
                    (this.dirty = this.lazy),
                    (this.deps = []),
                    (this.newDeps = []),
                    (this.depIds = new Qo()),
                    (this.newDepIds = new Qo()),
                    (this.expression = ""),
                    Qr(n)
                        ? (this.getter = n)
                        : ((this.getter = (function (t) {
                              if (!Do.test(t)) {
                                  var e = t.split(".");
                                  return function (t) {
                                      for (var n = 0; n < e.length; n++) {
                                          if (!t) return;
                                          t = t[e[n]];
                                      }
                                      return t;
                                  };
                              }
                          })(n)),
                          this.getter || (this.getter = Oo)),
                    (this.value = this.lazy ? void 0 : this.get());
            }
            return (
                Vr(t, [
                    {
                        key: "get",
                        value: function () {
                            var t;
                            fi(this);
                            var e = this.vm;
                            try {
                                t = this.getter.call(e, e);
                            } catch (t) {
                                if (!this.user) throw t;
                                Na(t, e, 'getter for watcher "'.concat(this.expression, '"'));
                            } finally {
                                this.deep && ts(t), pi(), this.cleanupDeps();
                            }
                            return t;
                        },
                    },
                    {
                        key: "addDep",
                        value: function (t) {
                            var e = t.id;
                            this.newDepIds.has(e) || (this.newDepIds.add(e), this.newDeps.push(t), this.depIds.has(e) || t.addSub(this));
                        },
                    },
                    {
                        key: "cleanupDeps",
                        value: function () {
                            for (var t = this.deps.length; t--; ) {
                                var e = this.deps[t];
                                this.newDepIds.has(e.id) || e.removeSub(this);
                            }
                            var n = this.depIds;
                            (this.depIds = this.newDepIds), (this.newDepIds = n), this.newDepIds.clear(), (n = this.deps), (this.deps = this.newDeps), (this.newDeps = n), (this.newDeps.length = 0);
                        },
                    },
                    {
                        key: "update",
                        value: function () {
                            this.lazy
                                ? (this.dirty = !0)
                                : this.sync
                                ? this.run()
                                : (function (t) {
                                      var e = t.id;
                                      if (null == Pa[e] && (t !== ui.target || !t.noRecurse)) {
                                          if (((Pa[e] = !0), ka)) {
                                              for (var n = xa.length - 1; n > ja && xa[n].id > t.id; ) n--;
                                              xa.splice(n + 1, 0, t);
                                          } else xa.push(t);
                                          Ta || ((Ta = !0), Ja(Ra));
                                      }
                                  })(this);
                        },
                    },
                    {
                        key: "run",
                        value: function () {
                            if (this.active) {
                                var t = this.get();
                                if (t !== this.value || to(t) || this.deep) {
                                    var e = this.value;
                                    if (((this.value = t), this.user)) {
                                        var n = 'callback for watcher "'.concat(this.expression, '"');
                                        Fa(this.cb, this.vm, [t, e], this.vm, n);
                                    } else this.cb.call(this.vm, t, e);
                                }
                            }
                        },
                    },
                    {
                        key: "evaluate",
                        value: function () {
                            (this.value = this.get()), (this.dirty = !1);
                        },
                    },
                    {
                        key: "depend",
                        value: function () {
                            for (var t = this.deps.length; t--; ) this.deps[t].depend();
                        },
                    },
                    {
                        key: "teardown",
                        value: function () {
                            if ((this.vm && !this.vm._isBeingDestroyed && lo(this.vm._scope.effects, this), this.active)) {
                                for (var t = this.deps.length; t--; ) this.deps[t].removeSub(this);
                                (this.active = !1), this.onStop && this.onStop();
                            }
                        },
                    },
                ]),
                t
            );
        })(),
        os = { enumerable: !0, configurable: !0, get: Oo, set: Oo };
    function is(t, e, n) {
        (os.get = function () {
            return this[e][n];
        }),
            (os.set = function (t) {
                this[e][n] = t;
            }),
            Object.defineProperty(t, n, os);
    }
    function as(t) {
        var e = t.$options;
        if (
            (e.props &&
                (function (t, e) {
                    var n = t.$options.propsData || {},
                        r = (t._props = Ei({})),
                        o = (t.$options._propKeys = []);
                    for (var i in (t.$parent && bi(!1), e)) o.push(i), Si(r, i, Ls(i, e, n, t)), i in t || is(t, "_props", i);
                    bi(!0);
                })(t, e.props),
            (function (t) {
                var e = t.$options,
                    n = e.setup;
                if (n) {
                    var r = (t._setupContext = sa(t));
                    ni(t), fi();
                    var o = Fa(n, null, [t._props || Ei({}), r], t, "setup");
                    if ((pi(), ni(), Qr(o))) e.render = o;
                    else if (to(o))
                        if (((t._setupState = o), o.__sfc)) {
                            var i = (t._setupProxy = {});
                            for (var a in o) "__sfc" !== a && ki(i, o, a);
                        } else for (var s in o) Io(s) || ki(t, o, s);
                }
            })(t),
            e.methods &&
                (function (t, e) {
                    for (var n in (t.$options.props, e)) t[n] = "function" != typeof e[n] ? Oo : wo(e[n], t);
                })(t, e.methods),
            e.data)
        )
            !(function (t) {
                var e = t.$options.data;
                no(
                    (e = t._data = Qr(e)
                        ? (function (t, e) {
                              fi();
                              try {
                                  return t.call(e, e);
                              } catch (t) {
                                  return Na(t, e, "data()"), {};
                              } finally {
                                  pi();
                              }
                          })(e, t)
                        : e || {})
                ) || (e = {});
                var n = Object.keys(e),
                    r = t.$options.props;
                t.$options.methods;
                for (var o = n.length; o--; ) {
                    var i = n[o];
                    (r && po(r, i)) || Io(i) || is(t, "_data", i);
                }
                var a = _i(e);
                a && a.vmCount++;
            })(t);
        else {
            var n = _i((t._data = {}));
            n && n.vmCount++;
        }
        e.computed &&
            (function (t, e) {
                var n = (t._computedWatchers = Object.create(null)),
                    r = Xo();
                for (var o in e) {
                    var i = e[o],
                        a = Qr(i) ? i : i.get;
                    r || (n[o] = new rs(t, a || Oo, Oo, ss)), o in t || cs(t, o, i);
                }
            })(t, e.computed),
            e.watch &&
                e.watch !== Ko &&
                (function (t, e) {
                    for (var n in e) {
                        var r = e[n];
                        if (Gr(r)) for (var o = 0; o < r.length; o++) fs(t, n, r[o]);
                        else fs(t, n, r);
                    }
                })(t, e.watch);
    }
    var ss = { lazy: !0 };
    function cs(t, e, n) {
        var r = !Xo();
        Qr(n) ? ((os.get = r ? us(e) : ls(n)), (os.set = Oo)) : ((os.get = n.get ? (r && !1 !== n.cache ? us(e) : ls(n.get)) : Oo), (os.set = n.set || Oo)), Object.defineProperty(t, e, os);
    }
    function us(t) {
        return function () {
            var e = this._computedWatchers && this._computedWatchers[t];
            if (e) return e.dirty && e.evaluate(), ui.target && e.depend(), e.value;
        };
    }
    function ls(t) {
        return function () {
            return t.call(this, this);
        };
    }
    function fs(t, e, n, r) {
        return no(n) && ((r = n), (n = n.handler)), "string" == typeof n && (n = t[n]), t.$watch(e, n, r);
    }
    function ps(t, e) {
        if (t) {
            for (var n = Object.create(null), r = ti ? Reflect.ownKeys(t) : Object.keys(t), o = 0; o < r.length; o++) {
                var i = r[o];
                if ("__ob__" !== i) {
                    var a = t[i].from;
                    if (a in e._provided) n[i] = e._provided[a];
                    else if ("default" in t[i]) {
                        var s = t[i].default;
                        n[i] = Qr(s) ? s.call(e) : s;
                    }
                }
            }
            return n;
        }
    }
    var ds = 0;
    function hs(t) {
        var e = t.options;
        if (t.super) {
            var n = hs(t.super);
            if (n !== t.superOptions) {
                t.superOptions = n;
                var r = (function (t) {
                    var e,
                        n = t.options,
                        r = t.sealedOptions;
                    for (var o in n) n[o] !== r[o] && (e || (e = {}), (e[o] = n[o]));
                    return e;
                })(t);
                r && So(t.extendOptions, r), (e = t.options = js(n, t.extendOptions)).name && (e.components[e.name] = t);
            }
        }
        return e;
    }
    function vs(t, e, n, r, o) {
        var i,
            a = this,
            s = o.options;
        po(r, "_uid") ? ((i = Object.create(r))._original = r) : ((i = r), (r = r._original));
        var c = Jr(s._compiled),
            u = !c;
        (this.data = t),
            (this.props = e),
            (this.children = n),
            (this.parent = r),
            (this.listeners = t.on || Kr),
            (this.injections = ps(s.inject, r)),
            (this.slots = function () {
                return a.$slots || oa(r, t.scopedSlots, (a.$slots = ea(n, r))), a.$slots;
            }),
            Object.defineProperty(this, "scopedSlots", {
                enumerable: !0,
                get: function () {
                    return oa(r, t.scopedSlots, this.slots());
                },
            }),
            c && ((this.$options = s), (this.$slots = this.slots()), (this.$scopedSlots = oa(r, t.scopedSlots, this.$slots))),
            s._scopeId
                ? (this._c = function (t, e, n, o) {
                      var a = Ni(i, t, e, n, o, u);
                      return a && !Gr(a) && ((a.fnScopeId = s._scopeId), (a.fnContext = r)), a;
                  })
                : (this._c = function (t, e, n, r) {
                      return Ni(i, t, e, n, r, u);
                  });
    }
    function ys(t, e, n, r, o) {
        var i = ai(t);
        return (i.fnContext = n), (i.fnOptions = r), e.slot && ((i.data || (i.data = {})).slot = e.slot), i;
    }
    function ms(t, e) {
        for (var n in e) t[yo(n)] = e[n];
    }
    function bs(t) {
        return t.name || t.__name || t._componentTag;
    }
    ta(vs.prototype);
    var gs = {
            init: function (t, e) {
                if (t.componentInstance && !t.componentInstance._isDestroyed && t.data.keepAlive) {
                    var n = t;
                    gs.prepatch(n, n);
                } else
                    (t.componentInstance = (function (t, e) {
                        var n = { _isComponent: !0, _parentVnode: t, parent: e },
                            r = t.data.inlineTemplate;
                        return Xr(r) && ((n.render = r.render), (n.staticRenderFns = r.staticRenderFns)), new t.componentOptions.Ctor(n);
                    })(t, ga)).$mount(e ? t.elm : void 0, e);
            },
            prepatch: function (t, e) {
                var n = e.componentOptions;
                !(function (t, e, n, r, o) {
                    var i = r.data.scopedSlots,
                        a = t.$scopedSlots,
                        s = !!((i && !i.$stable) || (a !== Kr && !a.$stable) || (i && t.$scopedSlots.$key !== i.$key) || (!i && t.$scopedSlots.$key)),
                        c = !!(o || t.$options._renderChildren || s),
                        u = t.$vnode;
                    (t.$options._parentVnode = r), (t.$vnode = r), t._vnode && (t._vnode.parent = r), (t.$options._renderChildren = o);
                    var l = r.data.attrs || Kr;
                    t._attrsProxy && ca(t._attrsProxy, l, (u.data && u.data.attrs) || Kr, t, "$attrs") && (c = !0), (t.$attrs = l), (n = n || Kr);
                    var f = t.$options._parentListeners;
                    if ((t._listenersProxy && ca(t._listenersProxy, n, f || Kr, t, "$listeners"), (t.$listeners = t.$options._parentListeners = n), ba(t, n, f), e && t.$options.props)) {
                        bi(!1);
                        for (var p = t._props, d = t.$options._propKeys || [], h = 0; h < d.length; h++) {
                            var v = d[h],
                                y = t.$options.props;
                            p[v] = Ls(v, y, e, t);
                        }
                        bi(!0), (t.$options.propsData = e);
                    }
                    c && ((t.$slots = ea(o, r.context)), t.$forceUpdate());
                })((e.componentInstance = t.componentInstance), n.propsData, n.listeners, e, n.children);
            },
            insert: function (t) {
                var e,
                    n = t.context,
                    r = t.componentInstance;
                r._isMounted || ((r._isMounted = !0), Oa(r, "mounted")), t.data.keepAlive && (n._isMounted ? (((e = r)._inactive = !1), Ea.push(e)) : Sa(r, !0));
            },
            destroy: function (t) {
                var e = t.componentInstance;
                e._isDestroyed || (t.data.keepAlive ? Aa(e, !0) : e.$destroy());
            },
        },
        ws = Object.keys(gs);
    function _s(t, e, n, r, o) {
        if (!Yr(t)) {
            var i = n.$options._base;
            if ((to(t) && (t = i.extend(t)), "function" == typeof t)) {
                var a;
                if (
                    Yr(t.cid) &&
                    ((t = (function (t, e) {
                        if (Jr(t.error) && Xr(t.errorComp)) return t.errorComp;
                        if (Xr(t.resolved)) return t.resolved;
                        var n = pa;
                        if ((n && Xr(t.owners) && -1 === t.owners.indexOf(n) && t.owners.push(n), Jr(t.loading) && Xr(t.loadingComp))) return t.loadingComp;
                        if (n && !Xr(t.owners)) {
                            var r = (t.owners = [n]),
                                o = !0,
                                i = null,
                                a = null;
                            n.$on("hook:destroyed", function () {
                                return lo(r, n);
                            });
                            var s = function (t) {
                                    for (var e = 0, n = r.length; e < n; e++) r[e].$forceUpdate();
                                    t && ((r.length = 0), null !== i && (clearTimeout(i), (i = null)), null !== a && (clearTimeout(a), (a = null)));
                                },
                                c = ko(function (n) {
                                    (t.resolved = da(n, e)), o ? (r.length = 0) : s(!0);
                                }),
                                u = ko(function (e) {
                                    Xr(t.errorComp) && ((t.error = !0), s(!0));
                                }),
                                l = t(c, u);
                            return (
                                to(l) &&
                                    (oo(l)
                                        ? Yr(t.resolved) && l.then(c, u)
                                        : oo(l.component) &&
                                          (l.component.then(c, u),
                                          Xr(l.error) && (t.errorComp = da(l.error, e)),
                                          Xr(l.loading) &&
                                              ((t.loadingComp = da(l.loading, e)),
                                              0 === l.delay
                                                  ? (t.loading = !0)
                                                  : (i = setTimeout(function () {
                                                        (i = null), Yr(t.resolved) && Yr(t.error) && ((t.loading = !0), s(!1));
                                                    }, l.delay || 200))),
                                          Xr(l.timeout) &&
                                              (a = setTimeout(function () {
                                                  (a = null), Yr(t.resolved) && u(null);
                                              }, l.timeout)))),
                                (o = !1),
                                t.loading ? t.loadingComp : t.resolved
                            );
                        }
                    })((a = t), i)),
                    void 0 === t)
                )
                    return (function (t, e, n, r, o) {
                        var i = oi();
                        return (i.asyncFactory = t), (i.asyncMeta = { data: e, context: n, children: r, tag: o }), i;
                    })(a, e, n, r, o);
                (e = e || {}),
                    hs(t),
                    Xr(e.model) &&
                        (function (t, e) {
                            var n = (t.model && t.model.prop) || "value",
                                r = (t.model && t.model.event) || "input";
                            (e.attrs || (e.attrs = {}))[n] = e.model.value;
                            var o = e.on || (e.on = {}),
                                i = o[r],
                                a = e.model.callback;
                            Xr(i) ? (Gr(i) ? -1 === i.indexOf(a) : i !== a) && (o[r] = [a].concat(i)) : (o[r] = a);
                        })(t.options, e);
                var s = (function (t, e, n) {
                    var r = e.options.props;
                    if (!Yr(r)) {
                        var o = {},
                            i = t.attrs,
                            a = t.props;
                        if (Xr(i) || Xr(a))
                            for (var s in r) {
                                var c = go(s);
                                Mi(o, a, s, c, !0) || Mi(o, i, s, c, !1);
                            }
                        return o;
                    }
                })(e, t);
                if (Jr(t.options.functional))
                    return (function (t, e, n, r, o) {
                        var i = t.options,
                            a = {},
                            s = i.props;
                        if (Xr(s)) for (var c in s) a[c] = Ls(c, s, e || Kr);
                        else Xr(n.attrs) && ms(a, n.attrs), Xr(n.props) && ms(a, n.props);
                        var u = new vs(n, a, o, r, t),
                            l = i.render.call(null, u._c, u);
                        if (l instanceof ri) return ys(l, n, u.parent, i);
                        if (Gr(l)) {
                            for (var f = Ii(l) || [], p = new Array(f.length), d = 0; d < f.length; d++) p[d] = ys(f[d], n, u.parent, i);
                            return p;
                        }
                    })(t, s, e, n, r);
                var c = e.on;
                if (((e.on = e.nativeOn), Jr(t.options.abstract))) {
                    var u = e.slot;
                    (e = {}), u && (e.slot = u);
                }
                !(function (t) {
                    for (var e = t.hook || (t.hook = {}), n = 0; n < ws.length; n++) {
                        var r = ws[n],
                            o = e[r],
                            i = gs[r];
                        o === i || (o && o._merged) || (e[r] = o ? Ss(i, o) : i);
                    }
                })(e);
                var l = bs(t.options) || o;
                return new ri("vue-component-".concat(t.cid).concat(l ? "-".concat(l) : ""), e, void 0, void 0, void 0, n, { Ctor: t, propsData: s, listeners: c, tag: o, children: r }, a);
            }
        }
    }
    function Ss(t, e) {
        var n = function (n, r) {
            t(n, r), e(n, r);
        };
        return (n._merged = !0), n;
    }
    var As = Oo,
        Os = $o.optionMergeStrategies;
    function xs(t, e) {
        var n,
            r,
            o,
            i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
        if (!e) return t;
        for (var a = ti ? Reflect.ownKeys(e) : Object.keys(e), s = 0; s < a.length; s++) "__ob__" !== (n = a[s]) && ((r = t[n]), (o = e[n]), i && po(t, n) ? r !== o && no(r) && no(o) && xs(r, o) : Ai(t, n, o));
        return t;
    }
    function Es(t, e, n) {
        return n
            ? function () {
                  var r = Qr(e) ? e.call(n, n) : e,
                      o = Qr(t) ? t.call(n, n) : t;
                  return r ? xs(r, o) : o;
              }
            : e
            ? t
                ? function () {
                      return xs(Qr(e) ? e.call(this, this) : e, Qr(t) ? t.call(this, this) : t);
                  }
                : e
            : t;
    }
    function Ps(t, e) {
        var n = e ? (t ? t.concat(e) : Gr(e) ? e : [e]) : t;
        return n
            ? (function (t) {
                  for (var e = [], n = 0; n < t.length; n++) -1 === e.indexOf(t[n]) && e.push(t[n]);
                  return e;
              })(n)
            : n;
    }
    function Ts(t, e, n, r) {
        var o = Object.create(t || null);
        return e ? So(o, e) : o;
    }
    (Os.data = function (t, e, n) {
        return n ? Es(t, e, n) : e && "function" != typeof e ? t : Es(t, e);
    }),
        Lo.forEach(function (t) {
            Os[t] = Ps;
        }),
        Co.forEach(function (t) {
            Os[t + "s"] = Ts;
        }),
        (Os.watch = function (t, e, n, r) {
            if ((t === Ko && (t = void 0), e === Ko && (e = void 0), !e)) return Object.create(t || null);
            if (!t) return e;
            var o = {};
            for (var i in (So(o, t), e)) {
                var a = o[i],
                    s = e[i];
                a && !Gr(a) && (a = [a]), (o[i] = a ? a.concat(s) : Gr(s) ? s : [s]);
            }
            return o;
        }),
        (Os.props = Os.methods = Os.inject = Os.computed = function (t, e, n, r) {
            if (!t) return e;
            var o = Object.create(null);
            return So(o, t), e && So(o, e), o;
        }),
        (Os.provide = function (t, e) {
            return t
                ? function () {
                      var n = Object.create(null);
                      return xs(n, Qr(t) ? t.call(this) : t), e && xs(n, Qr(e) ? e.call(this) : e, !1), n;
                  }
                : e;
        });
    var ks = function (t, e) {
        return void 0 === e ? t : e;
    };
    function js(t, e, n) {
        if (
            (Qr(e) && (e = e.options),
            (function (t, e) {
                var n = t.props;
                if (n) {
                    var r,
                        o,
                        i = {};
                    if (Gr(n)) for (r = n.length; r--; ) "string" == typeof (o = n[r]) && (i[yo(o)] = { type: null });
                    else if (no(n)) for (var a in n) (o = n[a]), (i[yo(a)] = no(o) ? o : { type: o });
                    t.props = i;
                }
            })(e),
            (function (t, e) {
                var n = t.inject;
                if (n) {
                    var r = (t.inject = {});
                    if (Gr(n)) for (var o = 0; o < n.length; o++) r[n[o]] = { from: n[o] };
                    else if (no(n))
                        for (var i in n) {
                            var a = n[i];
                            r[i] = no(a) ? So({ from: i }, a) : { from: a };
                        }
                }
            })(e),
            (function (t) {
                var e = t.directives;
                if (e)
                    for (var n in e) {
                        var r = e[n];
                        Qr(r) && (e[n] = { bind: r, update: r });
                    }
            })(e),
            !e._base && (e.extends && (t = js(t, e.extends, n)), e.mixins))
        )
            for (var r = 0, o = e.mixins.length; r < o; r++) t = js(t, e.mixins[r], n);
        var i,
            a = {};
        for (i in t) s(i);
        for (i in e) po(t, i) || s(i);
        function s(r) {
            var o = Os[r] || ks;
            a[r] = o(t[r], e[r], n, r);
        }
        return a;
    }
    function Cs(t, e, n, r) {
        if ("string" == typeof n) {
            var o = t[e];
            if (po(o, n)) return o[n];
            var i = yo(n);
            if (po(o, i)) return o[i];
            var a = mo(i);
            return po(o, a) ? o[a] : o[n] || o[i] || o[a];
        }
    }
    function Ls(t, e, n, r) {
        var o = e[t],
            i = !po(n, t),
            a = n[t],
            s = Rs(Boolean, o.type);
        if (s > -1)
            if (i && !po(o, "default")) a = !1;
            else if ("" === a || a === go(t)) {
                var c = Rs(String, o.type);
                (c < 0 || s < c) && (a = !0);
            }
        if (void 0 === a) {
            a = (function (t, e, n) {
                if (po(e, "default")) {
                    var r = e.default;
                    return t && t.$options.propsData && void 0 === t.$options.propsData[n] && void 0 !== t._props[n] ? t._props[n] : Qr(r) && "Function" !== Ms(e.type) ? r.call(t) : r;
                }
            })(r, o, t);
            var u = mi;
            bi(!0), _i(a), bi(u);
        }
        return a;
    }
    var $s = /^\s*function (\w+)/;
    function Ms(t) {
        var e = t && t.toString().match($s);
        return e ? e[1] : "";
    }
    function Is(t, e) {
        return Ms(t) === Ms(e);
    }
    function Rs(t, e) {
        if (!Gr(e)) return Is(e, t) ? 0 : -1;
        for (var n = 0, r = e.length; n < r; n++) if (Is(e[n], t)) return n;
        return -1;
    }
    function Ds(t) {
        this._init(t);
    }
    function Ns(t) {
        return t && (bs(t.Ctor.options) || t.tag);
    }
    function Fs(t, e) {
        return Gr(t) ? t.indexOf(e) > -1 : "string" == typeof t ? t.split(",").indexOf(e) > -1 : ((n = t), "[object RegExp]" === eo.call(n) && t.test(e));
        var n;
    }
    function qs(t, e) {
        var n = t.cache,
            r = t.keys,
            o = t._vnode;
        for (var i in n) {
            var a = n[i];
            if (a) {
                var s = a.name;
                s && !e(s) && Hs(n, i, r, o);
            }
        }
    }
    function Hs(t, e, n, r) {
        var o = t[e];
        !o || (r && o.tag === r.tag) || o.componentInstance.$destroy(), (t[e] = null), lo(n, e);
    }
    !(function (t) {
        t.prototype._init = function (t) {
            var e = this;
            (e._uid = ds++),
                (e._isVue = !0),
                (e.__v_skip = !0),
                (e._scope = new Da(!0)),
                (e._scope._vm = !0),
                t && t._isComponent
                    ? (function (t, e) {
                          var n = (t.$options = Object.create(t.constructor.options)),
                              r = e._parentVnode;
                          (n.parent = e.parent), (n._parentVnode = r);
                          var o = r.componentOptions;
                          (n.propsData = o.propsData), (n._parentListeners = o.listeners), (n._renderChildren = o.children), (n._componentTag = o.tag), e.render && ((n.render = e.render), (n.staticRenderFns = e.staticRenderFns));
                      })(e, t)
                    : (e.$options = js(hs(e.constructor), t || {}, e)),
                (e._renderProxy = e),
                (e._self = e),
                (function (t) {
                    var e = t.$options,
                        n = e.parent;
                    if (n && !e.abstract) {
                        for (; n.$options.abstract && n.$parent; ) n = n.$parent;
                        n.$children.push(t);
                    }
                    (t.$parent = n),
                        (t.$root = n ? n.$root : t),
                        (t.$children = []),
                        (t.$refs = {}),
                        (t._provided = n ? n._provided : Object.create(null)),
                        (t._watcher = null),
                        (t._inactive = null),
                        (t._directInactive = !1),
                        (t._isMounted = !1),
                        (t._isDestroyed = !1),
                        (t._isBeingDestroyed = !1);
                })(e),
                (function (t) {
                    (t._events = Object.create(null)), (t._hasHookEvent = !1);
                    var e = t.$options._parentListeners;
                    e && ba(t, e);
                })(e),
                (function (t) {
                    (t._vnode = null), (t._staticTrees = null);
                    var e = t.$options,
                        n = (t.$vnode = e._parentVnode),
                        r = n && n.context;
                    (t.$slots = ea(e._renderChildren, r)),
                        (t.$scopedSlots = n ? oa(t.$parent, n.data.scopedSlots, t.$slots) : Kr),
                        (t._c = function (e, n, r, o) {
                            return Ni(t, e, n, r, o, !1);
                        }),
                        (t.$createElement = function (e, n, r, o) {
                            return Ni(t, e, n, r, o, !0);
                        });
                    var o = n && n.data;
                    Si(t, "$attrs", (o && o.attrs) || Kr, null, !0), Si(t, "$listeners", e._parentListeners || Kr, null, !0);
                })(e),
                Oa(e, "beforeCreate", void 0, !1),
                (function (t) {
                    var e = ps(t.$options.inject, t);
                    e &&
                        (bi(!1),
                        Object.keys(e).forEach(function (n) {
                            Si(t, n, e[n]);
                        }),
                        bi(!0));
                })(e),
                as(e),
                (function (t) {
                    var e = t.$options.provide;
                    if (e) {
                        var n = Qr(e) ? e.call(t) : e;
                        if (!to(n)) return;
                        for (
                            var r = (function (t) {
                                    var e = t._provided,
                                        n = t.$parent && t.$parent._provided;
                                    return n === e ? (t._provided = Object.create(n)) : e;
                                })(t),
                                o = ti ? Reflect.ownKeys(n) : Object.keys(n),
                                i = 0;
                            i < o.length;
                            i++
                        ) {
                            var a = o[i];
                            Object.defineProperty(r, a, Object.getOwnPropertyDescriptor(n, a));
                        }
                    }
                })(e),
                Oa(e, "created"),
                e.$options.el && e.$mount(e.$options.el);
        };
    })(Ds),
        (function (t) {
            Object.defineProperty(t.prototype, "$data", {
                get: function () {
                    return this._data;
                },
            }),
                Object.defineProperty(t.prototype, "$props", {
                    get: function () {
                        return this._props;
                    },
                }),
                (t.prototype.$set = Ai),
                (t.prototype.$delete = Oi),
                (t.prototype.$watch = function (t, e, n) {
                    var r = this;
                    if (no(e)) return fs(r, t, e, n);
                    (n = n || {}).user = !0;
                    var o = new rs(r, t, e, n);
                    if (n.immediate) {
                        var i = 'callback for immediate watcher "'.concat(o.expression, '"');
                        fi(), Fa(e, r, [o.value], r, i), pi();
                    }
                    return function () {
                        o.teardown();
                    };
                });
        })(Ds),
        (function (t) {
            var e = /^hook:/;
            (t.prototype.$on = function (t, n) {
                var r = this;
                if (Gr(t)) for (var o = 0, i = t.length; o < i; o++) r.$on(t[o], n);
                else (r._events[t] || (r._events[t] = [])).push(n), e.test(t) && (r._hasHookEvent = !0);
                return r;
            }),
                (t.prototype.$once = function (t, e) {
                    var n = this;
                    function r() {
                        n.$off(t, r), e.apply(n, arguments);
                    }
                    return (r.fn = e), n.$on(t, r), n;
                }),
                (t.prototype.$off = function (t, e) {
                    var n = this;
                    if (!arguments.length) return (n._events = Object.create(null)), n;
                    if (Gr(t)) {
                        for (var r = 0, o = t.length; r < o; r++) n.$off(t[r], e);
                        return n;
                    }
                    var i = n._events[t];
                    if (!i) return n;
                    if (!e) return (n._events[t] = null), n;
                    for (var a, s = i.length; s--; )
                        if ((a = i[s]) === e || a.fn === e) {
                            i.splice(s, 1);
                            break;
                        }
                    return n;
                }),
                (t.prototype.$emit = function (t) {
                    var e = this,
                        n = e._events[t];
                    if (n) {
                        n = n.length > 1 ? _o(n) : n;
                        for (var r = _o(arguments, 1), o = 'event handler for "'.concat(t, '"'), i = 0, a = n.length; i < a; i++) Fa(n[i], e, r, e, o);
                    }
                    return e;
                });
        })(Ds),
        (function (t) {
            (t.prototype._update = function (t, e) {
                var n = this,
                    r = n.$el,
                    o = n._vnode,
                    i = wa(n);
                (n._vnode = t), (n.$el = o ? n.__patch__(o, t) : n.__patch__(n.$el, t, e, !1)), i(), r && (r.__vue__ = null), n.$el && (n.$el.__vue__ = n);
                for (var a = n; a && a.$vnode && a.$parent && a.$vnode === a.$parent._vnode; ) (a.$parent.$el = a.$el), (a = a.$parent);
            }),
                (t.prototype.$forceUpdate = function () {
                    this._watcher && this._watcher.update();
                }),
                (t.prototype.$destroy = function () {
                    var t = this;
                    if (!t._isBeingDestroyed) {
                        Oa(t, "beforeDestroy"), (t._isBeingDestroyed = !0);
                        var e = t.$parent;
                        !e || e._isBeingDestroyed || t.$options.abstract || lo(e.$children, t),
                            t._scope.stop(),
                            t._data.__ob__ && t._data.__ob__.vmCount--,
                            (t._isDestroyed = !0),
                            t.__patch__(t._vnode, null),
                            Oa(t, "destroyed"),
                            t.$off(),
                            t.$el && (t.$el.__vue__ = null),
                            t.$vnode && (t.$vnode.parent = null);
                    }
                });
        })(Ds),
        (function (t) {
            ta(t.prototype),
                (t.prototype.$nextTick = function (t) {
                    return Ja(t, this);
                }),
                (t.prototype._render = function () {
                    var t,
                        e = this,
                        n = e.$options,
                        r = n.render,
                        o = n._parentVnode;
                    o && e._isMounted && ((e.$scopedSlots = oa(e.$parent, o.data.scopedSlots, e.$slots, e.$scopedSlots)), e._slotsProxy && la(e._slotsProxy, e.$scopedSlots)), (e.$vnode = o);
                    try {
                        ni(e), (pa = e), (t = r.call(e._renderProxy, e.$createElement));
                    } catch (n) {
                        Na(n, e, "render"), (t = e._vnode);
                    } finally {
                        (pa = null), ni();
                    }
                    return Gr(t) && 1 === t.length && (t = t[0]), t instanceof ri || (t = oi()), (t.parent = o), t;
                });
        })(Ds);
    var Bs = [String, RegExp, Array],
        Us = {
            KeepAlive: {
                name: "keep-alive",
                abstract: !0,
                props: { include: Bs, exclude: Bs, max: [String, Number] },
                methods: {
                    cacheVNode: function () {
                        var t = this.cache,
                            e = this.keys,
                            n = this.vnodeToCache,
                            r = this.keyToCache;
                        if (n) {
                            var o = n.tag,
                                i = n.componentInstance,
                                a = n.componentOptions;
                            (t[r] = { name: Ns(a), tag: o, componentInstance: i }), e.push(r), this.max && e.length > parseInt(this.max) && Hs(t, e[0], e, this._vnode), (this.vnodeToCache = null);
                        }
                    },
                },
                created: function () {
                    (this.cache = Object.create(null)), (this.keys = []);
                },
                destroyed: function () {
                    for (var t in this.cache) Hs(this.cache, t, this.keys);
                },
                mounted: function () {
                    var t = this;
                    this.cacheVNode(),
                        this.$watch("include", function (e) {
                            qs(t, function (t) {
                                return Fs(e, t);
                            });
                        }),
                        this.$watch("exclude", function (e) {
                            qs(t, function (t) {
                                return !Fs(e, t);
                            });
                        });
                },
                updated: function () {
                    this.cacheVNode();
                },
                render: function () {
                    var t = this.$slots.default,
                        e = ha(t),
                        n = e && e.componentOptions;
                    if (n) {
                        var r = Ns(n),
                            o = this.include,
                            i = this.exclude;
                        if ((o && (!r || !Fs(o, r))) || (i && r && Fs(i, r))) return e;
                        var a = this.cache,
                            s = this.keys,
                            c = null == e.key ? n.Ctor.cid + (n.tag ? "::".concat(n.tag) : "") : e.key;
                        a[c] ? ((e.componentInstance = a[c].componentInstance), lo(s, c), s.push(c)) : ((this.vnodeToCache = e), (this.keyToCache = c)), (e.data.keepAlive = !0);
                    }
                    return e || (t && t[0]);
                },
            },
        };
    !(function (t) {
        var e = {
            get: function () {
                return $o;
            },
        };
        Object.defineProperty(t, "config", e),
            (t.util = { warn: As, extend: So, mergeOptions: js, defineReactive: Si }),
            (t.set = Ai),
            (t.delete = Oi),
            (t.nextTick = Ja),
            (t.observable = function (t) {
                return _i(t), t;
            }),
            (t.options = Object.create(null)),
            Co.forEach(function (e) {
                t.options[e + "s"] = Object.create(null);
            }),
            (t.options._base = t),
            So(t.options.components, Us),
            (function (t) {
                t.use = function (t) {
                    var e = this._installedPlugins || (this._installedPlugins = []);
                    if (e.indexOf(t) > -1) return this;
                    var n = _o(arguments, 1);
                    return n.unshift(this), Qr(t.install) ? t.install.apply(t, n) : Qr(t) && t.apply(null, n), e.push(t), this;
                };
            })(t),
            (function (t) {
                t.mixin = function (t) {
                    return (this.options = js(this.options, t)), this;
                };
            })(t),
            (function (t) {
                t.cid = 0;
                var e = 1;
                t.extend = function (t) {
                    t = t || {};
                    var n = this,
                        r = n.cid,
                        o = t._Ctor || (t._Ctor = {});
                    if (o[r]) return o[r];
                    var i = bs(t) || bs(n.options),
                        a = function (t) {
                            this._init(t);
                        };
                    return (
                        ((a.prototype = Object.create(n.prototype)).constructor = a),
                        (a.cid = e++),
                        (a.options = js(n.options, t)),
                        (a.super = n),
                        a.options.props &&
                            (function (t) {
                                var e = t.options.props;
                                for (var n in e) is(t.prototype, "_props", n);
                            })(a),
                        a.options.computed &&
                            (function (t) {
                                var e = t.options.computed;
                                for (var n in e) cs(t.prototype, n, e[n]);
                            })(a),
                        (a.extend = n.extend),
                        (a.mixin = n.mixin),
                        (a.use = n.use),
                        Co.forEach(function (t) {
                            a[t] = n[t];
                        }),
                        i && (a.options.components[i] = a),
                        (a.superOptions = n.options),
                        (a.extendOptions = t),
                        (a.sealedOptions = So({}, a.options)),
                        (o[r] = a),
                        a
                    );
                };
            })(t),
            (function (t) {
                Co.forEach(function (e) {
                    t[e] = function (t, n) {
                        return n
                            ? ("component" === e && no(n) && ((n.name = n.name || t), (n = this.options._base.extend(n))), "directive" === e && Qr(n) && (n = { bind: n, update: n }), (this.options[e + "s"][t] = n), n)
                            : this.options[e + "s"][t];
                    };
                });
            })(t);
    })(Ds),
        Object.defineProperty(Ds.prototype, "$isServer", { get: Xo }),
        Object.defineProperty(Ds.prototype, "$ssrContext", {
            get: function () {
                return this.$vnode && this.$vnode.ssrContext;
            },
        }),
        Object.defineProperty(Ds, "FunctionalRenderContext", { value: vs }),
        (Ds.version = "2.7.14");
    var Ws = so("style,class"),
        Vs = so("input,textarea,option,select,progress"),
        zs = function (t, e, n) {
            return ("value" === n && Vs(t) && "button" !== e) || ("selected" === n && "option" === t) || ("checked" === n && "input" === t) || ("muted" === n && "video" === t);
        },
        Ks = so("contenteditable,draggable,spellcheck"),
        Gs = so("events,caret,typing,plaintext-only"),
        Ys = so(
            "allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible"
        ),
        Xs = "http://www.w3.org/1999/xlink",
        Js = function (t) {
            return ":" === t.charAt(5) && "xlink" === t.slice(0, 5);
        },
        Zs = function (t) {
            return Js(t) ? t.slice(6, t.length) : "";
        },
        Qs = function (t) {
            return null == t || !1 === t;
        };
    function tc(t, e) {
        return { staticClass: ec(t.staticClass, e.staticClass), class: Xr(t.class) ? [t.class, e.class] : e.class };
    }
    function ec(t, e) {
        return t ? (e ? t + " " + e : t) : e || "";
    }
    function nc(t) {
        return Array.isArray(t)
            ? (function (t) {
                  for (var e, n = "", r = 0, o = t.length; r < o; r++) Xr((e = nc(t[r]))) && "" !== e && (n && (n += " "), (n += e));
                  return n;
              })(t)
            : to(t)
            ? (function (t) {
                  var e = "";
                  for (var n in t) t[n] && (e && (e += " "), (e += n));
                  return e;
              })(t)
            : "string" == typeof t
            ? t
            : "";
    }
    var rc = { svg: "http://www.w3.org/2000/svg", math: "http://www.w3.org/1998/Math/MathML" },
        oc = so(
            "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"
        ),
        ic = so("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view", !0),
        ac = function (t) {
            return oc(t) || ic(t);
        };
    function sc(t) {
        return ic(t) ? "svg" : "math" === t ? "math" : void 0;
    }
    var cc = Object.create(null),
        uc = so("text,number,password,search,email,tel,url");
    function lc(t) {
        return "string" == typeof t ? document.querySelector(t) || document.createElement("div") : t;
    }
    var fc = Object.freeze({
            __proto__: null,
            createElement: function (t, e) {
                var n = document.createElement(t);
                return "select" !== t || (e.data && e.data.attrs && void 0 !== e.data.attrs.multiple && n.setAttribute("multiple", "multiple")), n;
            },
            createElementNS: function (t, e) {
                return document.createElementNS(rc[t], e);
            },
            createTextNode: function (t) {
                return document.createTextNode(t);
            },
            createComment: function (t) {
                return document.createComment(t);
            },
            insertBefore: function (t, e, n) {
                t.insertBefore(e, n);
            },
            removeChild: function (t, e) {
                t.removeChild(e);
            },
            appendChild: function (t, e) {
                t.appendChild(e);
            },
            parentNode: function (t) {
                return t.parentNode;
            },
            nextSibling: function (t) {
                return t.nextSibling;
            },
            tagName: function (t) {
                return t.tagName;
            },
            setTextContent: function (t, e) {
                t.textContent = e;
            },
            setStyleScope: function (t, e) {
                t.setAttribute(e, "");
            },
        }),
        pc = {
            create: function (t, e) {
                dc(e);
            },
            update: function (t, e) {
                t.data.ref !== e.data.ref && (dc(t, !0), dc(e));
            },
            destroy: function (t) {
                dc(t, !0);
            },
        };
    function dc(t, e) {
        var n = t.data.ref;
        if (Xr(n)) {
            var r = t.context,
                o = t.componentInstance || t.elm,
                i = e ? null : o,
                a = e ? void 0 : o;
            if (Qr(n)) Fa(n, r, [i], r, "template ref function");
            else {
                var s = t.data.refInFor,
                    c = "string" == typeof n || "number" == typeof n,
                    u = Ti(n),
                    l = r.$refs;
                if (c || u)
                    if (s) {
                        var f = c ? l[n] : n.value;
                        e ? Gr(f) && lo(f, o) : Gr(f) ? f.includes(o) || f.push(o) : c ? ((l[n] = [o]), hc(r, n, l[n])) : (n.value = [o]);
                    } else if (c) {
                        if (e && l[n] !== o) return;
                        (l[n] = a), hc(r, n, i);
                    } else if (u) {
                        if (e && n.value !== o) return;
                        n.value = i;
                    }
            }
        }
    }
    function hc(t, e, n) {
        var r = t._setupState;
        r && po(r, e) && (Ti(r[e]) ? (r[e].value = n) : (r[e] = n));
    }
    var vc = new ri("", {}, []),
        yc = ["create", "activate", "update", "remove", "destroy"];
    function mc(t, e) {
        return (
            t.key === e.key &&
            t.asyncFactory === e.asyncFactory &&
            ((t.tag === e.tag &&
                t.isComment === e.isComment &&
                Xr(t.data) === Xr(e.data) &&
                (function (t, e) {
                    if ("input" !== t.tag) return !0;
                    var n,
                        r = Xr((n = t.data)) && Xr((n = n.attrs)) && n.type,
                        o = Xr((n = e.data)) && Xr((n = n.attrs)) && n.type;
                    return r === o || (uc(r) && uc(o));
                })(t, e)) ||
                (Jr(t.isAsyncPlaceholder) && Yr(e.asyncFactory.error)))
        );
    }
    function bc(t, e, n) {
        var r,
            o,
            i = {};
        for (r = e; r <= n; ++r) Xr((o = t[r].key)) && (i[o] = r);
        return i;
    }
    var gc = {
        create: wc,
        update: wc,
        destroy: function (t) {
            wc(t, vc);
        },
    };
    function wc(t, e) {
        (t.data.directives || e.data.directives) &&
            (function (t, e) {
                var n,
                    r,
                    o,
                    i = t === vc,
                    a = e === vc,
                    s = Sc(t.data.directives, t.context),
                    c = Sc(e.data.directives, e.context),
                    u = [],
                    l = [];
                for (n in c) (r = s[n]), (o = c[n]), r ? ((o.oldValue = r.value), (o.oldArg = r.arg), Oc(o, "update", e, t), o.def && o.def.componentUpdated && l.push(o)) : (Oc(o, "bind", e, t), o.def && o.def.inserted && u.push(o));
                if (u.length) {
                    var f = function () {
                        for (var n = 0; n < u.length; n++) Oc(u[n], "inserted", e, t);
                    };
                    i ? $i(e, "insert", f) : f();
                }
                if (
                    (l.length &&
                        $i(e, "postpatch", function () {
                            for (var n = 0; n < l.length; n++) Oc(l[n], "componentUpdated", e, t);
                        }),
                    !i)
                )
                    for (n in s) c[n] || Oc(s[n], "unbind", t, t, a);
            })(t, e);
    }
    var _c = Object.create(null);
    function Sc(t, e) {
        var n,
            r,
            o = Object.create(null);
        if (!t) return o;
        for (n = 0; n < t.length; n++) {
            if (((r = t[n]).modifiers || (r.modifiers = _c), (o[Ac(r)] = r), e._setupState && e._setupState.__sfc)) {
                var i = r.def || Cs(e, "_setupState", "v-" + r.name);
                r.def = "function" == typeof i ? { bind: i, update: i } : i;
            }
            r.def = r.def || Cs(e.$options, "directives", r.name);
        }
        return o;
    }
    function Ac(t) {
        return t.rawName || "".concat(t.name, ".").concat(Object.keys(t.modifiers || {}).join("."));
    }
    function Oc(t, e, n, r, o) {
        var i = t.def && t.def[e];
        if (i)
            try {
                i(n.elm, t, n, r, o);
            } catch (r) {
                Na(r, n.context, "directive ".concat(t.name, " ").concat(e, " hook"));
            }
    }
    var xc = [pc, gc];
    function Ec(t, e) {
        var n = e.componentOptions;
        if (!((Xr(n) && !1 === n.Ctor.options.inheritAttrs) || (Yr(t.data.attrs) && Yr(e.data.attrs)))) {
            var r,
                o,
                i = e.elm,
                a = t.data.attrs || {},
                s = e.data.attrs || {};
            for (r in ((Xr(s.__ob__) || Jr(s._v_attr_proxy)) && (s = e.data.attrs = So({}, s)), s)) (o = s[r]), a[r] !== o && Pc(i, r, o, e.data.pre);
            for (r in ((Ho || Uo) && s.value !== a.value && Pc(i, "value", s.value), a)) Yr(s[r]) && (Js(r) ? i.removeAttributeNS(Xs, Zs(r)) : Ks(r) || i.removeAttribute(r));
        }
    }
    function Pc(t, e, n, r) {
        r || t.tagName.indexOf("-") > -1
            ? Tc(t, e, n)
            : Ys(e)
            ? Qs(n)
                ? t.removeAttribute(e)
                : ((n = "allowfullscreen" === e && "EMBED" === t.tagName ? "true" : e), t.setAttribute(e, n))
            : Ks(e)
            ? t.setAttribute(
                  e,
                  (function (t, e) {
                      return Qs(e) || "false" === e ? "false" : "contenteditable" === t && Gs(e) ? e : "true";
                  })(e, n)
              )
            : Js(e)
            ? Qs(n)
                ? t.removeAttributeNS(Xs, Zs(e))
                : t.setAttributeNS(Xs, e, n)
            : Tc(t, e, n);
    }
    function Tc(t, e, n) {
        Qs(n)
            ? t.removeAttribute(e)
            : (!Ho ||
                  Bo ||
                  "TEXTAREA" !== t.tagName ||
                  "placeholder" !== e ||
                  "" === n ||
                  t.__ieph ||
                  (t.addEventListener("input", function e(n) {
                      n.stopImmediatePropagation(), t.removeEventListener("input", e);
                  }),
                  (t.__ieph = !0)),
              t.setAttribute(e, n));
    }
    var kc = { create: Ec, update: Ec };
    function jc(t, e) {
        var n = e.elm,
            r = e.data,
            o = t.data;
        if (!(Yr(r.staticClass) && Yr(r.class) && (Yr(o) || (Yr(o.staticClass) && Yr(o.class))))) {
            var i = (function (t) {
                    for (var e = t.data, n = t, r = t; Xr(r.componentInstance); ) (r = r.componentInstance._vnode) && r.data && (e = tc(r.data, e));
                    for (; Xr((n = n.parent)); ) n && n.data && (e = tc(e, n.data));
                    return (function (t, e) {
                        return Xr(t) || Xr(e) ? ec(t, nc(e)) : "";
                    })(e.staticClass, e.class);
                })(e),
                a = n._transitionClasses;
            Xr(a) && (i = ec(i, nc(a))), i !== n._prevClass && (n.setAttribute("class", i), (n._prevClass = i));
        }
    }
    var Cc,
        Lc,
        $c,
        Mc,
        Ic,
        Rc,
        Dc,
        Nc = { create: jc, update: jc },
        Fc = /[\w).+\-_$\]]/;
    function qc(t) {
        var e,
            n,
            r,
            o,
            i,
            a = !1,
            s = !1,
            c = !1,
            u = !1,
            l = 0,
            f = 0,
            p = 0,
            d = 0;
        for (r = 0; r < t.length; r++)
            if (((n = e), (e = t.charCodeAt(r)), a)) 39 === e && 92 !== n && (a = !1);
            else if (s) 34 === e && 92 !== n && (s = !1);
            else if (c) 96 === e && 92 !== n && (c = !1);
            else if (u) 47 === e && 92 !== n && (u = !1);
            else if (124 !== e || 124 === t.charCodeAt(r + 1) || 124 === t.charCodeAt(r - 1) || l || f || p) {
                switch (e) {
                    case 34:
                        s = !0;
                        break;
                    case 39:
                        a = !0;
                        break;
                    case 96:
                        c = !0;
                        break;
                    case 40:
                        p++;
                        break;
                    case 41:
                        p--;
                        break;
                    case 91:
                        f++;
                        break;
                    case 93:
                        f--;
                        break;
                    case 123:
                        l++;
                        break;
                    case 125:
                        l--;
                }
                if (47 === e) {
                    for (var h = void 0, v = r - 1; v >= 0 && " " === (h = t.charAt(v)); v--);
                    (h && Fc.test(h)) || (u = !0);
                }
            } else void 0 === o ? ((d = r + 1), (o = t.slice(0, r).trim())) : y();
        function y() {
            (i || (i = [])).push(t.slice(d, r).trim()), (d = r + 1);
        }
        if ((void 0 === o ? (o = t.slice(0, r).trim()) : 0 !== d && y(), i)) for (r = 0; r < i.length; r++) o = Hc(o, i[r]);
        return o;
    }
    function Hc(t, e) {
        var n = e.indexOf("(");
        if (n < 0) return '_f("'.concat(e, '")(').concat(t, ")");
        var r = e.slice(0, n),
            o = e.slice(n + 1);
        return '_f("'
            .concat(r, '")(')
            .concat(t)
            .concat(")" !== o ? "," + o : o);
    }
    function Bc(t, e) {
        console.error("[Vue compiler]: ".concat(t));
    }
    function Uc(t, e) {
        return t
            ? t
                  .map(function (t) {
                      return t[e];
                  })
                  .filter(function (t) {
                      return t;
                  })
            : [];
    }
    function Wc(t, e, n, r, o) {
        (t.props || (t.props = [])).push(Qc({ name: e, value: n, dynamic: o }, r)), (t.plain = !1);
    }
    function Vc(t, e, n, r, o) {
        (o ? t.dynamicAttrs || (t.dynamicAttrs = []) : t.attrs || (t.attrs = [])).push(Qc({ name: e, value: n, dynamic: o }, r)), (t.plain = !1);
    }
    function zc(t, e, n, r) {
        (t.attrsMap[e] = n), t.attrsList.push(Qc({ name: e, value: n }, r));
    }
    function Kc(t, e, n, r, o, i, a, s) {
        (t.directives || (t.directives = [])).push(Qc({ name: e, rawName: n, value: r, arg: o, isDynamicArg: i, modifiers: a }, s)), (t.plain = !1);
    }
    function Gc(t, e, n) {
        return n ? "_p(".concat(e, ',"').concat(t, '")') : t + e;
    }
    function Yc(t, e, n, r, o, i, a, s) {
        var c;
        (r = r || Kr).right
            ? s
                ? (e = "(".concat(e, ")==='click'?'contextmenu':(").concat(e, ")"))
                : "click" === e && ((e = "contextmenu"), delete r.right)
            : r.middle && (s ? (e = "(".concat(e, ")==='click'?'mouseup':(").concat(e, ")")) : "click" === e && (e = "mouseup")),
            r.capture && (delete r.capture, (e = Gc("!", e, s))),
            r.once && (delete r.once, (e = Gc("~", e, s))),
            r.passive && (delete r.passive, (e = Gc("&", e, s))),
            r.native ? (delete r.native, (c = t.nativeEvents || (t.nativeEvents = {}))) : (c = t.events || (t.events = {}));
        var u = Qc({ value: n.trim(), dynamic: s }, a);
        r !== Kr && (u.modifiers = r);
        var l = c[e];
        Array.isArray(l) ? (o ? l.unshift(u) : l.push(u)) : (c[e] = l ? (o ? [u, l] : [l, u]) : u), (t.plain = !1);
    }
    function Xc(t, e, n) {
        var r = Jc(t, ":" + e) || Jc(t, "v-bind:" + e);
        if (null != r) return qc(r);
        if (!1 !== n) {
            var o = Jc(t, e);
            if (null != o) return JSON.stringify(o);
        }
    }
    function Jc(t, e, n) {
        var r;
        if (null != (r = t.attrsMap[e]))
            for (var o = t.attrsList, i = 0, a = o.length; i < a; i++)
                if (o[i].name === e) {
                    o.splice(i, 1);
                    break;
                }
        return n && delete t.attrsMap[e], r;
    }
    function Zc(t, e) {
        for (var n = t.attrsList, r = 0, o = n.length; r < o; r++) {
            var i = n[r];
            if (e.test(i.name)) return n.splice(r, 1), i;
        }
    }
    function Qc(t, e) {
        return e && (null != e.start && (t.start = e.start), null != e.end && (t.end = e.end)), t;
    }
    function tu(t, e, n) {
        var r = n || {},
            o = r.number,
            i = "$$v";
        r.trim && (i = "(typeof $$v === 'string'? $$v.trim(): $$v)"), o && (i = "_n(".concat(i, ")"));
        var a = eu(e, i);
        t.model = { value: "(".concat(e, ")"), expression: JSON.stringify(e), callback: "function ($$v) {".concat(a, "}") };
    }
    function eu(t, e) {
        var n = (function (t) {
            if (((t = t.trim()), (Cc = t.length), t.indexOf("[") < 0 || t.lastIndexOf("]") < Cc - 1)) return (Mc = t.lastIndexOf(".")) > -1 ? { exp: t.slice(0, Mc), key: '"' + t.slice(Mc + 1) + '"' } : { exp: t, key: null };
            for (Lc = t, Mc = Ic = Rc = 0; !ru(); ) ou(($c = nu())) ? au($c) : 91 === $c && iu($c);
            return { exp: t.slice(0, Ic), key: t.slice(Ic + 1, Rc) };
        })(t);
        return null === n.key ? "".concat(t, "=").concat(e) : "$set(".concat(n.exp, ", ").concat(n.key, ", ").concat(e, ")");
    }
    function nu() {
        return Lc.charCodeAt(++Mc);
    }
    function ru() {
        return Mc >= Cc;
    }
    function ou(t) {
        return 34 === t || 39 === t;
    }
    function iu(t) {
        var e = 1;
        for (Ic = Mc; !ru(); )
            if (ou((t = nu()))) au(t);
            else if ((91 === t && e++, 93 === t && e--, 0 === e)) {
                Rc = Mc;
                break;
            }
    }
    function au(t) {
        for (var e = t; !ru() && (t = nu()) !== e; );
    }
    function su(t, e, n) {
        var r = Dc;
        return function o() {
            var i = e.apply(null, arguments);
            null !== i && lu(t, o, n, r);
        };
    }
    var cu = Ua && !(zo && Number(zo[1]) <= 53);
    function uu(t, e, n, r) {
        if (cu) {
            var o = Ca,
                i = e;
            e = i._wrapper = function (t) {
                if (t.target === t.currentTarget || t.timeStamp >= o || t.timeStamp <= 0 || t.target.ownerDocument !== document) return i.apply(this, arguments);
            };
        }
        Dc.addEventListener(t, e, Go ? { capture: n, passive: r } : n);
    }
    function lu(t, e, n, r) {
        (r || Dc).removeEventListener(t, e._wrapper || e, n);
    }
    function fu(t, e) {
        if (!Yr(t.data.on) || !Yr(e.data.on)) {
            var n = e.data.on || {},
                r = t.data.on || {};
            (Dc = e.elm || t.elm),
                (function (t) {
                    if (Xr(t.__r)) {
                        var e = Ho ? "change" : "input";
                        (t[e] = [].concat(t.__r, t[e] || [])), delete t.__r;
                    }
                    Xr(t.__c) && ((t.change = [].concat(t.__c, t.change || [])), delete t.__c);
                })(n),
                Li(n, r, uu, lu, su, e.context),
                (Dc = void 0);
        }
    }
    var pu,
        du = {
            create: fu,
            update: fu,
            destroy: function (t) {
                return fu(t, vc);
            },
        };
    function hu(t, e) {
        if (!Yr(t.data.domProps) || !Yr(e.data.domProps)) {
            var n,
                r,
                o = e.elm,
                i = t.data.domProps || {},
                a = e.data.domProps || {};
            for (n in ((Xr(a.__ob__) || Jr(a._v_attr_proxy)) && (a = e.data.domProps = So({}, a)), i)) n in a || (o[n] = "");
            for (n in a) {
                if (((r = a[n]), "textContent" === n || "innerHTML" === n)) {
                    if ((e.children && (e.children.length = 0), r === i[n])) continue;
                    1 === o.childNodes.length && o.removeChild(o.childNodes[0]);
                }
                if ("value" === n && "PROGRESS" !== o.tagName) {
                    o._value = r;
                    var s = Yr(r) ? "" : String(r);
                    vu(o, s) && (o.value = s);
                } else if ("innerHTML" === n && ic(o.tagName) && Yr(o.innerHTML)) {
                    (pu = pu || document.createElement("div")).innerHTML = "<svg>".concat(r, "</svg>");
                    for (var c = pu.firstChild; o.firstChild; ) o.removeChild(o.firstChild);
                    for (; c.firstChild; ) o.appendChild(c.firstChild);
                } else if (r !== i[n])
                    try {
                        o[n] = r;
                    } catch (t) {}
            }
        }
    }
    function vu(t, e) {
        return (
            !t.composing &&
            ("OPTION" === t.tagName ||
                (function (t, e) {
                    var n = !0;
                    try {
                        n = document.activeElement !== t;
                    } catch (t) {}
                    return n && t.value !== e;
                })(t, e) ||
                (function (t, e) {
                    var n = t.value,
                        r = t._vModifiers;
                    if (Xr(r)) {
                        if (r.number) return ao(n) !== ao(e);
                        if (r.trim) return n.trim() !== e.trim();
                    }
                    return n !== e;
                })(t, e))
        );
    }
    var yu = { create: hu, update: hu },
        mu = ho(function (t) {
            var e = {},
                n = /:(.+)/;
            return (
                t.split(/;(?![^(]*\))/g).forEach(function (t) {
                    if (t) {
                        var r = t.split(n);
                        r.length > 1 && (e[r[0].trim()] = r[1].trim());
                    }
                }),
                e
            );
        });
    function bu(t) {
        var e = gu(t.style);
        return t.staticStyle ? So(t.staticStyle, e) : e;
    }
    function gu(t) {
        return Array.isArray(t) ? Ao(t) : "string" == typeof t ? mu(t) : t;
    }
    var wu,
        _u = /^--/,
        Su = /\s*!important$/,
        Au = function (t, e, n) {
            if (_u.test(e)) t.style.setProperty(e, n);
            else if (Su.test(n)) t.style.setProperty(go(e), n.replace(Su, ""), "important");
            else {
                var r = xu(e);
                if (Array.isArray(n)) for (var o = 0, i = n.length; o < i; o++) t.style[r] = n[o];
                else t.style[r] = n;
            }
        },
        Ou = ["Webkit", "Moz", "ms"],
        xu = ho(function (t) {
            if (((wu = wu || document.createElement("div").style), "filter" !== (t = yo(t)) && t in wu)) return t;
            for (var e = t.charAt(0).toUpperCase() + t.slice(1), n = 0; n < Ou.length; n++) {
                var r = Ou[n] + e;
                if (r in wu) return r;
            }
        });
    function Eu(t, e) {
        var n = e.data,
            r = t.data;
        if (!(Yr(n.staticStyle) && Yr(n.style) && Yr(r.staticStyle) && Yr(r.style))) {
            var o,
                i,
                a = e.elm,
                s = r.staticStyle,
                c = r.normalizedStyle || r.style || {},
                u = s || c,
                l = gu(e.data.style) || {};
            e.data.normalizedStyle = Xr(l.__ob__) ? So({}, l) : l;
            var f = (function (t, e) {
                for (var n, r = {}, o = t; o.componentInstance; ) (o = o.componentInstance._vnode) && o.data && (n = bu(o.data)) && So(r, n);
                (n = bu(t.data)) && So(r, n);
                for (var i = t; (i = i.parent); ) i.data && (n = bu(i.data)) && So(r, n);
                return r;
            })(e);
            for (i in u) Yr(f[i]) && Au(a, i, "");
            for (i in f) (o = f[i]) !== u[i] && Au(a, i, null == o ? "" : o);
        }
    }
    var Pu = { create: Eu, update: Eu },
        Tu = /\s+/;
    function ku(t, e) {
        if (e && (e = e.trim()))
            if (t.classList)
                e.indexOf(" ") > -1
                    ? e.split(Tu).forEach(function (e) {
                          return t.classList.add(e);
                      })
                    : t.classList.add(e);
            else {
                var n = " ".concat(t.getAttribute("class") || "", " ");
                n.indexOf(" " + e + " ") < 0 && t.setAttribute("class", (n + e).trim());
            }
    }
    function ju(t, e) {
        if (e && (e = e.trim()))
            if (t.classList)
                e.indexOf(" ") > -1
                    ? e.split(Tu).forEach(function (e) {
                          return t.classList.remove(e);
                      })
                    : t.classList.remove(e),
                    t.classList.length || t.removeAttribute("class");
            else {
                for (var n = " ".concat(t.getAttribute("class") || "", " "), r = " " + e + " "; n.indexOf(r) >= 0; ) n = n.replace(r, " ");
                (n = n.trim()) ? t.setAttribute("class", n) : t.removeAttribute("class");
            }
    }
    function Cu(t) {
        if (t) {
            if ("object" == zr(t)) {
                var e = {};
                return !1 !== t.css && So(e, Lu(t.name || "v")), So(e, t), e;
            }
            return "string" == typeof t ? Lu(t) : void 0;
        }
    }
    var Lu = ho(function (t) {
            return {
                enterClass: "".concat(t, "-enter"),
                enterToClass: "".concat(t, "-enter-to"),
                enterActiveClass: "".concat(t, "-enter-active"),
                leaveClass: "".concat(t, "-leave"),
                leaveToClass: "".concat(t, "-leave-to"),
                leaveActiveClass: "".concat(t, "-leave-active"),
            };
        }),
        $u = Fo && !Bo,
        Mu = "transition",
        Iu = "transitionend",
        Ru = "animation",
        Du = "animationend";
    $u &&
        (void 0 === window.ontransitionend && void 0 !== window.onwebkittransitionend && ((Mu = "WebkitTransition"), (Iu = "webkitTransitionEnd")),
        void 0 === window.onanimationend && void 0 !== window.onwebkitanimationend && ((Ru = "WebkitAnimation"), (Du = "webkitAnimationEnd")));
    var Nu = Fo
        ? window.requestAnimationFrame
            ? window.requestAnimationFrame.bind(window)
            : setTimeout
        : function (t) {
              return t();
          };
    function Fu(t) {
        Nu(function () {
            Nu(t);
        });
    }
    function qu(t, e) {
        var n = t._transitionClasses || (t._transitionClasses = []);
        n.indexOf(e) < 0 && (n.push(e), ku(t, e));
    }
    function Hu(t, e) {
        t._transitionClasses && lo(t._transitionClasses, e), ju(t, e);
    }
    function Bu(t, e, n) {
        var r = Wu(t, e),
            o = r.type,
            i = r.timeout,
            a = r.propCount;
        if (!o) return n();
        var s = "transition" === o ? Iu : Du,
            c = 0,
            u = function () {
                t.removeEventListener(s, l), n();
            },
            l = function (e) {
                e.target === t && ++c >= a && u();
            };
        setTimeout(function () {
            c < a && u();
        }, i + 1),
            t.addEventListener(s, l);
    }
    var Uu = /\b(transform|all)(,|$)/;
    function Wu(t, e) {
        var n,
            r = window.getComputedStyle(t),
            o = (r[Mu + "Delay"] || "").split(", "),
            i = (r[Mu + "Duration"] || "").split(", "),
            a = Vu(o, i),
            s = (r[Ru + "Delay"] || "").split(", "),
            c = (r[Ru + "Duration"] || "").split(", "),
            u = Vu(s, c),
            l = 0,
            f = 0;
        return (
            "transition" === e
                ? a > 0 && ((n = "transition"), (l = a), (f = i.length))
                : "animation" === e
                ? u > 0 && ((n = "animation"), (l = u), (f = c.length))
                : (f = (n = (l = Math.max(a, u)) > 0 ? (a > u ? "transition" : "animation") : null) ? ("transition" === n ? i.length : c.length) : 0),
            { type: n, timeout: l, propCount: f, hasTransform: "transition" === n && Uu.test(r[Mu + "Property"]) }
        );
    }
    function Vu(t, e) {
        for (; t.length < e.length; ) t = t.concat(t);
        return Math.max.apply(
            null,
            e.map(function (e, n) {
                return zu(e) + zu(t[n]);
            })
        );
    }
    function zu(t) {
        return 1e3 * Number(t.slice(0, -1).replace(",", "."));
    }
    function Ku(t, e) {
        var n = t.elm;
        Xr(n._leaveCb) && ((n._leaveCb.cancelled = !0), n._leaveCb());
        var r = Cu(t.data.transition);
        if (!Yr(r) && !Xr(n._enterCb) && 1 === n.nodeType) {
            for (
                var o = r.css,
                    i = r.type,
                    a = r.enterClass,
                    s = r.enterToClass,
                    c = r.enterActiveClass,
                    u = r.appearClass,
                    l = r.appearToClass,
                    f = r.appearActiveClass,
                    p = r.beforeEnter,
                    d = r.enter,
                    h = r.afterEnter,
                    v = r.enterCancelled,
                    y = r.beforeAppear,
                    m = r.appear,
                    b = r.afterAppear,
                    g = r.appearCancelled,
                    w = r.duration,
                    _ = ga,
                    S = ga.$vnode;
                S && S.parent;

            )
                (_ = S.context), (S = S.parent);
            var A = !_._isMounted || !t.isRootInsert;
            if (!A || m || "" === m) {
                var O = A && u ? u : a,
                    x = A && f ? f : c,
                    E = A && l ? l : s,
                    P = (A && y) || p,
                    T = A && Qr(m) ? m : d,
                    k = (A && b) || h,
                    j = (A && g) || v,
                    C = ao(to(w) ? w.enter : w),
                    L = !1 !== o && !Bo,
                    $ = Xu(T),
                    M = (n._enterCb = ko(function () {
                        L && (Hu(n, E), Hu(n, x)), M.cancelled ? (L && Hu(n, O), j && j(n)) : k && k(n), (n._enterCb = null);
                    }));
                t.data.show ||
                    $i(t, "insert", function () {
                        var e = n.parentNode,
                            r = e && e._pending && e._pending[t.key];
                        r && r.tag === t.tag && r.elm._leaveCb && r.elm._leaveCb(), T && T(n, M);
                    }),
                    P && P(n),
                    L &&
                        (qu(n, O),
                        qu(n, x),
                        Fu(function () {
                            Hu(n, O), M.cancelled || (qu(n, E), $ || (Yu(C) ? setTimeout(M, C) : Bu(n, i, M)));
                        })),
                    t.data.show && (e && e(), T && T(n, M)),
                    L || $ || M();
            }
        }
    }
    function Gu(t, e) {
        var n = t.elm;
        Xr(n._enterCb) && ((n._enterCb.cancelled = !0), n._enterCb());
        var r = Cu(t.data.transition);
        if (Yr(r) || 1 !== n.nodeType) return e();
        if (!Xr(n._leaveCb)) {
            var o = r.css,
                i = r.type,
                a = r.leaveClass,
                s = r.leaveToClass,
                c = r.leaveActiveClass,
                u = r.beforeLeave,
                l = r.leave,
                f = r.afterLeave,
                p = r.leaveCancelled,
                d = r.delayLeave,
                h = r.duration,
                v = !1 !== o && !Bo,
                y = Xu(l),
                m = ao(to(h) ? h.leave : h),
                b = (n._leaveCb = ko(function () {
                    n.parentNode && n.parentNode._pending && (n.parentNode._pending[t.key] = null), v && (Hu(n, s), Hu(n, c)), b.cancelled ? (v && Hu(n, a), p && p(n)) : (e(), f && f(n)), (n._leaveCb = null);
                }));
            d ? d(g) : g();
        }
        function g() {
            b.cancelled ||
                (!t.data.show && n.parentNode && ((n.parentNode._pending || (n.parentNode._pending = {}))[t.key] = t),
                u && u(n),
                v &&
                    (qu(n, a),
                    qu(n, c),
                    Fu(function () {
                        Hu(n, a), b.cancelled || (qu(n, s), y || (Yu(m) ? setTimeout(b, m) : Bu(n, i, b)));
                    })),
                l && l(n, b),
                v || y || b());
        }
    }
    function Yu(t) {
        return "number" == typeof t && !isNaN(t);
    }
    function Xu(t) {
        if (Yr(t)) return !1;
        var e = t.fns;
        return Xr(e) ? Xu(Array.isArray(e) ? e[0] : e) : (t._length || t.length) > 1;
    }
    function Ju(t, e) {
        !0 !== e.data.show && Ku(e);
    }
    var Zu = (function (t) {
        var e,
            n,
            r = {},
            o = t.modules,
            i = t.nodeOps;
        for (e = 0; e < yc.length; ++e) for (r[yc[e]] = [], n = 0; n < o.length; ++n) Xr(o[n][yc[e]]) && r[yc[e]].push(o[n][yc[e]]);
        function a(t) {
            var e = i.parentNode(t);
            Xr(e) && i.removeChild(e, t);
        }
        function s(t, e, n, o, a, s, f) {
            if (
                (Xr(t.elm) && Xr(s) && (t = s[f] = ai(t)),
                (t.isRootInsert = !a),
                !(function (t, e, n, o) {
                    var i = t.data;
                    if (Xr(i)) {
                        var a = Xr(t.componentInstance) && i.keepAlive;
                        if ((Xr((i = i.hook)) && Xr((i = i.init)) && i(t, !1), Xr(t.componentInstance)))
                            return (
                                c(t, e),
                                u(n, t.elm, o),
                                Jr(a) &&
                                    (function (t, e, n, o) {
                                        for (var i, a = t; a.componentInstance; )
                                            if (Xr((i = (a = a.componentInstance._vnode).data)) && Xr((i = i.transition))) {
                                                for (i = 0; i < r.activate.length; ++i) r.activate[i](vc, a);
                                                e.push(a);
                                                break;
                                            }
                                        u(n, t.elm, o);
                                    })(t, e, n, o),
                                !0
                            );
                    }
                })(t, e, n, o))
            ) {
                var h = t.data,
                    v = t.children,
                    y = t.tag;
                Xr(y)
                    ? ((t.elm = t.ns ? i.createElementNS(t.ns, y) : i.createElement(y, t)), d(t), l(t, v, e), Xr(h) && p(t, e), u(n, t.elm, o))
                    : Jr(t.isComment)
                    ? ((t.elm = i.createComment(t.text)), u(n, t.elm, o))
                    : ((t.elm = i.createTextNode(t.text)), u(n, t.elm, o));
            }
        }
        function c(t, e) {
            Xr(t.data.pendingInsert) && (e.push.apply(e, t.data.pendingInsert), (t.data.pendingInsert = null)), (t.elm = t.componentInstance.$el), f(t) ? (p(t, e), d(t)) : (dc(t), e.push(t));
        }
        function u(t, e, n) {
            Xr(t) && (Xr(n) ? i.parentNode(n) === t && i.insertBefore(t, e, n) : i.appendChild(t, e));
        }
        function l(t, e, n) {
            if (Gr(e)) for (var r = 0; r < e.length; ++r) s(e[r], n, t.elm, null, !0, e, r);
            else Zr(t.text) && i.appendChild(t.elm, i.createTextNode(String(t.text)));
        }
        function f(t) {
            for (; t.componentInstance; ) t = t.componentInstance._vnode;
            return Xr(t.tag);
        }
        function p(t, n) {
            for (var o = 0; o < r.create.length; ++o) r.create[o](vc, t);
            Xr((e = t.data.hook)) && (Xr(e.create) && e.create(vc, t), Xr(e.insert) && n.push(t));
        }
        function d(t) {
            var e;
            if (Xr((e = t.fnScopeId))) i.setStyleScope(t.elm, e);
            else for (var n = t; n; ) Xr((e = n.context)) && Xr((e = e.$options._scopeId)) && i.setStyleScope(t.elm, e), (n = n.parent);
            Xr((e = ga)) && e !== t.context && e !== t.fnContext && Xr((e = e.$options._scopeId)) && i.setStyleScope(t.elm, e);
        }
        function h(t, e, n, r, o, i) {
            for (; r <= o; ++r) s(n[r], i, t, e, !1, n, r);
        }
        function v(t) {
            var e,
                n,
                o = t.data;
            if (Xr(o)) for (Xr((e = o.hook)) && Xr((e = e.destroy)) && e(t), e = 0; e < r.destroy.length; ++e) r.destroy[e](t);
            if (Xr((e = t.children))) for (n = 0; n < t.children.length; ++n) v(t.children[n]);
        }
        function y(t, e, n) {
            for (; e <= n; ++e) {
                var r = t[e];
                Xr(r) && (Xr(r.tag) ? (m(r), v(r)) : a(r.elm));
            }
        }
        function m(t, e) {
            if (Xr(e) || Xr(t.data)) {
                var n,
                    o = r.remove.length + 1;
                for (
                    Xr(e)
                        ? (e.listeners += o)
                        : (e = (function (t, e) {
                              function n() {
                                  0 == --n.listeners && a(t);
                              }
                              return (n.listeners = e), n;
                          })(t.elm, o)),
                        Xr((n = t.componentInstance)) && Xr((n = n._vnode)) && Xr(n.data) && m(n, e),
                        n = 0;
                    n < r.remove.length;
                    ++n
                )
                    r.remove[n](t, e);
                Xr((n = t.data.hook)) && Xr((n = n.remove)) ? n(t, e) : e();
            } else a(t.elm);
        }
        function b(t, e, n, r) {
            for (var o = n; o < r; o++) {
                var i = e[o];
                if (Xr(i) && mc(t, i)) return o;
            }
        }
        function g(t, e, n, o, a, c) {
            if (t !== e) {
                Xr(e.elm) && Xr(o) && (e = o[a] = ai(e));
                var u = (e.elm = t.elm);
                if (Jr(t.isAsyncPlaceholder)) Xr(e.asyncFactory.resolved) ? S(t.elm, e, n) : (e.isAsyncPlaceholder = !0);
                else if (Jr(e.isStatic) && Jr(t.isStatic) && e.key === t.key && (Jr(e.isCloned) || Jr(e.isOnce))) e.componentInstance = t.componentInstance;
                else {
                    var l,
                        p = e.data;
                    Xr(p) && Xr((l = p.hook)) && Xr((l = l.prepatch)) && l(t, e);
                    var d = t.children,
                        v = e.children;
                    if (Xr(p) && f(e)) {
                        for (l = 0; l < r.update.length; ++l) r.update[l](t, e);
                        Xr((l = p.hook)) && Xr((l = l.update)) && l(t, e);
                    }
                    Yr(e.text)
                        ? Xr(d) && Xr(v)
                            ? d !== v &&
                              (function (t, e, n, r, o) {
                                  for (var a, c, u, l = 0, f = 0, p = e.length - 1, d = e[0], v = e[p], m = n.length - 1, w = n[0], _ = n[m], S = !o; l <= p && f <= m; )
                                      Yr(d)
                                          ? (d = e[++l])
                                          : Yr(v)
                                          ? (v = e[--p])
                                          : mc(d, w)
                                          ? (g(d, w, r, n, f), (d = e[++l]), (w = n[++f]))
                                          : mc(v, _)
                                          ? (g(v, _, r, n, m), (v = e[--p]), (_ = n[--m]))
                                          : mc(d, _)
                                          ? (g(d, _, r, n, m), S && i.insertBefore(t, d.elm, i.nextSibling(v.elm)), (d = e[++l]), (_ = n[--m]))
                                          : mc(v, w)
                                          ? (g(v, w, r, n, f), S && i.insertBefore(t, v.elm, d.elm), (v = e[--p]), (w = n[++f]))
                                          : (Yr(a) && (a = bc(e, l, p)),
                                            Yr((c = Xr(w.key) ? a[w.key] : b(w, e, l, p)))
                                                ? s(w, r, t, d.elm, !1, n, f)
                                                : mc((u = e[c]), w)
                                                ? (g(u, w, r, n, f), (e[c] = void 0), S && i.insertBefore(t, u.elm, d.elm))
                                                : s(w, r, t, d.elm, !1, n, f),
                                            (w = n[++f]));
                                  l > p ? h(t, Yr(n[m + 1]) ? null : n[m + 1].elm, n, f, m, r) : f > m && y(e, l, p);
                              })(u, d, v, n, c)
                            : Xr(v)
                            ? (Xr(t.text) && i.setTextContent(u, ""), h(u, null, v, 0, v.length - 1, n))
                            : Xr(d)
                            ? y(d, 0, d.length - 1)
                            : Xr(t.text) && i.setTextContent(u, "")
                        : t.text !== e.text && i.setTextContent(u, e.text),
                        Xr(p) && Xr((l = p.hook)) && Xr((l = l.postpatch)) && l(t, e);
                }
            }
        }
        function w(t, e, n) {
            if (Jr(n) && Xr(t.parent)) t.parent.data.pendingInsert = e;
            else for (var r = 0; r < e.length; ++r) e[r].data.hook.insert(e[r]);
        }
        var _ = so("attrs,class,staticClass,staticStyle,key");
        function S(t, e, n, r) {
            var o,
                i = e.tag,
                a = e.data,
                s = e.children;
            if (((r = r || (a && a.pre)), (e.elm = t), Jr(e.isComment) && Xr(e.asyncFactory))) return (e.isAsyncPlaceholder = !0), !0;
            if (Xr(a) && (Xr((o = a.hook)) && Xr((o = o.init)) && o(e, !0), Xr((o = e.componentInstance)))) return c(e, n), !0;
            if (Xr(i)) {
                if (Xr(s))
                    if (t.hasChildNodes())
                        if (Xr((o = a)) && Xr((o = o.domProps)) && Xr((o = o.innerHTML))) {
                            if (o !== t.innerHTML) return !1;
                        } else {
                            for (var u = !0, f = t.firstChild, d = 0; d < s.length; d++) {
                                if (!f || !S(f, s[d], n, r)) {
                                    u = !1;
                                    break;
                                }
                                f = f.nextSibling;
                            }
                            if (!u || f) return !1;
                        }
                    else l(e, s, n);
                if (Xr(a)) {
                    var h = !1;
                    for (var v in a)
                        if (!_(v)) {
                            (h = !0), p(e, n);
                            break;
                        }
                    !h && a.class && ts(a.class);
                }
            } else t.data !== e.text && (t.data = e.text);
            return !0;
        }
        return function (t, e, n, o) {
            if (!Yr(e)) {
                var a,
                    c = !1,
                    u = [];
                if (Yr(t)) (c = !0), s(e, u);
                else {
                    var l = Xr(t.nodeType);
                    if (!l && mc(t, e)) g(t, e, u, null, null, o);
                    else {
                        if (l) {
                            if ((1 === t.nodeType && t.hasAttribute("data-server-rendered") && (t.removeAttribute("data-server-rendered"), (n = !0)), Jr(n) && S(t, e, u))) return w(e, u, !0), t;
                            (a = t), (t = new ri(i.tagName(a).toLowerCase(), {}, [], void 0, a));
                        }
                        var p = t.elm,
                            d = i.parentNode(p);
                        if ((s(e, u, p._leaveCb ? null : d, i.nextSibling(p)), Xr(e.parent)))
                            for (var h = e.parent, m = f(e); h; ) {
                                for (var b = 0; b < r.destroy.length; ++b) r.destroy[b](h);
                                if (((h.elm = e.elm), m)) {
                                    for (var _ = 0; _ < r.create.length; ++_) r.create[_](vc, h);
                                    var A = h.data.hook.insert;
                                    if (A.merged) for (var O = 1; O < A.fns.length; O++) A.fns[O]();
                                } else dc(h);
                                h = h.parent;
                            }
                        Xr(d) ? y([t], 0, 0) : Xr(t.tag) && v(t);
                    }
                }
                return w(e, u, c), e.elm;
            }
            Xr(t) && v(t);
        };
    })({
        nodeOps: fc,
        modules: [
            kc,
            Nc,
            du,
            yu,
            Pu,
            Fo
                ? {
                      create: Ju,
                      activate: Ju,
                      remove: function (t, e) {
                          !0 !== t.data.show ? Gu(t, e) : e();
                      },
                  }
                : {},
        ].concat(xc),
    });
    Bo &&
        document.addEventListener("selectionchange", function () {
            var t = document.activeElement;
            t && t.vmodel && al(t, "input");
        });
    var Qu = {
        inserted: function (t, e, n, r) {
            "select" === n.tag
                ? (r.elm && !r.elm._vOptions
                      ? $i(n, "postpatch", function () {
                            Qu.componentUpdated(t, e, n);
                        })
                      : tl(t, e, n.context),
                  (t._vOptions = [].map.call(t.options, rl)))
                : ("textarea" === n.tag || uc(t.type)) &&
                  ((t._vModifiers = e.modifiers), e.modifiers.lazy || (t.addEventListener("compositionstart", ol), t.addEventListener("compositionend", il), t.addEventListener("change", il), Bo && (t.vmodel = !0)));
        },
        componentUpdated: function (t, e, n) {
            if ("select" === n.tag) {
                tl(t, e, n.context);
                var r = t._vOptions,
                    o = (t._vOptions = [].map.call(t.options, rl));
                o.some(function (t, e) {
                    return !Po(t, r[e]);
                }) &&
                    (t.multiple
                        ? e.value.some(function (t) {
                              return nl(t, o);
                          })
                        : e.value !== e.oldValue && nl(e.value, o)) &&
                    al(t, "change");
            }
        },
    };
    function tl(t, e, n) {
        el(t, e),
            (Ho || Uo) &&
                setTimeout(function () {
                    el(t, e);
                }, 0);
    }
    function el(t, e, n) {
        var r = e.value,
            o = t.multiple;
        if (!o || Array.isArray(r)) {
            for (var i, a, s = 0, c = t.options.length; s < c; s++)
                if (((a = t.options[s]), o)) (i = To(r, rl(a)) > -1), a.selected !== i && (a.selected = i);
                else if (Po(rl(a), r)) return void (t.selectedIndex !== s && (t.selectedIndex = s));
            o || (t.selectedIndex = -1);
        }
    }
    function nl(t, e) {
        return e.every(function (e) {
            return !Po(e, t);
        });
    }
    function rl(t) {
        return "_value" in t ? t._value : t.value;
    }
    function ol(t) {
        t.target.composing = !0;
    }
    function il(t) {
        t.target.composing && ((t.target.composing = !1), al(t.target, "input"));
    }
    function al(t, e) {
        var n = document.createEvent("HTMLEvents");
        n.initEvent(e, !0, !0), t.dispatchEvent(n);
    }
    function sl(t) {
        return !t.componentInstance || (t.data && t.data.transition) ? t : sl(t.componentInstance._vnode);
    }
    var cl = {
            bind: function (t, e, n) {
                var r = e.value,
                    o = (n = sl(n)).data && n.data.transition,
                    i = (t.__vOriginalDisplay = "none" === t.style.display ? "" : t.style.display);
                r && o
                    ? ((n.data.show = !0),
                      Ku(n, function () {
                          t.style.display = i;
                      }))
                    : (t.style.display = r ? i : "none");
            },
            update: function (t, e, n) {
                var r = e.value;
                !r != !e.oldValue &&
                    ((n = sl(n)).data && n.data.transition
                        ? ((n.data.show = !0),
                          r
                              ? Ku(n, function () {
                                    t.style.display = t.__vOriginalDisplay;
                                })
                              : Gu(n, function () {
                                    t.style.display = "none";
                                }))
                        : (t.style.display = r ? t.__vOriginalDisplay : "none"));
            },
            unbind: function (t, e, n, r, o) {
                o || (t.style.display = t.__vOriginalDisplay);
            },
        },
        ul = { model: Qu, show: cl },
        ll = {
            name: String,
            appear: Boolean,
            css: Boolean,
            mode: String,
            type: String,
            enterClass: String,
            leaveClass: String,
            enterToClass: String,
            leaveToClass: String,
            enterActiveClass: String,
            leaveActiveClass: String,
            appearClass: String,
            appearActiveClass: String,
            appearToClass: String,
            duration: [Number, String, Object],
        };
    function fl(t) {
        var e = t && t.componentOptions;
        return e && e.Ctor.options.abstract ? fl(ha(e.children)) : t;
    }
    function pl(t) {
        var e = {},
            n = t.$options;
        for (var r in n.propsData) e[r] = t[r];
        var o = n._parentListeners;
        for (var i in o) e[yo(i)] = o[i];
        return e;
    }
    function dl(t, e) {
        if (/\d-keep-alive$/.test(e.tag)) return t("keep-alive", { props: e.componentOptions.propsData });
    }
    var hl = function (t) {
            return t.tag || ra(t);
        },
        vl = function (t) {
            return "show" === t.name;
        },
        yl = {
            name: "transition",
            props: ll,
            abstract: !0,
            render: function (t) {
                var e = this,
                    n = this.$slots.default;
                if (n && (n = n.filter(hl)).length) {
                    var r = this.mode,
                        o = n[0];
                    if (
                        (function (t) {
                            for (; (t = t.parent); ) if (t.data.transition) return !0;
                        })(this.$vnode)
                    )
                        return o;
                    var i = fl(o);
                    if (!i) return o;
                    if (this._leaving) return dl(t, o);
                    var a = "__transition-".concat(this._uid, "-");
                    i.key = null == i.key ? (i.isComment ? a + "comment" : a + i.tag) : Zr(i.key) ? (0 === String(i.key).indexOf(a) ? i.key : a + i.key) : i.key;
                    var s = ((i.data || (i.data = {})).transition = pl(this)),
                        c = this._vnode,
                        u = fl(c);
                    if (
                        (i.data.directives && i.data.directives.some(vl) && (i.data.show = !0),
                        u &&
                            u.data &&
                            !(function (t, e) {
                                return e.key === t.key && e.tag === t.tag;
                            })(i, u) &&
                            !ra(u) &&
                            (!u.componentInstance || !u.componentInstance._vnode.isComment))
                    ) {
                        var l = (u.data.transition = So({}, s));
                        if ("out-in" === r)
                            return (
                                (this._leaving = !0),
                                $i(l, "afterLeave", function () {
                                    (e._leaving = !1), e.$forceUpdate();
                                }),
                                dl(t, o)
                            );
                        if ("in-out" === r) {
                            if (ra(i)) return c;
                            var f,
                                p = function () {
                                    f();
                                };
                            $i(s, "afterEnter", p),
                                $i(s, "enterCancelled", p),
                                $i(l, "delayLeave", function (t) {
                                    f = t;
                                });
                        }
                    }
                    return o;
                }
            },
        },
        ml = So({ tag: String, moveClass: String }, ll);
    delete ml.mode;
    var bl = {
        props: ml,
        beforeMount: function () {
            var t = this,
                e = this._update;
            this._update = function (n, r) {
                var o = wa(t);
                t.__patch__(t._vnode, t.kept, !1, !0), (t._vnode = t.kept), o(), e.call(t, n, r);
            };
        },
        render: function (t) {
            for (var e = this.tag || this.$vnode.data.tag || "span", n = Object.create(null), r = (this.prevChildren = this.children), o = this.$slots.default || [], i = (this.children = []), a = pl(this), s = 0; s < o.length; s++) {
                var c = o[s];
                c.tag && null != c.key && 0 !== String(c.key).indexOf("__vlist") && (i.push(c), (n[c.key] = c), ((c.data || (c.data = {})).transition = a));
            }
            if (r) {
                for (var u = [], l = [], f = 0; f < r.length; f++) {
                    var p = r[f];
                    (p.data.transition = a), (p.data.pos = p.elm.getBoundingClientRect()), n[p.key] ? u.push(p) : l.push(p);
                }
                (this.kept = t(e, null, u)), (this.removed = l);
            }
            return t(e, null, i);
        },
        updated: function () {
            var t = this.prevChildren,
                e = this.moveClass || (this.name || "v") + "-move";
            t.length &&
                this.hasMove(t[0].elm, e) &&
                (t.forEach(gl),
                t.forEach(wl),
                t.forEach(_l),
                (this._reflow = document.body.offsetHeight),
                t.forEach(function (t) {
                    if (t.data.moved) {
                        var n = t.elm,
                            r = n.style;
                        qu(n, e),
                            (r.transform = r.WebkitTransform = r.transitionDuration = ""),
                            n.addEventListener(
                                Iu,
                                (n._moveCb = function t(r) {
                                    (r && r.target !== n) || (r && !/transform$/.test(r.propertyName)) || (n.removeEventListener(Iu, t), (n._moveCb = null), Hu(n, e));
                                })
                            );
                    }
                }));
        },
        methods: {
            hasMove: function (t, e) {
                if (!$u) return !1;
                if (this._hasMove) return this._hasMove;
                var n = t.cloneNode();
                t._transitionClasses &&
                    t._transitionClasses.forEach(function (t) {
                        ju(n, t);
                    }),
                    ku(n, e),
                    (n.style.display = "none"),
                    this.$el.appendChild(n);
                var r = Wu(n);
                return this.$el.removeChild(n), (this._hasMove = r.hasTransform);
            },
        },
    };
    function gl(t) {
        t.elm._moveCb && t.elm._moveCb(), t.elm._enterCb && t.elm._enterCb();
    }
    function wl(t) {
        t.data.newPos = t.elm.getBoundingClientRect();
    }
    function _l(t) {
        var e = t.data.pos,
            n = t.data.newPos,
            r = e.left - n.left,
            o = e.top - n.top;
        if (r || o) {
            t.data.moved = !0;
            var i = t.elm.style;
            (i.transform = i.WebkitTransform = "translate(".concat(r, "px,").concat(o, "px)")), (i.transitionDuration = "0s");
        }
    }
    var Sl = { Transition: yl, TransitionGroup: bl };
    (Ds.config.mustUseProp = zs),
        (Ds.config.isReservedTag = ac),
        (Ds.config.isReservedAttr = Ws),
        (Ds.config.getTagNamespace = sc),
        (Ds.config.isUnknownElement = function (t) {
            if (!Fo) return !0;
            if (ac(t)) return !1;
            if (((t = t.toLowerCase()), null != cc[t])) return cc[t];
            var e = document.createElement(t);
            return t.indexOf("-") > -1 ? (cc[t] = e.constructor === window.HTMLUnknownElement || e.constructor === window.HTMLElement) : (cc[t] = /HTMLUnknownElement/.test(e.toString()));
        }),
        So(Ds.options.directives, ul),
        So(Ds.options.components, Sl),
        (Ds.prototype.__patch__ = Fo ? Zu : Oo),
        (Ds.prototype.$mount = function (t, e) {
            return (function (t, e, n) {
                var r;
                (t.$el = e),
                    t.$options.render || (t.$options.render = oi),
                    Oa(t, "beforeMount"),
                    (r = function () {
                        t._update(t._render(), n);
                    }),
                    new rs(
                        t,
                        r,
                        Oo,
                        {
                            before: function () {
                                t._isMounted && !t._isDestroyed && Oa(t, "beforeUpdate");
                            },
                        },
                        !0
                    ),
                    (n = !1);
                var o = t._preWatchers;
                if (o) for (var i = 0; i < o.length; i++) o[i].run();
                return null == t.$vnode && ((t._isMounted = !0), Oa(t, "mounted")), t;
            })(this, (t = t && Fo ? lc(t) : void 0), e);
        }),
        Fo &&
            setTimeout(function () {
                $o.devtools && Jo && Jo.emit("init", Ds);
            }, 0);
    var Al,
        Ol = /\{\{((?:.|\r?\n)+?)\}\}/g,
        xl = /[-.*+?^${}()|[\]\/\\]/g,
        El = ho(function (t) {
            var e = t[0].replace(xl, "\\$&"),
                n = t[1].replace(xl, "\\$&");
            return new RegExp(e + "((?:.|\\n)+?)" + n, "g");
        }),
        Pl = {
            staticKeys: ["staticClass"],
            transformNode: function (t, e) {
                e.warn;
                var n = Jc(t, "class");
                n && (t.staticClass = JSON.stringify(n.replace(/\s+/g, " ").trim()));
                var r = Xc(t, "class", !1);
                r && (t.classBinding = r);
            },
            genData: function (t) {
                var e = "";
                return t.staticClass && (e += "staticClass:".concat(t.staticClass, ",")), t.classBinding && (e += "class:".concat(t.classBinding, ",")), e;
            },
        },
        Tl = {
            staticKeys: ["staticStyle"],
            transformNode: function (t, e) {
                e.warn;
                var n = Jc(t, "style");
                n && (t.staticStyle = JSON.stringify(mu(n)));
                var r = Xc(t, "style", !1);
                r && (t.styleBinding = r);
            },
            genData: function (t) {
                var e = "";
                return t.staticStyle && (e += "staticStyle:".concat(t.staticStyle, ",")), t.styleBinding && (e += "style:(".concat(t.styleBinding, "),")), e;
            },
        },
        kl = so("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),
        jl = so("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),
        Cl = so(
            "address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"
        ),
        Ll = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,
        $l = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,
        Ml = "[a-zA-Z_][\\-\\.0-9_a-zA-Z".concat(Mo.source, "]*"),
        Il = "((?:".concat(Ml, "\\:)?").concat(Ml, ")"),
        Rl = new RegExp("^<".concat(Il)),
        Dl = /^\s*(\/?)>/,
        Nl = new RegExp("^<\\/".concat(Il, "[^>]*>")),
        Fl = /^<!DOCTYPE [^>]+>/i,
        ql = /^<!\--/,
        Hl = /^<!\[/,
        Bl = so("script,style,textarea", !0),
        Ul = {},
        Wl = { "&lt;": "<", "&gt;": ">", "&quot;": '"', "&amp;": "&", "&#10;": "\n", "&#9;": "\t", "&#39;": "'" },
        Vl = /&(?:lt|gt|quot|amp|#39);/g,
        zl = /&(?:lt|gt|quot|amp|#39|#10|#9);/g,
        Kl = so("pre,textarea", !0),
        Gl = function (t, e) {
            return t && Kl(t) && "\n" === e[0];
        };
    function Yl(t, e) {
        var n = e ? zl : Vl;
        return t.replace(n, function (t) {
            return Wl[t];
        });
    }
    var Xl,
        Jl,
        Zl,
        Ql,
        tf,
        ef,
        nf,
        rf,
        of = /^@|^v-on:/,
        af = /^v-|^@|^:|^#/,
        sf = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,
        cf = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
        uf = /^\(|\)$/g,
        lf = /^\[.*\]$/,
        ff = /:(.*)$/,
        pf = /^:|^\.|^v-bind:/,
        df = /\.[^.\]]+(?=[^\]]*$)/g,
        hf = /^v-slot(:|$)|^#/,
        vf = /[\r\n]/,
        yf = /[ \f\t\r\n]+/g,
        mf = ho(function (t) {
            return ((Al = Al || document.createElement("div")).innerHTML = t), Al.textContent;
        });
    function bf(t, e, n) {
        return { type: 1, tag: t, attrsList: e, attrsMap: Of(e), rawAttrsMap: {}, parent: n, children: [] };
    }
    function gf(t, e) {
        var n;
        !(function (t) {
            var e = Xc(t, "key");
            e && (t.key = e);
        })(t),
            (t.plain = !t.key && !t.scopedSlots && !t.attrsList.length),
            (function (t) {
                var e = Xc(t, "ref");
                e &&
                    ((t.ref = e),
                    (t.refInFor = (function (t) {
                        for (var e = t; e; ) {
                            if (void 0 !== e.for) return !0;
                            e = e.parent;
                        }
                        return !1;
                    })(t)));
            })(t),
            (function (t) {
                var e;
                "template" === t.tag ? ((e = Jc(t, "scope")), (t.slotScope = e || Jc(t, "slot-scope"))) : (e = Jc(t, "slot-scope")) && (t.slotScope = e);
                var n = Xc(t, "slot");
                if (
                    (n &&
                        ((t.slotTarget = '""' === n ? '"default"' : n),
                        (t.slotTargetDynamic = !(!t.attrsMap[":slot"] && !t.attrsMap["v-bind:slot"])),
                        "template" === t.tag ||
                            t.slotScope ||
                            Vc(
                                t,
                                "slot",
                                n,
                                (function (t, e) {
                                    return t.rawAttrsMap[":" + e] || t.rawAttrsMap["v-bind:" + e] || t.rawAttrsMap[e];
                                })(t, "slot")
                            )),
                    "template" === t.tag)
                ) {
                    var r = Zc(t, hf);
                    if (r) {
                        var o = Sf(r),
                            i = o.name,
                            a = o.dynamic;
                        (t.slotTarget = i), (t.slotTargetDynamic = a), (t.slotScope = r.value || "_empty_");
                    }
                } else {
                    var s = Zc(t, hf);
                    if (s) {
                        var c = t.scopedSlots || (t.scopedSlots = {}),
                            u = Sf(s),
                            l = u.name,
                            f = u.dynamic,
                            p = (c[l] = bf("template", [], t));
                        (p.slotTarget = l),
                            (p.slotTargetDynamic = f),
                            (p.children = t.children.filter(function (t) {
                                if (!t.slotScope) return (t.parent = p), !0;
                            })),
                            (p.slotScope = s.value || "_empty_"),
                            (t.children = []),
                            (t.plain = !1);
                    }
                }
            })(t),
            "slot" === (n = t).tag && (n.slotName = Xc(n, "name")),
            (function (t) {
                var e;
                (e = Xc(t, "is")) && (t.component = e), null != Jc(t, "inline-template") && (t.inlineTemplate = !0);
            })(t);
        for (var r = 0; r < Zl.length; r++) t = Zl[r](t, e) || t;
        return (
            (function (t) {
                var e,
                    n,
                    r,
                    o,
                    i,
                    a,
                    s,
                    c,
                    u = t.attrsList;
                for (e = 0, n = u.length; e < n; e++)
                    if (((r = o = u[e].name), (i = u[e].value), af.test(r)))
                        if (((t.hasBindings = !0), (a = Af(r.replace(af, ""))) && (r = r.replace(df, "")), pf.test(r)))
                            (r = r.replace(pf, "")),
                                (i = qc(i)),
                                (c = lf.test(r)) && (r = r.slice(1, -1)),
                                a &&
                                    (a.prop && !c && "innerHtml" === (r = yo(r)) && (r = "innerHTML"),
                                    a.camel && !c && (r = yo(r)),
                                    a.sync &&
                                        ((s = eu(i, "$event")),
                                        c ? Yc(t, '"update:"+('.concat(r, ")"), s, null, !1, 0, u[e], !0) : (Yc(t, "update:".concat(yo(r)), s, null, !1, 0, u[e]), go(r) !== yo(r) && Yc(t, "update:".concat(go(r)), s, null, !1, 0, u[e])))),
                                (a && a.prop) || (!t.component && nf(t.tag, t.attrsMap.type, r)) ? Wc(t, r, i, u[e], c) : Vc(t, r, i, u[e], c);
                        else if (of.test(r)) (r = r.replace(of, "")), (c = lf.test(r)) && (r = r.slice(1, -1)), Yc(t, r, i, a, !1, 0, u[e], c);
                        else {
                            var l = (r = r.replace(af, "")).match(ff),
                                f = l && l[1];
                            (c = !1), f && ((r = r.slice(0, -(f.length + 1))), lf.test(f) && ((f = f.slice(1, -1)), (c = !0))), Kc(t, r, o, i, f, c, a, u[e]);
                        }
                    else Vc(t, r, JSON.stringify(i), u[e]), !t.component && "muted" === r && nf(t.tag, t.attrsMap.type, r) && Wc(t, r, "true", u[e]);
            })(t),
            t
        );
    }
    function wf(t) {
        var e;
        if ((e = Jc(t, "v-for"))) {
            var n = (function (t) {
                var e = t.match(sf);
                if (e) {
                    var n = {};
                    n.for = e[2].trim();
                    var r = e[1].trim().replace(uf, ""),
                        o = r.match(cf);
                    return o ? ((n.alias = r.replace(cf, "").trim()), (n.iterator1 = o[1].trim()), o[2] && (n.iterator2 = o[2].trim())) : (n.alias = r), n;
                }
            })(e);
            n && So(t, n);
        }
    }
    function _f(t, e) {
        t.ifConditions || (t.ifConditions = []), t.ifConditions.push(e);
    }
    function Sf(t) {
        var e = t.name.replace(hf, "");
        return e || ("#" !== t.name[0] && (e = "default")), lf.test(e) ? { name: e.slice(1, -1), dynamic: !0 } : { name: '"'.concat(e, '"'), dynamic: !1 };
    }
    function Af(t) {
        var e = t.match(df);
        if (e) {
            var n = {};
            return (
                e.forEach(function (t) {
                    n[t.slice(1)] = !0;
                }),
                n
            );
        }
    }
    function Of(t) {
        for (var e = {}, n = 0, r = t.length; n < r; n++) e[t[n].name] = t[n].value;
        return e;
    }
    var xf = /^xmlns:NS\d+/,
        Ef = /^NS\d+:/;
    function Pf(t) {
        return bf(t.tag, t.attrsList.slice(), t.parent);
    }
    var Tf,
        kf,
        jf = [
            Pl,
            Tl,
            {
                preTransformNode: function (t, e) {
                    if ("input" === t.tag) {
                        var n,
                            r = t.attrsMap;
                        if (!r["v-model"]) return;
                        if (((r[":type"] || r["v-bind:type"]) && (n = Xc(t, "type")), r.type || n || !r["v-bind"] || (n = "(".concat(r["v-bind"], ").type")), n)) {
                            var o = Jc(t, "v-if", !0),
                                i = o ? "&&(".concat(o, ")") : "",
                                a = null != Jc(t, "v-else", !0),
                                s = Jc(t, "v-else-if", !0),
                                c = Pf(t);
                            wf(c), zc(c, "type", "checkbox"), gf(c, e), (c.processed = !0), (c.if = "(".concat(n, ")==='checkbox'") + i), _f(c, { exp: c.if, block: c });
                            var u = Pf(t);
                            Jc(u, "v-for", !0), zc(u, "type", "radio"), gf(u, e), _f(c, { exp: "(".concat(n, ")==='radio'") + i, block: u });
                            var l = Pf(t);
                            return Jc(l, "v-for", !0), zc(l, ":type", n), gf(l, e), _f(c, { exp: o, block: l }), a ? (c.else = !0) : s && (c.elseif = s), c;
                        }
                    }
                },
            },
        ],
        Cf = {
            expectHTML: !0,
            modules: jf,
            directives: {
                model: function (t, e, n) {
                    var r = e.value,
                        o = e.modifiers,
                        i = t.tag,
                        a = t.attrsMap.type;
                    if (t.component) return tu(t, r, o), !1;
                    if ("select" === i)
                        !(function (t, e, n) {
                            var r = n && n.number,
                                o = 'var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '.concat(
                                    r ? "_n(val)" : "val",
                                    "});"
                                );
                            Yc(t, "change", (o = "".concat(o, " ").concat(eu(e, "$event.target.multiple ? $$selectedVal : $$selectedVal[0]"))), null, !0);
                        })(t, r, o);
                    else if ("input" === i && "checkbox" === a)
                        !(function (t, e, n) {
                            var r = n && n.number,
                                o = Xc(t, "value") || "null",
                                i = Xc(t, "true-value") || "true",
                                a = Xc(t, "false-value") || "false";
                            Wc(t, "checked", "Array.isArray(".concat(e, ")?_i(").concat(e, ",").concat(o, ")>-1") + ("true" === i ? ":(".concat(e, ")") : ":_q(".concat(e, ",").concat(i, ")"))),
                                Yc(
                                    t,
                                    "change",
                                    "var $$a="
                                        .concat(e, ",$$el=$event.target,$$c=$$el.checked?(")
                                        .concat(i, "):(")
                                        .concat(a, ");if(Array.isArray($$a)){var $$v=")
                                        .concat(r ? "_n(" + o + ")" : o, ",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&(")
                                        .concat(eu(e, "$$a.concat([$$v])"), ")}else{$$i>-1&&(")
                                        .concat(eu(e, "$$a.slice(0,$$i).concat($$a.slice($$i+1))"), ")}}else{")
                                        .concat(eu(e, "$$c"), "}"),
                                    null,
                                    !0
                                );
                        })(t, r, o);
                    else if ("input" === i && "radio" === a)
                        !(function (t, e, n) {
                            var r = n && n.number,
                                o = Xc(t, "value") || "null";
                            (o = r ? "_n(".concat(o, ")") : o), Wc(t, "checked", "_q(".concat(e, ",").concat(o, ")")), Yc(t, "change", eu(e, o), null, !0);
                        })(t, r, o);
                    else if ("input" === i || "textarea" === i)
                        !(function (t, e, n) {
                            var r = t.attrsMap.type,
                                o = n || {},
                                i = o.lazy,
                                a = o.number,
                                s = o.trim,
                                c = !i && "range" !== r,
                                u = i ? "change" : "range" === r ? "__r" : "input",
                                l = "$event.target.value";
                            s && (l = "$event.target.value.trim()"), a && (l = "_n(".concat(l, ")"));
                            var f = eu(e, l);
                            c && (f = "if($event.target.composing)return;".concat(f)), Wc(t, "value", "(".concat(e, ")")), Yc(t, u, f, null, !0), (s || a) && Yc(t, "blur", "$forceUpdate()");
                        })(t, r, o);
                    else if (!$o.isReservedTag(i)) return tu(t, r, o), !1;
                    return !0;
                },
                text: function (t, e) {
                    e.value && Wc(t, "textContent", "_s(".concat(e.value, ")"), e);
                },
                html: function (t, e) {
                    e.value && Wc(t, "innerHTML", "_s(".concat(e.value, ")"), e);
                },
            },
            isPreTag: function (t) {
                return "pre" === t;
            },
            isUnaryTag: kl,
            mustUseProp: zs,
            canBeLeftOpenTag: jl,
            isReservedTag: ac,
            getTagNamespace: sc,
            staticKeys: (function (t) {
                return t
                    .reduce(function (t, e) {
                        return t.concat(e.staticKeys || []);
                    }, [])
                    .join(",");
            })(jf),
        },
        Lf = ho(function (t) {
            return so("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap" + (t ? "," + t : ""));
        });
    function $f(t, e) {
        t && ((Tf = Lf(e.staticKeys || "")), (kf = e.isReservedTag || xo), Mf(t), If(t, !1));
    }
    function Mf(t) {
        if (
            ((t.static = (function (t) {
                return (
                    2 !== t.type &&
                    (3 === t.type ||
                        !(
                            !t.pre &&
                            (t.hasBindings ||
                                t.if ||
                                t.for ||
                                co(t.tag) ||
                                !kf(t.tag) ||
                                (function (t) {
                                    for (; t.parent; ) {
                                        if ("template" !== (t = t.parent).tag) return !1;
                                        if (t.for) return !0;
                                    }
                                    return !1;
                                })(t) ||
                                !Object.keys(t).every(Tf))
                        ))
                );
            })(t)),
            1 === t.type)
        ) {
            if (!kf(t.tag) && "slot" !== t.tag && null == t.attrsMap["inline-template"]) return;
            for (var e = 0, n = t.children.length; e < n; e++) {
                var r = t.children[e];
                Mf(r), r.static || (t.static = !1);
            }
            if (t.ifConditions)
                for (var o = 1, i = t.ifConditions.length; o < i; o++) {
                    var a = t.ifConditions[o].block;
                    Mf(a), a.static || (t.static = !1);
                }
        }
    }
    function If(t, e) {
        if (1 === t.type) {
            if (((t.static || t.once) && (t.staticInFor = e), t.static && t.children.length && (1 !== t.children.length || 3 !== t.children[0].type))) return void (t.staticRoot = !0);
            if (((t.staticRoot = !1), t.children)) for (var n = 0, r = t.children.length; n < r; n++) If(t.children[n], e || !!t.for);
            if (t.ifConditions) for (var o = 1, i = t.ifConditions.length; o < i; o++) If(t.ifConditions[o].block, e);
        }
    }
    var Rf = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/,
        Df = /\([^)]*?\);*$/,
        Nf = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,
        Ff = { esc: 27, tab: 9, enter: 13, space: 32, up: 38, left: 37, right: 39, down: 40, delete: [8, 46] },
        qf = {
            esc: ["Esc", "Escape"],
            tab: "Tab",
            enter: "Enter",
            space: [" ", "Spacebar"],
            up: ["Up", "ArrowUp"],
            left: ["Left", "ArrowLeft"],
            right: ["Right", "ArrowRight"],
            down: ["Down", "ArrowDown"],
            delete: ["Backspace", "Delete", "Del"],
        },
        Hf = function (t) {
            return "if(".concat(t, ")return null;");
        },
        Bf = {
            stop: "$event.stopPropagation();",
            prevent: "$event.preventDefault();",
            self: Hf("$event.target !== $event.currentTarget"),
            ctrl: Hf("!$event.ctrlKey"),
            shift: Hf("!$event.shiftKey"),
            alt: Hf("!$event.altKey"),
            meta: Hf("!$event.metaKey"),
            left: Hf("'button' in $event && $event.button !== 0"),
            middle: Hf("'button' in $event && $event.button !== 1"),
            right: Hf("'button' in $event && $event.button !== 2"),
        };
    function Uf(t, e) {
        var n = e ? "nativeOn:" : "on:",
            r = "",
            o = "";
        for (var i in t) {
            var a = Wf(t[i]);
            t[i] && t[i].dynamic ? (o += "".concat(i, ",").concat(a, ",")) : (r += '"'.concat(i, '":').concat(a, ","));
        }
        return (r = "{".concat(r.slice(0, -1), "}")), o ? n + "_d(".concat(r, ",[").concat(o.slice(0, -1), "])") : n + r;
    }
    function Wf(t) {
        if (!t) return "function(){}";
        if (Array.isArray(t))
            return "[".concat(
                t
                    .map(function (t) {
                        return Wf(t);
                    })
                    .join(","),
                "]"
            );
        var e = Nf.test(t.value),
            n = Rf.test(t.value),
            r = Nf.test(t.value.replace(Df, ""));
        if (t.modifiers) {
            var o = "",
                i = "",
                a = [];
            for (var s in t.modifiers)
                if (Bf[s]) (i += Bf[s]), Ff[s] && a.push(s);
                else if ("exact" === s) {
                    var c = t.modifiers;
                    i += Hf(
                        ["ctrl", "shift", "alt", "meta"]
                            .filter(function (t) {
                                return !c[t];
                            })
                            .map(function (t) {
                                return "$event.".concat(t, "Key");
                            })
                            .join("||")
                    );
                } else a.push(s);
            return (
                a.length &&
                    (o += (function (t) {
                        return "if(!$event.type.indexOf('key')&&".concat(t.map(Vf).join("&&"), ")return null;");
                    })(a)),
                i && (o += i),
                "function($event){".concat(o).concat(e ? "return ".concat(t.value, ".apply(null, arguments)") : n ? "return (".concat(t.value, ").apply(null, arguments)") : r ? "return ".concat(t.value) : t.value, "}")
            );
        }
        return e || n ? t.value : "function($event){".concat(r ? "return ".concat(t.value) : t.value, "}");
    }
    function Vf(t) {
        var e = parseInt(t, 10);
        if (e) return "$event.keyCode!==".concat(e);
        var n = Ff[t],
            r = qf[t];
        return "_k($event.keyCode,".concat(JSON.stringify(t), ",").concat(JSON.stringify(n), ",$event.key,").concat(JSON.stringify(r), ")");
    }
    var zf = {
            on: function (t, e) {
                t.wrapListeners = function (t) {
                    return "_g(".concat(t, ",").concat(e.value, ")");
                };
            },
            bind: function (t, e) {
                t.wrapData = function (n) {
                    return "_b("
                        .concat(n, ",'")
                        .concat(t.tag, "',")
                        .concat(e.value, ",")
                        .concat(e.modifiers && e.modifiers.prop ? "true" : "false")
                        .concat(e.modifiers && e.modifiers.sync ? ",true" : "", ")");
                };
            },
            cloak: Oo,
        },
        Kf = Vr(function t(e) {
            Ur(this, t), (this.options = e), (this.warn = e.warn || Bc), (this.transforms = Uc(e.modules, "transformCode")), (this.dataGenFns = Uc(e.modules, "genData")), (this.directives = So(So({}, zf), e.directives));
            var n = e.isReservedTag || xo;
            (this.maybeComponent = function (t) {
                return !!t.component || !n(t.tag);
            }),
                (this.onceId = 0),
                (this.staticRenderFns = []),
                (this.pre = !1);
        });
    function Gf(t, e) {
        var n = new Kf(e);
        return { render: "with(this){return ".concat(t ? ("script" === t.tag ? "null" : Yf(t, n)) : '_c("div")', "}"), staticRenderFns: n.staticRenderFns };
    }
    function Yf(t, e) {
        if ((t.parent && (t.pre = t.pre || t.parent.pre), t.staticRoot && !t.staticProcessed)) return Xf(t, e);
        if (t.once && !t.onceProcessed) return Jf(t, e);
        if (t.for && !t.forProcessed) return tp(t, e);
        if (t.if && !t.ifProcessed) return Zf(t, e);
        if ("template" !== t.tag || t.slotTarget || e.pre) {
            if ("slot" === t.tag)
                return (function (t, e) {
                    var n = t.slotName || '"default"',
                        r = op(t, e),
                        o = "_t(".concat(n).concat(r ? ",function(){return ".concat(r, "}") : ""),
                        i =
                            t.attrs || t.dynamicAttrs
                                ? sp(
                                      (t.attrs || []).concat(t.dynamicAttrs || []).map(function (t) {
                                          return { name: yo(t.name), value: t.value, dynamic: t.dynamic };
                                      })
                                  )
                                : null,
                        a = t.attrsMap["v-bind"];
                    return (!i && !a) || r || (o += ",null"), i && (o += ",".concat(i)), a && (o += "".concat(i ? "" : ",null", ",").concat(a)), o + ")";
                })(t, e);
            var n;
            if (t.component)
                n = (function (t, e, n) {
                    var r = e.inlineTemplate ? null : op(e, n, !0);
                    return "_c("
                        .concat(t, ",")
                        .concat(ep(e, n))
                        .concat(r ? ",".concat(r) : "", ")");
                })(t.component, t, e);
            else {
                var r,
                    o,
                    i = e.maybeComponent(t);
                (!t.plain || (t.pre && i)) && (r = ep(t, e));
                var a = e.options.bindings;
                i &&
                    a &&
                    !1 !== a.__isScriptSetup &&
                    (o = (function (t, e) {
                        var n = yo(e),
                            r = mo(n),
                            o = function (o) {
                                return t[e] === o ? e : t[n] === o ? n : t[r] === o ? r : void 0;
                            },
                            i = o("setup-const") || o("setup-reactive-const");
                        return i || o("setup-let") || o("setup-ref") || o("setup-maybe-ref") || void 0;
                    })(a, t.tag)),
                    o || (o = "'".concat(t.tag, "'"));
                var s = t.inlineTemplate ? null : op(t, e, !0);
                n = "_c("
                    .concat(o)
                    .concat(r ? ",".concat(r) : "")
                    .concat(s ? ",".concat(s) : "", ")");
            }
            for (var c = 0; c < e.transforms.length; c++) n = e.transforms[c](t, n);
            return n;
        }
        return op(t, e) || "void 0";
    }
    function Xf(t, e) {
        t.staticProcessed = !0;
        var n = e.pre;
        return t.pre && (e.pre = t.pre), e.staticRenderFns.push("with(this){return ".concat(Yf(t, e), "}")), (e.pre = n), "_m(".concat(e.staticRenderFns.length - 1).concat(t.staticInFor ? ",true" : "", ")");
    }
    function Jf(t, e) {
        if (((t.onceProcessed = !0), t.if && !t.ifProcessed)) return Zf(t, e);
        if (t.staticInFor) {
            for (var n = "", r = t.parent; r; ) {
                if (r.for) {
                    n = r.key;
                    break;
                }
                r = r.parent;
            }
            return n
                ? "_o("
                      .concat(Yf(t, e), ",")
                      .concat(e.onceId++, ",")
                      .concat(n, ")")
                : Yf(t, e);
        }
        return Xf(t, e);
    }
    function Zf(t, e, n, r) {
        return (t.ifProcessed = !0), Qf(t.ifConditions.slice(), e, n, r);
    }
    function Qf(t, e, n, r) {
        if (!t.length) return r || "_e()";
        var o = t.shift();
        return o.exp ? "(".concat(o.exp, ")?").concat(i(o.block), ":").concat(Qf(t, e, n, r)) : "".concat(i(o.block));
        function i(t) {
            return n ? n(t, e) : t.once ? Jf(t, e) : Yf(t, e);
        }
    }
    function tp(t, e, n, r) {
        var o = t.for,
            i = t.alias,
            a = t.iterator1 ? ",".concat(t.iterator1) : "",
            s = t.iterator2 ? ",".concat(t.iterator2) : "";
        return (
            (t.forProcessed = !0),
            ""
                .concat(r || "_l", "((")
                .concat(o, "),function(")
                .concat(i)
                .concat(a)
                .concat(s, "){return ")
                .concat((n || Yf)(t, e), "})")
        );
    }
    function ep(t, e) {
        var n = "{",
            r = (function (t, e) {
                var n = t.directives;
                if (n) {
                    var r,
                        o,
                        i,
                        a,
                        s = "directives:[",
                        c = !1;
                    for (r = 0, o = n.length; r < o; r++) {
                        (i = n[r]), (a = !0);
                        var u = e.directives[i.name];
                        u && (a = !!u(t, i, e.warn)),
                            a &&
                                ((c = !0),
                                (s += '{name:"'
                                    .concat(i.name, '",rawName:"')
                                    .concat(i.rawName, '"')
                                    .concat(i.value ? ",value:(".concat(i.value, "),expression:").concat(JSON.stringify(i.value)) : "")
                                    .concat(i.arg ? ",arg:".concat(i.isDynamicArg ? i.arg : '"'.concat(i.arg, '"')) : "")
                                    .concat(i.modifiers ? ",modifiers:".concat(JSON.stringify(i.modifiers)) : "", "},")));
                    }
                    return c ? s.slice(0, -1) + "]" : void 0;
                }
            })(t, e);
        r && (n += r + ","), t.key && (n += "key:".concat(t.key, ",")), t.ref && (n += "ref:".concat(t.ref, ",")), t.refInFor && (n += "refInFor:true,"), t.pre && (n += "pre:true,"), t.component && (n += 'tag:"'.concat(t.tag, '",'));
        for (var o = 0; o < e.dataGenFns.length; o++) n += e.dataGenFns[o](t);
        if (
            (t.attrs && (n += "attrs:".concat(sp(t.attrs), ",")),
            t.props && (n += "domProps:".concat(sp(t.props), ",")),
            t.events && (n += "".concat(Uf(t.events, !1), ",")),
            t.nativeEvents && (n += "".concat(Uf(t.nativeEvents, !0), ",")),
            t.slotTarget && !t.slotScope && (n += "slot:".concat(t.slotTarget, ",")),
            t.scopedSlots &&
                (n += "".concat(
                    (function (t, e, n) {
                        var r =
                                t.for ||
                                Object.keys(e).some(function (t) {
                                    var n = e[t];
                                    return n.slotTargetDynamic || n.if || n.for || np(n);
                                }),
                            o = !!t.if;
                        if (!r)
                            for (var i = t.parent; i; ) {
                                if ((i.slotScope && "_empty_" !== i.slotScope) || i.for) {
                                    r = !0;
                                    break;
                                }
                                i.if && (o = !0), (i = i.parent);
                            }
                        var a = Object.keys(e)
                            .map(function (t) {
                                return rp(e[t], n);
                            })
                            .join(",");
                        return "scopedSlots:_u(["
                            .concat(a, "]")
                            .concat(r ? ",null,true" : "")
                            .concat(
                                !r && o
                                    ? ",null,false,".concat(
                                          (function (t) {
                                              for (var e = 5381, n = t.length; n; ) e = (33 * e) ^ t.charCodeAt(--n);
                                              return e >>> 0;
                                          })(a)
                                      )
                                    : "",
                                ")"
                            );
                    })(t, t.scopedSlots, e),
                    ","
                )),
            t.model && (n += "model:{value:".concat(t.model.value, ",callback:").concat(t.model.callback, ",expression:").concat(t.model.expression, "},")),
            t.inlineTemplate)
        ) {
            var i = (function (t, e) {
                var n = t.children[0];
                if (n && 1 === n.type) {
                    var r = Gf(n, e.options);
                    return "inlineTemplate:{render:function(){".concat(r.render, "},staticRenderFns:[").concat(
                        r.staticRenderFns
                            .map(function (t) {
                                return "function(){".concat(t, "}");
                            })
                            .join(","),
                        "]}"
                    );
                }
            })(t, e);
            i && (n += "".concat(i, ","));
        }
        return (n = n.replace(/,$/, "") + "}"), t.dynamicAttrs && (n = "_b(".concat(n, ',"').concat(t.tag, '",').concat(sp(t.dynamicAttrs), ")")), t.wrapData && (n = t.wrapData(n)), t.wrapListeners && (n = t.wrapListeners(n)), n;
    }
    function np(t) {
        return 1 === t.type && ("slot" === t.tag || t.children.some(np));
    }
    function rp(t, e) {
        var n = t.attrsMap["slot-scope"];
        if (t.if && !t.ifProcessed && !n) return Zf(t, e, rp, "null");
        if (t.for && !t.forProcessed) return tp(t, e, rp);
        var r = "_empty_" === t.slotScope ? "" : String(t.slotScope),
            o = "function(".concat(r, "){return ").concat("template" === t.tag ? (t.if && n ? "(".concat(t.if, ")?").concat(op(t, e) || "undefined", ":undefined") : op(t, e) || "undefined") : Yf(t, e), "}"),
            i = r ? "" : ",proxy:true";
        return "{key:"
            .concat(t.slotTarget || '"default"', ",fn:")
            .concat(o)
            .concat(i, "}");
    }
    function op(t, e, n, r, o) {
        var i = t.children;
        if (i.length) {
            var a = i[0];
            if (1 === i.length && a.for && "template" !== a.tag && "slot" !== a.tag) {
                var s = n ? (e.maybeComponent(a) ? ",1" : ",0") : "";
                return "".concat((r || Yf)(a, e)).concat(s);
            }
            var c = n
                    ? (function (t, e) {
                          for (var n = 0, r = 0; r < t.length; r++) {
                              var o = t[r];
                              if (1 === o.type) {
                                  if (
                                      ip(o) ||
                                      (o.ifConditions &&
                                          o.ifConditions.some(function (t) {
                                              return ip(t.block);
                                          }))
                                  ) {
                                      n = 2;
                                      break;
                                  }
                                  (e(o) ||
                                      (o.ifConditions &&
                                          o.ifConditions.some(function (t) {
                                              return e(t.block);
                                          }))) &&
                                      (n = 1);
                              }
                          }
                          return n;
                      })(i, e.maybeComponent)
                    : 0,
                u = o || ap;
            return "["
                .concat(
                    i
                        .map(function (t) {
                            return u(t, e);
                        })
                        .join(","),
                    "]"
                )
                .concat(c ? ",".concat(c) : "");
        }
    }
    function ip(t) {
        return void 0 !== t.for || "template" === t.tag || "slot" === t.tag;
    }
    function ap(t, e) {
        return 1 === t.type
            ? Yf(t, e)
            : 3 === t.type && t.isComment
            ? (function (t) {
                  return "_e(".concat(JSON.stringify(t.text), ")");
              })(t)
            : (function (t) {
                  return "_v(".concat(2 === t.type ? t.expression : cp(JSON.stringify(t.text)), ")");
              })(t);
    }
    function sp(t) {
        for (var e = "", n = "", r = 0; r < t.length; r++) {
            var o = t[r],
                i = cp(o.value);
            o.dynamic ? (n += "".concat(o.name, ",").concat(i, ",")) : (e += '"'.concat(o.name, '":').concat(i, ","));
        }
        return (e = "{".concat(e.slice(0, -1), "}")), n ? "_d(".concat(e, ",[").concat(n.slice(0, -1), "])") : e;
    }
    function cp(t) {
        return t.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
    }
    function up(t, e) {
        try {
            return new Function(t);
        } catch (n) {
            return e.push({ err: n, code: t }), Oo;
        }
    }
    function lp(t) {
        var e = Object.create(null);
        return function (n, r, o) {
            (r = So({}, r)).warn, delete r.warn;
            var i = r.delimiters ? String(r.delimiters) + n : n;
            if (e[i]) return e[i];
            var a = t(n, r),
                s = {},
                c = [];
            return (
                (s.render = up(a.render, c)),
                (s.staticRenderFns = a.staticRenderFns.map(function (t) {
                    return up(t, c);
                })),
                (e[i] = s)
            );
        };
    }
    new RegExp(
        "\\b" +
            "do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b") +
            "\\b"
    ),
        new RegExp("\\b" + "delete,typeof,void".split(",").join("\\s*\\([^\\)]*\\)|\\b") + "\\s*\\([^\\)]*\\)");
    var fp,
        pp,
        dp =
            ((fp = function (t, e) {
                var n = (function (t, e) {
                    (Xl = e.warn || Bc),
                        (ef = e.isPreTag || xo),
                        (nf = e.mustUseProp || xo),
                        (rf = e.getTagNamespace || xo),
                        e.isReservedTag,
                        (Zl = Uc(e.modules, "transformNode")),
                        (Ql = Uc(e.modules, "preTransformNode")),
                        (tf = Uc(e.modules, "postTransformNode")),
                        (Jl = e.delimiters);
                    var n,
                        r,
                        o = [],
                        i = !1 !== e.preserveWhitespace,
                        a = e.whitespace,
                        s = !1,
                        c = !1;
                    function u(t) {
                        if ((l(t), s || t.processed || (t = gf(t, e)), o.length || t === n || (n.if && (t.elseif || t.else) && _f(n, { exp: t.elseif, block: t })), r && !t.forbidden))
                            if (t.elseif || t.else)
                                !(function (t, e) {
                                    var n = (function (t) {
                                        for (var e = t.length; e--; ) {
                                            if (1 === t[e].type) return t[e];
                                            t.pop();
                                        }
                                    })(e.children);
                                    n && n.if && _f(n, { exp: t.elseif, block: t });
                                })(t, r);
                            else {
                                if (t.slotScope) {
                                    var i = t.slotTarget || '"default"';
                                    (r.scopedSlots || (r.scopedSlots = {}))[i] = t;
                                }
                                r.children.push(t), (t.parent = r);
                            }
                        (t.children = t.children.filter(function (t) {
                            return !t.slotScope;
                        })),
                            l(t),
                            t.pre && (s = !1),
                            ef(t.tag) && (c = !1);
                        for (var a = 0; a < tf.length; a++) tf[a](t, e);
                    }
                    function l(t) {
                        if (!c) for (var e; (e = t.children[t.children.length - 1]) && 3 === e.type && " " === e.text; ) t.children.pop();
                    }
                    return (
                        (function (t, e) {
                            for (
                                var n,
                                    r,
                                    o = [],
                                    i = e.expectHTML,
                                    a = e.isUnaryTag || xo,
                                    s = e.canBeLeftOpenTag || xo,
                                    c = 0,
                                    u = function () {
                                        if (((n = t), r && Bl(r))) {
                                            var u = 0,
                                                l = r.toLowerCase(),
                                                d = Ul[l] || (Ul[l] = new RegExp("([\\s\\S]*?)(</" + l + "[^>]*>)", "i")),
                                                h = t.replace(d, function (t, n, r) {
                                                    return (
                                                        (u = r.length),
                                                        Bl(l) || "noscript" === l || (n = n.replace(/<!\--([\s\S]*?)-->/g, "$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g, "$1")),
                                                        Gl(l, n) && (n = n.slice(1)),
                                                        e.chars && e.chars(n),
                                                        ""
                                                    );
                                                });
                                            (c += t.length - h.length), (t = h), p(l, c - u, c);
                                        } else {
                                            var v,
                                                y,
                                                m,
                                                b = t.indexOf("<");
                                            if (0 === b) {
                                                if (ql.test(t)) {
                                                    var g = t.indexOf("--\x3e");
                                                    if (g >= 0) return e.shouldKeepComment && e.comment && e.comment(t.substring(4, g), c, c + g + 3), f(g + 3), "continue";
                                                }
                                                if (Hl.test(t)) {
                                                    var w = t.indexOf("]>");
                                                    if (w >= 0) return f(w + 2), "continue";
                                                }
                                                var _ = t.match(Fl);
                                                if (_) return f(_[0].length), "continue";
                                                var S = t.match(Nl);
                                                if (S) {
                                                    var A = c;
                                                    return f(S[0].length), p(S[1], A, c), "continue";
                                                }
                                                var O = (function () {
                                                    var e = t.match(Rl);
                                                    if (e) {
                                                        var n,
                                                            r,
                                                            o = { tagName: e[1], attrs: [], start: c };
                                                        for (f(e[0].length); !(n = t.match(Dl)) && (r = t.match($l) || t.match(Ll)); ) (r.start = c), f(r[0].length), (r.end = c), o.attrs.push(r);
                                                        if (n) return (o.unarySlash = n[1]), f(n[0].length), (o.end = c), o;
                                                    }
                                                })();
                                                if (O)
                                                    return (
                                                        (function (t) {
                                                            var n = t.tagName,
                                                                c = t.unarySlash;
                                                            i && ("p" === r && Cl(n) && p(r), s(n) && r === n && p(n));
                                                            for (var u = a(n) || !!c, l = t.attrs.length, f = new Array(l), d = 0; d < l; d++) {
                                                                var h = t.attrs[d],
                                                                    v = h[3] || h[4] || h[5] || "",
                                                                    y = "a" === n && "href" === h[1] ? e.shouldDecodeNewlinesForHref : e.shouldDecodeNewlines;
                                                                f[d] = { name: h[1], value: Yl(v, y) };
                                                            }
                                                            u || (o.push({ tag: n, lowerCasedTag: n.toLowerCase(), attrs: f, start: t.start, end: t.end }), (r = n)), e.start && e.start(n, f, u, t.start, t.end);
                                                        })(O),
                                                        Gl(O.tagName, t) && f(1),
                                                        "continue"
                                                    );
                                            }
                                            if (b >= 0) {
                                                for (y = t.slice(b); !(Nl.test(y) || Rl.test(y) || ql.test(y) || Hl.test(y) || ((m = y.indexOf("<", 1)), m < 0)); ) (b += m), (y = t.slice(b));
                                                v = t.substring(0, b);
                                            }
                                            b < 0 && (v = t), v && f(v.length), e.chars && v && e.chars(v, c - v.length, c);
                                        }
                                        if (t === n) return e.chars && e.chars(t), "break";
                                    };
                                t;

                            ) {
                                var l = u();
                                if ("continue" !== l && "break" === l) break;
                            }
                            function f(e) {
                                (c += e), (t = t.substring(e));
                            }
                            function p(t, n, i) {
                                var a, s;
                                if ((null == n && (n = c), null == i && (i = c), t)) for (s = t.toLowerCase(), a = o.length - 1; a >= 0 && o[a].lowerCasedTag !== s; a--);
                                else a = 0;
                                if (a >= 0) {
                                    for (var u = o.length - 1; u >= a; u--) e.end && e.end(o[u].tag, n, i);
                                    (o.length = a), (r = a && o[a - 1].tag);
                                } else "br" === s ? e.start && e.start(t, [], !0, n, i) : "p" === s && (e.start && e.start(t, [], !1, n, i), e.end && e.end(t, n, i));
                            }
                            p();
                        })(t, {
                            warn: Xl,
                            expectHTML: e.expectHTML,
                            isUnaryTag: e.isUnaryTag,
                            canBeLeftOpenTag: e.canBeLeftOpenTag,
                            shouldDecodeNewlines: e.shouldDecodeNewlines,
                            shouldDecodeNewlinesForHref: e.shouldDecodeNewlinesForHref,
                            shouldKeepComment: e.comments,
                            outputSourceRange: e.outputSourceRange,
                            start: function (t, i, a, l, f) {
                                var p = (r && r.ns) || rf(t);
                                Ho &&
                                    "svg" === p &&
                                    (i = (function (t) {
                                        for (var e = [], n = 0; n < t.length; n++) {
                                            var r = t[n];
                                            xf.test(r.name) || ((r.name = r.name.replace(Ef, "")), e.push(r));
                                        }
                                        return e;
                                    })(i));
                                var d,
                                    h = bf(t, i, r);
                                p && (h.ns = p), ("style" !== (d = h).tag && ("script" !== d.tag || (d.attrsMap.type && "text/javascript" !== d.attrsMap.type))) || Xo() || (h.forbidden = !0);
                                for (var v = 0; v < Ql.length; v++) h = Ql[v](h, e) || h;
                                s ||
                                    ((function (t) {
                                        null != Jc(t, "v-pre") && (t.pre = !0);
                                    })(h),
                                    h.pre && (s = !0)),
                                    ef(h.tag) && (c = !0),
                                    s
                                        ? (function (t) {
                                              var e = t.attrsList,
                                                  n = e.length;
                                              if (n)
                                                  for (var r = (t.attrs = new Array(n)), o = 0; o < n; o++)
                                                      (r[o] = { name: e[o].name, value: JSON.stringify(e[o].value) }), null != e[o].start && ((r[o].start = e[o].start), (r[o].end = e[o].end));
                                              else t.pre || (t.plain = !0);
                                          })(h)
                                        : h.processed ||
                                          (wf(h),
                                          (function (t) {
                                              var e = Jc(t, "v-if");
                                              if (e) (t.if = e), _f(t, { exp: e, block: t });
                                              else {
                                                  null != Jc(t, "v-else") && (t.else = !0);
                                                  var n = Jc(t, "v-else-if");
                                                  n && (t.elseif = n);
                                              }
                                          })(h),
                                          (function (t) {
                                              null != Jc(t, "v-once") && (t.once = !0);
                                          })(h)),
                                    n || (n = h),
                                    a ? u(h) : ((r = h), o.push(h));
                            },
                            end: function (t, e, n) {
                                var i = o[o.length - 1];
                                (o.length -= 1), (r = o[o.length - 1]), u(i);
                            },
                            chars: function (t, e, n) {
                                if (r && (!Ho || "textarea" !== r.tag || r.attrsMap.placeholder !== t)) {
                                    var o,
                                        u,
                                        l,
                                        f = r.children;
                                    (t = c || t.trim() ? ("script" === (o = r).tag || "style" === o.tag ? t : mf(t)) : f.length ? (a ? ("condense" === a && vf.test(t) ? "" : " ") : i ? " " : "") : "") &&
                                        (c || "condense" !== a || (t = t.replace(yf, " ")),
                                        !s &&
                                        " " !== t &&
                                        (u = (function (t, e) {
                                            var n = e ? El(e) : Ol;
                                            if (n.test(t)) {
                                                for (var r, o, i, a = [], s = [], c = (n.lastIndex = 0); (r = n.exec(t)); ) {
                                                    (o = r.index) > c && (s.push((i = t.slice(c, o))), a.push(JSON.stringify(i)));
                                                    var u = qc(r[1].trim());
                                                    a.push("_s(".concat(u, ")")), s.push({ "@binding": u }), (c = o + r[0].length);
                                                }
                                                return c < t.length && (s.push((i = t.slice(c))), a.push(JSON.stringify(i))), { expression: a.join("+"), tokens: s };
                                            }
                                        })(t, Jl))
                                            ? (l = { type: 2, expression: u.expression, tokens: u.tokens, text: t })
                                            : (" " === t && f.length && " " === f[f.length - 1].text) || (l = { type: 3, text: t }),
                                        l && f.push(l));
                                }
                            },
                            comment: function (t, e, n) {
                                if (r) {
                                    var o = { type: 3, text: t, isComment: !0 };
                                    r.children.push(o);
                                }
                            },
                        }),
                        n
                    );
                })(t.trim(), e);
                !1 !== e.optimize && $f(n, e);
                var r = Gf(n, e);
                return { ast: n, render: r.render, staticRenderFns: r.staticRenderFns };
            }),
            function (t) {
                function e(e, n) {
                    var r = Object.create(t),
                        o = [],
                        i = [];
                    if (n)
                        for (var a in (n.modules && (r.modules = (t.modules || []).concat(n.modules)), n.directives && (r.directives = So(Object.create(t.directives || null), n.directives)), n))
                            "modules" !== a && "directives" !== a && (r[a] = n[a]);
                    r.warn = function (t, e, n) {
                        (n ? i : o).push(t);
                    };
                    var s = fp(e.trim(), r);
                    return (s.errors = o), (s.tips = i), s;
                }
                return { compile: e, compileToFunctions: lp(e) };
            }),
        hp = dp(Cf),
        vp = (hp.compile, hp.compileToFunctions);
    function yp(t) {
        return ((pp = pp || document.createElement("div")).innerHTML = t ? '<a href="\n"/>' : '<div a="\n"/>'), pp.innerHTML.indexOf("&#10;") > 0;
    }
    var mp = !!Fo && yp(!1),
        bp = !!Fo && yp(!0),
        gp = ho(function (t) {
            var e = lc(t);
            return e && e.innerHTML;
        }),
        wp = Ds.prototype.$mount;
    function _p(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
        return r;
    }
    (Ds.prototype.$mount = function (t, e) {
        if ((t = t && lc(t)) === document.body || t === document.documentElement) return this;
        var n = this.$options;
        if (!n.render) {
            var r = n.template;
            if (r)
                if ("string" == typeof r) "#" === r.charAt(0) && (r = gp(r));
                else {
                    if (!r.nodeType) return this;
                    r = r.innerHTML;
                }
            else
                t &&
                    (r = (function (t) {
                        if (t.outerHTML) return t.outerHTML;
                        var e = document.createElement("div");
                        return e.appendChild(t.cloneNode(!0)), e.innerHTML;
                    })(t));
            if (r) {
                var o = vp(r, { outputSourceRange: !1, shouldDecodeNewlines: mp, shouldDecodeNewlinesForHref: bp, delimiters: n.delimiters, comments: n.comments }, this),
                    i = o.render,
                    a = o.staticRenderFns;
                (n.render = i), (n.staticRenderFns = a);
            }
        }
        return wp.call(this, t, e);
    }),
        (Ds.compile = vp),
        Ds.use(Br);
    const Sp = function () {
        document.querySelector(".blog-listing") &&
            ((Ds.config.devtools = !0),
            new Ds({
                el: ".blog-listing",
                data: function () {
                    return { all_related_products: [], posts: [], page: 1, perPage: 9, order: "date_desc", blogType: "", filterByProduct: null };
                },
                mounted: function () {
                    (this.posts = window.blogs), (this.all_related_products = window.all_related_products), (this.$el.style.opacity = 1);
                },
                filters: {
                    unslug: function (t) {
                        if (t) return ucwords(t.replaceAll("-", " "));
                    },
                    stripTags: function (t) {
                        return t.replace(/(<([^>]+)>)/gi, "");
                    },
                    truncateText: function (t) {
                        return t.substring(0, 150) + "...";
                    },
                    getFirstItemInList: function (t) {
                        return t.split(",")[0];
                    },
                },
                computed: {
                    maxPages: function () {
                        return Math.ceil(this.filteredPosts.length / this.perPage);
                    },
                    sortedPosts: function () {
                        var t = this;
                        return this.posts.sort(function (e, n) {
                            var r = new Date(e.published_at),
                                o = new Date(n.published_at);
                            return r.getTime() == o.getTime() ? 0 : "date_desc" == t.order ? (r.getTime() > o.getTime() ? -1 : 1) : r.getTime() < o.getTime() ? -1 : 1;
                        });
                    },
                    filteredPosts: function () {
                        var t = this;
                        return this.sortedPosts.filter(function (e) {
                            var n = !0;
                            return (
                                "" !== t.blogType && (n = -1 !== e.url.indexOf(t.blogType)),
                                t.filterByProduct &&
                                    (n =
                                        e.related_products &&
                                        e.related_products.filter(function (e) {
                                            return e.id === t.filterByProduct;
                                        }).length),
                                n
                            );
                        });
                    },
                    paginatedPosts: function () {
                        var t = this.page * this.perPage - 1;
                        return this.filteredPosts.filter(function (e, n) {
                            return n >= 0 && n <= t;
                        });
                    },
                    categories: function () {
                        var t,
                            e = [];
                        return (
                            this.posts.forEach(function (t) {
                                var n;
                                null != t &&
                                    null !== (n = t.news_meta) &&
                                    void 0 !== n &&
                                    n.primary_category &&
                                    -1 == e.indexOf(t.news_meta.primary_category) &&
                                    t.news_meta.primary_category.split(", ").forEach(function (t) {
                                        return e.push(t);
                                    });
                            }),
                            (function (t) {
                                if (Array.isArray(t)) return _p(t);
                            })((t = new Set(e))) ||
                                (function (t) {
                                    if (("undefined" != typeof Symbol && null != t[Symbol.iterator]) || null != t["@@iterator"]) return Array.from(t);
                                })(t) ||
                                (function (t, e) {
                                    if (t) {
                                        if ("string" == typeof t) return _p(t, e);
                                        var n = Object.prototype.toString.call(t).slice(8, -1);
                                        return (
                                            "Object" === n && t.constructor && (n = t.constructor.name),
                                            "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _p(t, e) : void 0
                                        );
                                    }
                                })(t) ||
                                (function () {
                                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                })()
                        );
                    },
                },
                methods: {
                    setPage: function (t) {
                        this.page = parseInt(t);
                    },
                },
            }));
    };
    document.addEventListener("DOMContentLoaded", function () {
        var t;
        customElements.define("animate-on-scroll", P),
            customElements.define("image-compare", b),
            customElements.define("ada-modal", D),
            customElements.define("ada-slider", K),
            customElements.define("ada-slide", nt),
            customElements.define("ada-slider-page", ft),
            customElements.define("ada-slider-prev", wt),
            customElements.define("ada-slider-next", kt),
            customElements.define("ada-slider-pause", Nt),
            customElements.define("ada-slider-pagination-text", Kt),
            customElements.define("ada-toggler", re),
            customElements.define("countdown-timer", ye),
            customElements.define("countdown-timer-days", me),
            customElements.define("countdown-timer-hours", be),
            customElements.define("countdown-timer-minutes", ge),
            customElements.define("countdown-timer-seconds", we),
            customElements.define("force-aspect-ratio", ke),
            customElements.define("count-on-scroll", Fe),
            customElements.define("ada-video", Ge),
            customElements.define("para-lax", rn),
            customElements.define("scroll-progress", dn),
            customElements.define("sticky-div", Sn),
            customElements.define("focus-trap", $n),
            customElements.define("move-element", Wn),
            customElements.define("inline-pagination", or),
            customElements.define("inline-pagination-prev", ir),
            customElements.define("inline-pagination-next", ar),
            customElements.define("inline-pagination-page", sr),
            customElements.define("svg-clip-path", mr),
            customElements.define("o-slider", _r),
            customElements.define("o-slider-next", Sr, { extends: "button" }),
            customElements.define("o-slider-prev", Ar, { extends: "button" }),
            customElements.define("o-slider-page", Or, { extends: "button" }),
            customElements.define("o-slider-autoplay-controls", xr),
            customElements.define("o-slider-pagination-text", Er),
            Cr(),
            new Ir(".main-menu", {
                menuTogglerContainer: "",
                menuDisplayWhenOpen: "block",
                slideDuration: 450,
                subMenuDisplayWhenOpen: "block",
                // menuToggler: ".mobile-menu-button",
                menuToggler: "",
                menuFillsScreenHeightOnToggle: !0,
                menuFillAccountsForHeaderHeight: !0,
                mobileSwitch: 768,
                setHiddenWhenMobileMenuIsToggled: [".skip-to-main", "main", ".main-footer"],
                mobileSubMenusAutomaticallyClose: !1,
                megamenuClass: "",
            }),
            /*new Ir(".secondary-menu", {
                menuTogglerContainer: "",
                menuDisplayWhenOpen: "block",
                slideDuration: 450,
                subMenuDisplayWhenOpen: "block",
                menuFillsScreenHeightOnToggle: !0,
                menuFillAccountsForHeaderHeight: !0,
                mobileSwitch: 768,
                mobileSubMenusAutomaticallyClose: !1,
                megamenuClass: "",
            }),*/
            (t = document.querySelectorAll(".add-to-cart")) &&
                t.forEach(function (t) {
                    return qr(t);
                }),
            (function () {
                if (document.querySelector(".shopify-currency-form select")) {
                    var t = function (t) {
                        t.target.form.submit();
                    };
                    document.querySelectorAll(".shopify-currency-form select").forEach(function (e) {
                        e.addEventListener("change", t);
                    });
                }
            })(),
            Sp(),
            document.querySelector(".quantity-selector") &&
                document.querySelectorAll(".quantity-selector").forEach(function (t) {
                    var e = t.querySelector(".quantity-selector--less"),
                        n = t.querySelector(".quantity-selector--more"),
                        r = t.querySelector(".quantity-selector--input");
                    e.addEventListener("click", function (t) {
                        t.preventDefault(), parseInt(r.value) > 1 && r.value--;
                    }),
                        n.addEventListener("click", function (t) {
                            t.preventDefault(), parseInt(r.value) && r.value++;
                        });
                }),
            document.querySelector("ada-modal iframe, ada-modal video") &&
                document.querySelectorAll("ada-modal").forEach(function (t) {
                    var e = t.querySelector("iframe, video");
                    e &&
                        (t.addEventListener("open", function (t) {
                            "IFRAME" === e.tagName ? e.setAttribute("src", e.getAttribute("data-src")) : "VIDEO" === e.tagName && e.play();
                        }),
                        t.addEventListener("close", function (t) {
                            "IFRAME" === e.tagName ? e.removeAttribute("src") : "VIDEO" === e.tagName && e.pause();
                        }));
                }),
            document.querySelector(".collection-sorting-form") &&
                (function () {
                    document.querySelector(".collection-sorting-form"),
                        document.querySelector(".collection-sorting-form select").addEventListener("change", function () {
                            var t = this.value,
                                e = window.location.protocol + "//" + window.location.host + t;
                            window.location.replace(e);
                        });
                    var t = window.location.href.split("/"),
                        e = (t = t.slice(3)).join("/"),
                        n = document.querySelector('.collection-sorting-form select[name="sort-by"]');
                    if (n) {
                        var r = n.querySelector('[value="/' + e + '"]');
                        r && (r.selected = !0);
                    }
                })(),
            document.querySelector(".testimonials--slider-container") &&
                Array.from(document.querySelectorAll(".testimonials--slider-container o-slider")).forEach(function (t) {
                    var e = Array.from(t.querySelectorAll("iframe , video"));
                    t.addEventListener("pageUpdated", function () {
                        e.forEach(function (t) {
                            "VIDEO" === t.tagName ? t.pause() : (t.src = t.src);
                        });
                    });
                }),
            document.querySelectorAll("body *:not(script):not(style)").forEach(function (t) {
                t.innerHTML.includes("®") && 0 == t.children.length && "SUP" != t.tagName && (t.innerHTML = t.innerHTML.replaceAll("®", "<sup>®</sup>"));
            }),
            (function () {
                var t = document.querySelector(".scroll-add-to-cart"),
                    e = document.querySelector(".scroll-add-to-cart--closer"),
                    n = !1;
                if (t) {
                    var r = 0.8 * window.innerHeight;
                    window.addEventListener("scroll", function () {
                        var e = window.scrollY;
                        !n && e >= r ? t.classList.add("active") : t.classList.remove("active");
                    }),
                        e.addEventListener("click", function () {
                            t.classList.remove("active"), (n = !0);
                        });
                }
            })();
    });
})();


document.addEventListener('DOMContentLoaded', function(event) {
    
    const $ = document.querySelector.bind(document);
    const $$ = document.querySelectorAll.bind(document);

    // Mobile Menu
    const $mobileMenu = $('.hamburger-button');

    $mobileMenu.addEventListener('click', function() {
        document.body.classList.toggle('mobile-menu-open');
        $mobileMenu.classList.toggle('open');
    });


    // update css variable for mobile header height
    const updateHeaderHeightCSSVariable = function(event) {
        const headerHeight = $('.header-wrapper').clientHeight;
        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    };
    updateHeaderHeightCSSVariable();
    window.addEventListener('resize', updateHeaderHeightCSSVariable);



  
    // Open Klaviyo Popup via #email-signup
    function openKlaviyoPopup() {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'XbZqed']);
    }
    setTimeout(function() {
      if (window.location.hash === '#email-signup') {
        openKlaviyoPopup();
      }
    }, 1500);
  
    window.addEventListener("popstate", function(event) {
      if (window.location.hash === '#email-signup') {
        openKlaviyoPopup();
      }
    });


    // Open Gorgias Popup via #support-chat
    function openGorgiasChat() {
        GorgiasChat.open();
    }
    window.addEventListener("popstate", function(event) {
        if (window.location.hash === '#support-chat') {
            openGorgiasChat();
        }
    });

    // Gorgias custom code
    var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});
    initGorgiasChatPromise.then(async () => {
        
        if (window.location.hash === '#support-chat') {
            openGorgiasChat();
        }
        
        // Remove Gorgias Branding
        // https://docs.gorgias.com/en-US/remove-powered-by-gorgias-branding-286035
        GorgiasChat.hidePoweredBy(true);
        
    })
  
  
    // START - Hide Gorgias & Rewards on mobile homepage until scroll
    if (document.body.classList.contains('index') || document.body.classList.contains('product')) {
        window.addEventListener('scroll', function() {
            if (window.scrollY > 20) {
                document.body.classList.add('is-scrolled');
            } else {
                document.body.classList.remove('is-scrolled');
            }
        });
    }


    // END - Hide Gorgias & Rewards on mobile homepage until scroll
    
    
    
    // PDP - Move product review stars directly under product title
    // const $pdpReviewStars = $('body.product .shopify-app-block > .product-name').parentElement;
    // const $pdpTitle = $('body.product .product-single--headline');
    // $pdpTitle.insertAdjacentElement('afterend', $pdpReviewStars);

    // PDP - Hide strikeout price if same as regular price
    const $variantSelectors = $$('.lt-add-to-cart--button');
    const hideStrikeoutPriceIfCurrentPriceIsSame = function() {
        const $salePrice = $('.add-to-cart--sale-price');
        const $regularPrice = $('.add-to-cart--regular-price');
        if ($salePrice.textContent === $regularPrice.textContent) {
            $regularPrice.innerHTML = '';
        }
    }
    hideStrikeoutPriceIfCurrentPriceIsSame();
    $variantSelectors.forEach(function($variantSelector) {
        $variantSelector.addEventListener('click', hideStrikeoutPriceIfCurrentPriceIsSame);
    });

    // PDP - Switch product image on variant select
    const slideToSelectedVariantImage = function() {
        const variantImageIndex = this.getAttribute('data-variant-image-index');
        const $thumbnail = $('.product-single--thumbnail-slides .thumbnail-button[index="'+ variantImageIndex +'"]');
        if ($thumbnail) {
            $thumbnail.click();
        }
    };
    $variantSelectors.forEach(function($variantSelector) {
        $variantSelector.addEventListener('click', slideToSelectedVariantImage);
    });

    // PDP - highlight subsription label savings
    function replaceWithRoundedPercentage(str) {
        // e.g. "Save 12.63% on your order" outputs: "Save 12% on your order"
        const regex = /(\d+(\.\d+)?%)/;
        return str.replace(regex, (match) => {
            const number = parseFloat(match);
            return `${Math.floor(number)}%`;
        });
    }
    function highlightSubscriptionSavings() {
        document.querySelectorAll('.rc-radio__subscription').forEach(el => {
            el.innerHTML = el.innerHTML.replace('save', '<span class="tag">Save');
            el.innerHTML = el.innerHTML.replace('%', '%</span>');
            el.innerHTML = el.innerHTML.replace('%', '%</span>');
            el.innerHTML = replaceWithRoundedPercentage(el.innerHTML);
        });
    }
    setTimeout(highlightSubscriptionSavings, 1000);
    
    
    
});
